import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { postinity as PO } from "./postinity";
import { postinity2 as PO2 } from "./postinity2";
import { postinity3 as PO3 } from "./postinity3";
import { postinity4 as PO4 } from "./postinity4";
import { postinity5 as PO5 } from "./postinity5";
import { postinity6 as PO6 } from "./postinity6";
import { postinity7 as PO7 } from "./postinity7";
import { postinity8 as PO8 } from "./postinity8";
import { postinity9 as PO9 } from "./postinity9";
import { postinity10 as PO10 } from "./postinity10";
import { cgu as CGU } from "./cgu";
import { cropper as CROP } from "./cropper";
import { toussaint as TSS, toussaintOffer as TSSO, toussaintLanding as TSSL, toussaintCta as TSSC } from "./toussaint";

const fr = {
  "referral": {
    "title": "Convier votre famille & vos amis",
    "subtitle": "Ils allument leur 1re flamme à 1 €, vous recevez 1 mois offert.",
    "entry": "Convier des membres de votre famille & amis — 1 mois offert",
    "how": "Comment ça marche",
    "step1": "Partagez votre lien avec vos proches.",
    "step2": "Ils allument leur première flamme à 1 € seulement.",
    "step3": "Vous recevez 1 mois offert, à utiliser sur la flamme de votre choix.",
    "yourLink": "Votre lien de parrainage",
    "copy": "Copier le lien",
    "copied": "Lien copié !",
    "share": "Partager",
    "invited": "Proches invités",
    "earned": "Mois gagnés",
    "credit": "Mois offerts disponibles",
    "useCredit": "Utiliser mon mois offert",
    "creditBanner_one": "Vous avez {{count}} mois offert — prolongez une flamme gratuitement.",
    "creditBanner_other": "Vous avez {{count}} mois offerts — prolongez une flamme gratuitement.",
    "monthApplied": "Mois offert appliqué ! Flamme prolongée de 30 jours.",
    "shareText": "Allumez une bougie du souvenir sur BougieDuCœur. Votre 1er mois à seulement 1 € avec mon invitation :"
  },
  "blog": {
    "tagline": "Le premier mémorial numérique",
    "intro": "Hommages, récits et mémoriaux — pour ne jamais oublier ceux qui nous ont quittés.",
    "read": "Lire l'hommage",
    "empty": "Aucun article pour le moment.",
    "back": "Blog",
    "notFound": "Article introuvable.",
    "backToBlog": "Retour au blog",
    "ctaText": "Rendez hommage en allumant une bougie du souvenir.",
    "viewFlame": "Voir la flamme"
  },

  "brand": {
    "part1": "Bougie",
    "part2": "DuCœur"
  },
  "header": {
    "myCandles": "Mes bougies",
    "admin": "Admin",
    "notifications": "Notifications",
    "noNotifications": "Aucune notification",
    "viewCandle": "Voir la bougie"
  },
  "nav": {
    "home": "Accueil",
    "myCandles": "Mes bougies",
    "messages": "Messages",
    "profile": "Profil"
  },
  "install": {
    "title": "Installer BougieDuCœur",
    "desc": "Ajoutez l'icône sur votre écran d'accueil pour un accès rapide, comme une application.",
    "button": "Installer l'application",
    "later": "Plus tard",
    "iosStep1": "Dans Safari, appuyez sur le bouton Partager (carré avec une flèche ↑)",
    "iosStep2": "Faites défiler puis choisissez « Sur l'écran d'accueil »",
    "androidStep1": "Ouvrez le menu ⋮ du navigateur",
    "androidStep2": "Puis « Ajouter à l'écran d'accueil »"
  },
  "messages": {
    "title": "Messages reçus",
    "empty": "Aucun message reçu pour le moment.",
    "reactions": "réaction(s)"
  },
  "profile": {
    "title": "Mon profil",
    "name": "Nom",
    "email": "Email",
    "phone": "Portable",
    "country": "Pays",
    "language": "Langue",
    "notifications": "Recevoir les notifications",
    "save": "Enregistrer",
    "saved": "Profil mis à jour",
    "error": "Une erreur est survenue",
    "logout": "Se déconnecter",
    "incompleteNotice": "Votre profil est incomplet. Complétez vos informations.",
    "complete": "Compléter",
    "missingIntro": "À compléter :",
    "password": "Mot de passe",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Confirmer le nouveau mot de passe",
    "changePassword": "Changer le mot de passe",
    "pwdSection": "Mot de passe de connexion",
    "pwdTooShort": "Le mot de passe doit contenir au moins 6 caractères",
    "pwdMismatch": "Les mots de passe ne correspondent pas",
    "pwdChanged": "Mot de passe modifié",
    "pwdHint": "Laissez le champ « mot de passe actuel » vide si vous n'en aviez pas encore."
  },
  "home": {
    "title": "Une flamme pour ne jamais oublier",
    "subtitle": "Allumez une bougie de cœur en mémoire d'un être cher. Partagez un message et invitez vos proches à se recueillir Gratuitement",
    "cta": "Allumer une bougie",
    "ctaSub": "Hommage à un proche",
    "ctaFree": "à se recueillir gratuitement",
    "stats": "Déjà {{candles}} bougies allumées · {{messages}} messages de recueillement"
  },
  "auth": {
    "title": "Rejoignez BougieDuCœur",
    "desc": "Connectez-vous pour allumer et gérer vos bougies.",
    "google": "Continuer avec Google",
    "apple": "Continuer avec Apple",
    "appleSoon": "La connexion Apple arrive bientôt",
    "or": "ou",
    "login": "Connexion",
    "register": "Inscription",
    "email": "Email",
    "password": "Mot de passe",
    "name": "Nom",
    "firstName": "Prénom",
    "lastName": "Nom",
    "signIn": "Se connecter",
    "createAccount": "Créer mon compte",
    "welcome": "Bienvenue",
    "accountCreated": "Compte créé",
    "loginError": "Connexion impossible",
    "registerError": "Inscription impossible",
    "regTitle": "Créer un compte",
    "regSubtitle": "Rejoignez la communauté et rendez hommage à ceux qui vous manquent.",
    "freeBadge": "Inscription 100 % gratuite",
    "phone": "Téléphone portable (optionnel)",
    "termsAccept": "J'ai lu et j'accepte les conditions générales d'utilisation et les mentions légales.",
    "readTerms": "Lire les conditions générales d'utilisation et les mentions légales",
    "enableNotifications": "Activer les notifications",
    "continueWith": "ou continuer avec",
    "alreadyMember": "Déjà inscrit ? Se connecter",
    "mustAcceptTerms": "Vous devez accepter les conditions d'utilisation",
    "noAccount": "Pas encore de compte ?"
  },
  "create": {
    "title": "Allumer une bougie",
    "subtitle": "Un hommage personnalisé, en toute simplicité.",
    "nameLabel": "Nom du défunt",
    "namePlaceholder": "Ex. Marie Dupont",
    "messageLabel": "Message d'hommage",
    "messagePlaceholder": "Quelques mots venus du cœur...",
    "durationLabel": "Hommage à un proche",
    "photoLabel": "Photo (obligatoire)",
    "addPhoto": "Ajouter une photo",
    "birthDate": "Naissance",
    "offerDeadline": "Offre à valider avant le {{date}}",
    "candleFreeUntil": "Bougie allumée gratuitement jusqu'au {{date}}",
    "offerIncentive": "Si vous validez cette offre avant le {{end}}, votre bougie restera allumée gratuitement jusqu'au {{until}}.",
    "datesLater": "Vous pourrez ajouter les dates de naissance et de décès après le paiement.",
    "draftRestored": "Nous avons conservé les informations de votre bougie non finalisée.",
    "deathDate": "Décès",
    "previewEternal": "qui brûlera pour toujours",
    "previewDuration": "durée : {{label}}",
    "payButton": "Allumer pour {{price}}",
    "launchPlan": "Offre venue du Pape à Paris — 1 mois",
    "stripeNote": "Paiement sécurisé via Stripe · Carte de test 4242 4242 4242 4242",
    "candleLit": "Bougie allumée",
    "error": "Une erreur est survenue",
    "photoTooBig": "Photo trop lourde (max 3 Mo)",
    "photoRequired": "Merci d'ajouter une photo",
    "tagline": "Une Flamme & Messages pour l'éternité",
    "previewFlame": "Aperçu de la flamme"
  },
  "memorial": {
    "inMemory": "En mémoire de",
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Min",
    "seconds": "Sec",
    "extinguished": "La flamme s'est éteinte",
    "eternal": "Bougie allumée pour l'éternité",
    "forEternity": "Une bougie pour l'éternité",
    "pendingPayment": "Bougie en attente de paiement",
    "edit": "Modifier",
    "share": "Partager",
    "copyLink": "Copier le lien",
    "findThemOn": "Retrouvez {{name}} sur",
    "socialsTitle": "Réseaux sociaux du défunt (optionnel)",
    "socialsHint": "Ajoutez les liens officiels — ils apparaîtront sur la fiche.",
    "officialSite": "Site officiel",
    "shareInvite": "Allumez une bougie et laissez-lui un message gratuit 🕯️",
    "condolences": "Messages de sympathie",
    "yourName": "Votre nom",
    "supportMessage": "Laissez un message de soutien...",
    "depositFree": "Déposer un message gratuitement",
    "messageDeposited": "Votre message a été déposé",
    "sendError": "Envoi impossible",
    "notFound": "Bougie introuvable",
    "relightCta": "Participer & Prolonger",
    "eternityCta": "Prolonger pour l'éternité",
    "extendMore": "Prolonger Plus",
    "relightTitle": "Prolonger la flamme",
    "relightDesc": "Choisissez une durée pour raviver la bougie de {{name}}.",
    "flameWeak": "La flamme faiblit.",
    "flameExtinguished": "La flamme s'est éteinte.",
    "reviveInvite": "Ravivez-la et prolongez ce moment.",
    "editTitle": "Modifier l'hommage",
    "editDesc": "Mettez à jour le nom, le message et la photo de cette bougie.",
    "photo": "Photo",
    "add": "Ajouter",
    "save": "Enregistrer les modifications",
    "messageUpdated": "Message mis à jour",
    "editError": "Modification impossible",
    "nameRequired": "Le nom est requis",
    "linkCopied": "Lien copié",
    "copiedToClipboard": "Lien copié dans le presse-papier",
    "instagramCopied": "Lien copié — collez-le dans votre story ou votre bio Instagram",
    "firstMessage": "Soyez le premier à déposer un message.",
    "leaveMessage": "Laissez un message",
    "leaveMessageSub": "Gratuit, en quelques secondes",
    "supportCountLabel": "messages de soutien",
    "error": "Erreur"
  },
  "mycandles": {
    "title": "Mes bougies",
    "new": "Nouvelle",
    "active": "Active",
    "extinguished": "Éteinte",
    "eternal": "Éternelle",
    "pending": "En attente de paiement",
    "relights": "ravivage(s)",
    "collected": "récoltés",
    "messagesCount": "Nombre de messages",
    "empty": "Vous n'avez pas encore allumé de bougie.",
    "lightCandle": "Allumer une bougie",
    "pay": "Payer",
    "revive": "Raviver",
    "dialogLightTitle": "Allumer la bougie",
    "dialogRelightTitle": "Prolonger la flamme",
    "chooseDuration": "Choisissez une durée",
    "chooseDurationFor": "Choisissez une durée pour {{name}}.",
    "light": "Allumer",
    "prolong": "Prolonger",
    "updated": "Bougie mise à jour",
    "changePhoto": "Changer la photo",
    "groupShort": "Groupe",
    "newFull": "Nouvelle bougie"
  },
  "family": {
    "title": "Souvenirs de famille",
    "subtitle": "Réunissez les messages et photos de plusieurs bougies en un seul endroit.",
    "button": "Souvenirs de famille",
    "newGroup": "Nouveau groupe",
    "editGroup": "Modifier le groupe",
    "createGroup": "Créer le groupe",
    "groupName": "Nom du groupe",
    "groupNamePlaceholder": "Ex. Mes parents, Famille Martin…",
    "selectCandles": "Choisissez les bougies à regrouper",
    "noCandles": "Vous n'avez pas encore de bougie à regrouper.",
    "empty": "Aucun groupe pour le moment. Créez-en un pour réunir vos souvenirs.",
    "open": "Ouvrir",
    "share": "Partager",
    "edit": "Modifier",
    "delete": "Supprimer",
    "save": "Enregistrer",
    "deleteConfirm": "Supprimer ce groupe ? Les bougies et leurs messages ne sont pas supprimés.",
    "linkCopied": "Lien de partage copié — envoyez-le à votre famille",
    "saved": "Groupe enregistré",
    "deleted": "Groupe supprimé",
    "photos": "Photos",
    "messages": "Messages",
    "noPhotos": "Aucune photo déposée pour l'instant.",
    "noMessages": "Aucun message déposé pour l'instant.",
    "sharedTitle": "Souvenirs partagés",
    "backToGroups": "Retour aux groupes",
    "selectAtLeastOne": "Sélectionnez au moins une bougie",
    "candlesCount_one": "{{count}} bougie",
    "candlesCount_other": "{{count}} bougies",
    "photosCount_one": "{{count}} photo",
    "photosCount_other": "{{count}} photos",
    "messagesCount_one": "{{count}} message",
    "messagesCount_other": "{{count}} messages",
    "for": "pour",
    "inviteTitle": "Vous aussi, honorez leur mémoire",
    "inviteText": "Connectez-vous pour déposer vos propres photos et témoignages sur l'une des bougies ci-dessous.",
    "contributeTitle": "Laissez un message pour la famille",
    "contributeSub": "Votre message et vos photos seront ajoutés à chaque bougie de la famille.",
    "yourName": "Votre nom",
    "yourMessage": "Votre message…",
    "connectForPhotos": "Connectez-vous pour ajouter des photos",
    "photosMax": "10 photos maximum",
    "send": "Publier",
    "moderationNote": "Publié immédiatement sur chaque bougie de la famille.",
    "publishedNotice": "Merci, votre message a été publié 🕯️",
    "familyLabel": "Toute la famille",
    "deletePhoto": "Supprimer la photo",
    "editMessage": "Modifier le message",
    "connected": "Vous êtes connecté(e)",
    "coverPhoto": "Photo de couverture (optionnel)",
    "addCover": "Ajouter une photo",
    "follow": "Suivre ce groupe",
    "following": "Abonné(e)",
    "followed": "Abonné(e) ✓ Vous serez averti(e) des nouveaux souvenirs",
    "unfollowed": "Désabonné(e)",
    "followHint": "Inscrivez-vous pour suivre ce groupe et recevoir une notification à chaque nouveau souvenir.",
    "followedGroups": "Groupes suivis"
  },
  "payment": {
    "confirming": "Confirmation de votre paiement...",
    "flameLit": "La flamme est allumée",
    "redirecting": "Redirection vers le mémorial...",
    "timeout": "Paiement en cours de traitement. Consultez « Mes bougies » dans un instant.",
    "cancelled": "Paiement annulé",
    "noCharge": "Aucun montant n'a été débité.",
    "backToCandles": "Retour à mes bougies"
  },
  "plans": {
    "decouverte": "Découverte",
    "1mois": "1 mois",
    "6mois": "6 mois",
    "1an": "1 an",
    "eternite": "Pour l'éternité"
  },
  "conditions": {
    "back": "Retour à l'inscription",
    "title": "Conditions d'utilisation et Politique de confidentialité",
    "disclaimer": "Version condensée pour intégration dans l'application. Destinée à l'information des utilisateurs. Une validation juridique indépendante est recommandée avant publication.",
    "s1t": "1. Éditeur",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. Acceptation",
    "s2c": "En créant un compte ou en utilisant l'application, vous acceptez les présentes conditions. Si vous refusez ces conditions, vous ne devez pas utiliser le service.",
    "s3t": "3. Service",
    "s3c": "BougieDuCœur permet de créer des hommages numériques, d'allumer des bougies virtuelles, de publier des messages, des photos et d'utiliser les services proposés.",
    "s4t": "4. Compte",
    "s4c": "Vous garantissez l'exactitude des informations fournies et êtes responsable de la confidentialité de vos identifiants.",
    "s5t": "5. Contenus",
    "s5c": "Vous conservez vos droits sur vos contenus mais accordez à BougieDuCœur une licence non exclusive nécessaire à leur hébergement, affichage et diffusion dans le cadre du service.",
    "s6t": "6. Interdictions",
    "s6c": "Sont interdits les contenus illicites, haineux, diffamatoires, frauduleux, violant les droits d'auteur, le droit à l'image, la vie privée ou la mémoire des défunts. Les faux hommages, l'usurpation d'identité et les faux ayants droit sont interdits.",
    "s7t": "7. Modération",
    "s7c": "Tout contenu peut être signalé. BougieDuCœur peut retirer un contenu, suspendre ou supprimer un compte en cas de violation des présentes conditions.",
    "s8t": "8. Familles",
    "s8c": "Les familles et ayants droit peuvent demander la modification ou la suppression d'un mémorial après vérification des justificatifs.",
    "s9t": "9. Données personnelles",
    "s9c": "Vos données (nom, e-mail, téléphone, pays) sont utilisées pour la gestion du compte, des bougies et des notifications. Elles ne sont pas vendues. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression en écrivant à contact@bougieducoeur.com."
  }
};

const en = {
  "referral": {
    "title": "Invite your loved ones",
    "subtitle": "They light their 1st flame for €1, you get 1 free month.",
    "entry": "Referral — 1 free month",
    "how": "How it works",
    "step1": "Share your link with your loved ones.",
    "step2": "They light their first flame for just €1.",
    "step3": "You receive 1 free month, to use on any flame you choose.",
    "yourLink": "Your referral link",
    "copy": "Copy link",
    "copied": "Link copied!",
    "share": "Share",
    "invited": "Invited",
    "earned": "Months earned",
    "credit": "Free months available",
    "useCredit": "Use my free month",
    "creditBanner_one": "You have {{count}} free month — extend a flame for free.",
    "creditBanner_other": "You have {{count}} free months — extend a flame for free.",
    "monthApplied": "Free month applied! Flame extended by 30 days.",
    "shareText": "Light a candle of remembrance on BougieDuCœur. Your 1st month for just €1 with my invitation:"
  },
  "blog": {
    "tagline": "The first digital memorial",
    "intro": "Tributes, stories and memorials — so we never forget those who have left us.",
    "read": "Read the tribute",
    "empty": "No articles yet.",
    "back": "Blog",
    "notFound": "Article not found.",
    "backToBlog": "Back to the blog",
    "ctaText": "Pay tribute by lighting a candle of remembrance.",
    "viewFlame": "See the flame"
  },
  "brand": {
    "part1": "Candle",
    "part2": "OfTheHeart"
  },
  "header": {
    "myCandles": "My candles",
    "admin": "Admin",
    "notifications": "Notifications",
    "noNotifications": "No notifications",
    "viewCandle": "View candle"
  },
  "nav": {
    "home": "Home",
    "myCandles": "My candles",
    "messages": "Messages",
    "profile": "Profile"
  },
  "install": {
    "title": "Install BougieDuCœur",
    "desc": "Add the icon to your home screen for quick access, just like an app.",
    "button": "Install the app",
    "later": "Later",
    "iosStep1": "Tap Share",
    "iosStep2": "Then \"Add to Home Screen\"",
    "androidStep1": "Open the browser menu ⋮",
    "androidStep2": "Then \"Add to Home screen\""
  },
  "messages": {
    "title": "Received messages",
    "empty": "No messages received yet.",
    "reactions": "reaction(s)"
  },
  "profile": {
    "title": "My profile",
    "name": "Name",
    "email": "Email",
    "phone": "Mobile",
    "country": "Country",
    "language": "Language",
    "notifications": "Receive notifications",
    "save": "Save",
    "saved": "Profile updated",
    "error": "An error occurred",
    "logout": "Log out",
    "incompleteNotice": "Your profile is incomplete. Please complete your information.",
    "complete": "Complete",
    "missingIntro": "To complete:",
    "password": "Password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmPassword": "Confirm new password",
    "changePassword": "Change password",
    "pwdSection": "Login password",
    "pwdTooShort": "Password must be at least 6 characters",
    "pwdMismatch": "Passwords do not match",
    "pwdChanged": "Password changed",
    "pwdHint": "Leave the current password field empty if you didn't have one yet."
  },
  "home": {
    "title": "A flame to never forget",
    "subtitle": "Light a candle from the heart in memory of a loved one. Share a message and invite your family to gather for Free.",
    "cta": "Light a candle",
    "ctaSub": "A tribute to a loved one",
    "ctaFree": "gather in remembrance for free",
    "stats": "Already {{candles}} candles lit · {{messages}} messages of remembrance"
  },
  "auth": {
    "title": "Join BougieDuCœur",
    "desc": "Sign in to light and manage your candles.",
    "google": "Continue with Google",
    "apple": "Continue with Apple",
    "appleSoon": "Apple sign-in coming soon",
    "or": "or",
    "login": "Log in",
    "register": "Sign up",
    "email": "Email",
    "password": "Password",
    "name": "Name",
    "firstName": "First name",
    "lastName": "Last name",
    "signIn": "Sign in",
    "createAccount": "Create my account",
    "welcome": "Welcome",
    "accountCreated": "Account created",
    "loginError": "Unable to sign in",
    "registerError": "Unable to sign up",
    "regTitle": "Create an account",
    "regSubtitle": "Join the community and pay tribute to those you miss.",
    "freeBadge": "100% free registration",
    "phone": "Mobile phone (optional)",
    "termsAccept": "I have read and accept the general terms of use and the legal notice.",
    "readTerms": "Read the general terms of use and legal notice",
    "enableNotifications": "Enable notifications",
    "continueWith": "or continue with",
    "alreadyMember": "Already registered? Log in",
    "mustAcceptTerms": "You must accept the terms of use",
    "noAccount": "No account yet?"
  },
  "create": {
    "title": "Light a candle",
    "subtitle": "A personalized tribute, made simple.",
    "nameLabel": "Name of the deceased",
    "namePlaceholder": "e.g. Marie Dupont",
    "messageLabel": "Tribute message",
    "messagePlaceholder": "A few words from the heart...",
    "durationLabel": "A tribute to a loved one",
    "photoLabel": "Photo (required)",
    "addPhoto": "Add a photo",
    "birthDate": "Birth",
    "offerDeadline": "Offer to confirm before {{date}}",
    "candleFreeUntil": "Candle lit free of charge until {{date}}",
    "offerIncentive": "If you confirm this offer before {{end}}, your candle will stay lit free of charge until {{until}}.",
    "datesLater": "You can add the birth and death dates after payment.",
    "draftRestored": "We kept the details of your unfinished candle.",
    "deathDate": "Passing",
    "previewEternal": "that will burn forever",
    "previewDuration": "duration: {{label}}",
    "payButton": "Light for {{price}}",
    "launchPlan": "Offre venue du Pape à Paris — 1 mois",
    "stripeNote": "Secure payment via Stripe · Test card 4242 4242 4242 4242",
    "candleLit": "Candle lit",
    "error": "An error occurred",
    "photoTooBig": "Photo too large (max 3 MB)",
    "photoRequired": "Please add a photo",
    "tagline": "A Flame & Messages for eternity",
    "previewFlame": "Flame preview"
  },
  "memorial": {
    "inMemory": "In memory of",
    "days": "Days",
    "hours": "Hours",
    "minutes": "Min",
    "seconds": "Sec",
    "extinguished": "The flame has gone out",
    "eternal": "Candle lit for eternity",
    "forEternity": "A candle for eternity",
    "pendingPayment": "Candle awaiting payment",
    "edit": "Edit",
    "share": "Share",
    "copyLink": "Copy link",
    "findThemOn": "Find {{name}} on",
    "socialsTitle": "Deceased's social networks (optional)",
    "socialsHint": "Add the official links — they will appear on the memorial.",
    "officialSite": "Official website",
    "shareInvite": "Light a candle and leave a free message 🕯️",
    "condolences": "Messages of sympathy",
    "yourName": "Your name",
    "supportMessage": "Leave a message of support...",
    "depositFree": "Leave a message for free",
    "messageDeposited": "Your message has been posted",
    "sendError": "Unable to send",
    "notFound": "Candle not found",
    "relightCta": "Contribute & Extend",
    "eternityCta": "Extend for eternity",
    "extendMore": "Extend More",
    "relightTitle": "Extend the flame",
    "relightDesc": "Choose a duration to relight {{name}}'s candle.",
    "flameWeak": "The flame is fading.",
    "flameExtinguished": "The flame has gone out.",
    "reviveInvite": "Relight it and extend this moment.",
    "editTitle": "Edit the tribute",
    "editDesc": "Update the name, message and photo of this candle.",
    "photo": "Photo",
    "add": "Add",
    "save": "Save changes",
    "messageUpdated": "Message updated",
    "editError": "Unable to update",
    "nameRequired": "Name is required",
    "linkCopied": "Link copied",
    "copiedToClipboard": "Link copied to clipboard",
    "instagramCopied": "Link copied — paste it in your Instagram story or bio",
    "firstMessage": "Be the first to leave a message.",
    "leaveMessage": "Leave a message",
    "leaveMessageSub": "Free, takes seconds",
    "supportCountLabel": "messages of support",
    "error": "Error"
  },
  "mycandles": {
    "title": "My candles",
    "new": "New",
    "active": "Active",
    "extinguished": "Extinguished",
    "eternal": "Eternal",
    "pending": "Awaiting payment",
    "relights": "relight(s)",
    "collected": "collected",
    "messagesCount": "Number of messages",
    "empty": "You haven't lit a candle yet.",
    "lightCandle": "Light a candle",
    "pay": "Pay",
    "revive": "Relight",
    "dialogLightTitle": "Light the candle",
    "dialogRelightTitle": "Extend the flame",
    "chooseDuration": "Choose a duration",
    "chooseDurationFor": "Choose a duration for {{name}}.",
    "light": "Light",
    "prolong": "Extend",
    "updated": "Candle updated",
    "changePhoto": "Change photo",
    "groupShort": "Group",
    "newFull": "New candle"
  },
  "family": {
    "title": "Family memories",
    "subtitle": "Bring together the messages and photos from several candles in one place.",
    "button": "Family memories",
    "newGroup": "New group",
    "editGroup": "Edit group",
    "createGroup": "Create group",
    "groupName": "Group name",
    "groupNamePlaceholder": "e.g. My parents, The Martin family…",
    "selectCandles": "Choose the candles to group",
    "noCandles": "You don't have any candle to group yet.",
    "empty": "No group yet. Create one to gather your memories.",
    "open": "Open",
    "share": "Share",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "deleteConfirm": "Delete this group? The candles and their messages are not deleted.",
    "linkCopied": "Share link copied — send it to your family",
    "saved": "Group saved",
    "deleted": "Group deleted",
    "photos": "Photos",
    "messages": "Messages",
    "noPhotos": "No photo shared yet.",
    "noMessages": "No message shared yet.",
    "sharedTitle": "Shared memories",
    "backToGroups": "Back to groups",
    "selectAtLeastOne": "Select at least one candle",
    "candlesCount_one": "{{count}} candle",
    "candlesCount_other": "{{count}} candles",
    "photosCount_one": "{{count}} photo",
    "photosCount_other": "{{count}} photos",
    "messagesCount_one": "{{count}} message",
    "messagesCount_other": "{{count}} messages",
    "for": "for",
    "inviteTitle": "Honor their memory too",
    "inviteText": "Sign in to add your own photos and testimonials on one of the candles below.",
    "contributeTitle": "Leave a message for the family",
    "contributeSub": "Your message and photos will be added to every candle in the family.",
    "yourName": "Your name",
    "yourMessage": "Your message…",
    "connectForPhotos": "Sign in to add photos",
    "photosMax": "10 photos maximum",
    "send": "Publish",
    "moderationNote": "Published instantly on every candle of the family.",
    "publishedNotice": "Thank you, your message has been published 🕯️",
    "familyLabel": "The whole family",
    "deletePhoto": "Delete photo",
    "editMessage": "Edit message",
    "connected": "You are signed in",
    "coverPhoto": "Cover photo (optional)",
    "addCover": "Add a photo",
    "follow": "Follow this group",
    "following": "Following",
    "followed": "Following ✓ You'll be notified of new memories",
    "unfollowed": "Unfollowed",
    "followHint": "Sign up to follow this group and get notified with every new memory.",
    "followedGroups": "Followed groups"
  },
  "payment": {
    "confirming": "Confirming your payment...",
    "flameLit": "The flame is lit",
    "redirecting": "Redirecting to the memorial...",
    "timeout": "Payment is being processed. Check “My candles” in a moment.",
    "cancelled": "Payment cancelled",
    "noCharge": "No amount was charged.",
    "backToCandles": "Back to my candles"
  },
  "plans": {
    "decouverte": "Discovery",
    "1mois": "1 month",
    "6mois": "6 months",
    "1an": "1 year",
    "eternite": "For eternity"
  },
  "conditions": {
    "back": "Back to sign-up",
    "title": "Terms of Use and Privacy Policy",
    "disclaimer": "Condensed version for in-app integration. Provided for user information. Independent legal review is recommended before publication.",
    "s1t": "1. Publisher",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. Acceptance",
    "s2c": "By creating an account or using the application, you accept these terms. If you do not accept them, you must not use the service.",
    "s3t": "3. Service",
    "s3c": "BougieDuCœur lets you create digital tributes, light virtual candles, post messages and photos, and use the services offered.",
    "s4t": "4. Account",
    "s4c": "You guarantee the accuracy of the information provided and are responsible for keeping your credentials confidential.",
    "s5t": "5. Content",
    "s5c": "You keep your rights to your content but grant BougieDuCœur a non-exclusive license needed to host, display and distribute it as part of the service.",
    "s6t": "6. Prohibitions",
    "s6c": "Illegal, hateful, defamatory or fraudulent content, and content infringing copyright, image rights, privacy or the memory of the deceased, is prohibited. Fake tributes, identity theft and false rights holders are prohibited.",
    "s7t": "7. Moderation",
    "s7c": "Any content can be reported. BougieDuCœur may remove content, suspend or delete an account in the event of a breach of these terms.",
    "s8t": "8. Families",
    "s8c": "Families and rights holders may request the modification or deletion of a memorial after verification of supporting documents.",
    "s9t": "9. Personal data",
    "s9c": "Your data (name, email, phone, country) is used to manage your account, candles and notifications. It is not sold. Under the GDPR, you have the right to access, correct and delete it by writing to contact@bougieducoeur.com."
  }
};

const es = {
  "brand": {
    "part1": "Vela",
    "part2": "DelCorazón"
  },
  "header": {
    "myCandles": "Mis velas",
    "admin": "Admin",
    "notifications": "Notificaciones",
    "noNotifications": "Sin notificaciones",
    "viewCandle": "Ver la vela"
  },
  "nav": {
    "home": "Inicio",
    "myCandles": "Mis velas",
    "messages": "Mensajes",
    "profile": "Perfil"
  },
  "install": {
    "title": "Instalar BougieDuCœur",
    "desc": "Añade el icono a tu pantalla de inicio para un acceso rápido, como una aplicación.",
    "button": "Instalar la aplicación",
    "later": "Más tarde",
    "iosStep1": "Toca Compartir",
    "iosStep2": "Luego «Añadir a inicio»",
    "androidStep1": "Abre el menú ⋮ del navegador",
    "androidStep2": "Luego «Añadir a pantalla de inicio»"
  },
  "messages": {
    "title": "Mensajes recibidos",
    "empty": "Aún no has recibido ningún mensaje.",
    "reactions": "reacción(es)"
  },
  "profile": {
    "title": "Mi perfil",
    "name": "Nombre",
    "email": "Email",
    "phone": "Móvil",
    "country": "País",
    "language": "Idioma",
    "notifications": "Recibir notificaciones",
    "save": "Guardar",
    "saved": "Perfil actualizado",
    "error": "Ha ocurrido un error",
    "logout": "Cerrar sesión",
    "incompleteNotice": "Tu perfil está incompleto. Completa tu información.",
    "complete": "Completar",
    "missingIntro": "Por completar:",
    "password": "Contraseña",
    "currentPassword": "Contraseña actual",
    "newPassword": "Nueva contraseña",
    "confirmPassword": "Confirmar la nueva contraseña",
    "changePassword": "Cambiar la contraseña",
    "pwdSection": "Contraseña de acceso",
    "pwdTooShort": "La contraseña debe tener al menos 6 caracteres",
    "pwdMismatch": "Las contraseñas no coinciden",
    "pwdChanged": "Contraseña modificada",
    "pwdHint": "Deja vacío el campo «contraseña actual» si aún no tenías una."
  },
  "home": {
    "title": "Una llama para no olvidar jamás",
    "subtitle": "Encienda una vela del corazón en memoria de un ser querido. Comparta un mensaje e invite a sus seres queridos a recogerse.",
    "cta": "Encender una vela",
    "ctaSub": "Un homenaje a un ser querido",
    "ctaFree": "recogerse gratuitamente",
    "stats": "Ya {{candles}} velas encendidas · {{messages}} mensajes de recogimiento"
  },
  "auth": {
    "title": "Únase a BougieDuCœur",
    "desc": "Inicie sesión para encender y gestionar sus velas.",
    "google": "Continuar con Google",
    "apple": "Continuar con Apple",
    "appleSoon": "El inicio de sesión con Apple llegará pronto",
    "or": "o",
    "login": "Iniciar sesión",
    "register": "Registrarse",
    "email": "Correo",
    "password": "Contraseña",
    "name": "Nombre",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "signIn": "Iniciar sesión",
    "createAccount": "Crear mi cuenta",
    "welcome": "Bienvenido",
    "accountCreated": "Cuenta creada",
    "loginError": "No se pudo iniciar sesión",
    "registerError": "No se pudo registrar",
    "regTitle": "Crear una cuenta",
    "regSubtitle": "Únase a la comunidad y rinda homenaje a quienes extraña.",
    "freeBadge": "Registro 100 % gratuito",
    "phone": "Teléfono móvil (opcional)",
    "termsAccept": "He leído y acepto las condiciones generales de uso y el aviso legal.",
    "readTerms": "Leer las condiciones generales de uso y el aviso legal",
    "enableNotifications": "Activar las notificaciones",
    "continueWith": "o continuar con",
    "alreadyMember": "¿Ya registrado? Iniciar sesión",
    "mustAcceptTerms": "Debe aceptar las condiciones de uso",
    "noAccount": "¿Aún no tiene cuenta?"
  },
  "create": {
    "title": "Encender una vela",
    "subtitle": "Un homenaje personalizado, con sencillez.",
    "nameLabel": "Nombre del difunto",
    "namePlaceholder": "Ej. María Pérez",
    "messageLabel": "Mensaje de homenaje",
    "messagePlaceholder": "Unas palabras del corazón...",
    "durationLabel": "Un homenaje a un ser querido",
    "photoLabel": "Foto (obligatoria)",
    "addPhoto": "Añadir",
    "previewEternal": "que arderá para siempre",
    "previewDuration": "duración: {{label}}",
    "payButton": "Encender por {{price}}",
    "stripeNote": "Pago seguro con Stripe · Tarjeta de prueba 4242 4242 4242 4242",
    "candleLit": "Vela encendida",
    "error": "Ha ocurrido un error",
    "photoTooBig": "Foto demasiado grande (máx. 3 MB)",
    "photoRequired": "Añade una foto, por favor",
    "tagline": "Una Llama y Mensajes para la eternidad",
    "previewFlame": "Vista previa de la llama",
    "birthDate": "Nacimiento",
    "offerDeadline": "Oferta a validar antes del {{date}}",
    "candleFreeUntil": "Vela encendida gratis hasta el {{date}}",
    "offerIncentive": "Si validas esta oferta antes del {{end}}, tu vela permanecerá encendida gratis hasta el {{until}}.",
    "datesLater": "Podrás añadir las fechas de nacimiento y fallecimiento después del pago.",
    "draftRestored": "Guardamos los datos de tu vela sin finalizar.",
    "deathDate": "Fallecimiento"
  },
  "memorial": {
    "inMemory": "En memoria de",
    "days": "Días",
    "hours": "Horas",
    "minutes": "Min",
    "seconds": "Seg",
    "extinguished": "La llama se ha apagado",
    "eternal": "Vela encendida para la eternidad",
    "pendingPayment": "Vela pendiente de pago",
    "edit": "Editar",
    "share": "Compartir",
    "copyLink": "Copiar enlace",
    "findThemOn": "Encuentra a {{name}} en",
    "socialsTitle": "Redes sociales del difunto (opcional)",
    "socialsHint": "Añade los enlaces oficiales — aparecerán en la ficha.",
    "officialSite": "Sitio oficial",
    "shareInvite": "Enciende una vela y déjale un mensaje gratis 🕯️",
    "condolences": "Mensajes de simpatía",
    "yourName": "Su nombre",
    "supportMessage": "Deje un mensaje de apoyo...",
    "depositFree": "Dejar un mensaje gratis",
    "messageDeposited": "Su mensaje ha sido publicado",
    "sendError": "No se pudo enviar",
    "notFound": "Vela no encontrada",
    "relightCta": "Participar y Prolongar",
    "eternityCta": "Prolongar por la eternidad",
    "extendMore": "Prolongar Más",
    "relightTitle": "Prolongar la llama",
    "relightDesc": "Elija una duración para reavivar la vela de {{name}}.",
    "flameWeak": "La llama se debilita.",
    "flameExtinguished": "La llama se ha apagado.",
    "reviveInvite": "Reavívela y prolongue este momento.",
    "editTitle": "Editar el homenaje",
    "editDesc": "Actualice el nombre, el mensaje y la foto de esta vela.",
    "photo": "Foto",
    "add": "Añadir",
    "save": "Guardar cambios",
    "messageUpdated": "Mensaje actualizado",
    "editError": "No se pudo modificar",
    "nameRequired": "El nombre es obligatorio",
    "linkCopied": "Enlace copiado",
    "copiedToClipboard": "Enlace copiado al portapapeles",
    "instagramCopied": "Enlace copiado — péguelo en su historia o biografía de Instagram",
    "firstMessage": "Sea el primero en dejar un mensaje.",
    "leaveMessage": "Deje un mensaje",
    "leaveMessageSub": "Gratis, en unos segundos",
    "supportCountLabel": "mensajes de apoyo",
    "error": "Error",
    "forEternity": "Una vela para la eternidad"
  },
  "mycandles": {
    "title": "Mis velas",
    "new": "Nueva",
    "active": "Activa",
    "extinguished": "Apagada",
    "eternal": "Eterna",
    "pending": "Pendiente de pago",
    "relights": "reavivado(s)",
    "collected": "recaudados",
    "empty": "Aún no ha encendido ninguna vela.",
    "lightCandle": "Encender una vela",
    "pay": "Pagar",
    "revive": "Reavivar",
    "dialogLightTitle": "Encender la vela",
    "dialogRelightTitle": "Prolongar la llama",
    "chooseDuration": "Elija una duración",
    "chooseDurationFor": "Elija una duración para {{name}}.",
    "light": "Encender",
    "prolong": "Prolongar",
    "updated": "Vela actualizada",
    "changePhoto": "Cambiar la foto",
    "groupShort": "Grupo",
    "newFull": "Nueva vela",
    "messagesCount": "Número de mensajes"
  },
  "family": {
    "title": "Recuerdos de familia",
    "subtitle": "Reúne los mensajes y fotos de varias velas en un solo lugar.",
    "button": "Recuerdos de familia",
    "newGroup": "Nuevo grupo",
    "editGroup": "Editar grupo",
    "createGroup": "Crear grupo",
    "groupName": "Nombre del grupo",
    "groupNamePlaceholder": "Ej. Mis padres, Familia Martín…",
    "selectCandles": "Elige las velas a agrupar",
    "noCandles": "Aún no tienes ninguna vela para agrupar.",
    "empty": "Aún no hay grupos. Crea uno para reunir tus recuerdos.",
    "open": "Abrir",
    "share": "Compartir",
    "edit": "Editar",
    "delete": "Eliminar",
    "save": "Guardar",
    "deleteConfirm": "¿Eliminar este grupo? Las velas y sus mensajes no se eliminan.",
    "linkCopied": "Enlace copiado — envíalo a tu familia",
    "saved": "Grupo guardado",
    "deleted": "Grupo eliminado",
    "photos": "Fotos",
    "messages": "Mensajes",
    "noPhotos": "Aún no hay fotos.",
    "noMessages": "Aún no hay mensajes.",
    "sharedTitle": "Recuerdos compartidos",
    "backToGroups": "Volver a los grupos",
    "selectAtLeastOne": "Selecciona al menos una vela",
    "candlesCount_one": "{{count}} vela",
    "candlesCount_other": "{{count}} velas",
    "photosCount_one": "{{count}} foto",
    "photosCount_other": "{{count}} fotos",
    "messagesCount_one": "{{count}} mensaje",
    "messagesCount_other": "{{count}} mensajes",
    "for": "para",
    "inviteTitle": "Honra tú también su memoria",
    "inviteText": "Inicia sesión para dejar tus propias fotos y testimonios en una de las velas.",
    "contributeTitle": "Deja un mensaje para la familia",
    "contributeSub": "Tu mensaje y tus fotos se añadirán a cada vela de la familia.",
    "yourName": "Tu nombre",
    "yourMessage": "Tu mensaje…",
    "connectForPhotos": "Inicia sesión para añadir fotos",
    "photosMax": "10 fotos máximo",
    "send": "Publicar",
    "moderationNote": "Publicado al instante en cada vela de la familia.",
    "publishedNotice": "Gracias, tu mensaje se ha publicado 🕯️",
    "familyLabel": "Toda la familia",
    "deletePhoto": "Eliminar la foto",
    "editMessage": "Editar el mensaje",
    "connected": "Has iniciado sesión",
    "coverPhoto": "Foto de portada (opcional)",
    "addCover": "Añadir una foto",
    "follow": "Seguir este grupo",
    "following": "Siguiendo",
    "followed": "Siguiendo ✓ Se te avisará de los nuevos recuerdos",
    "unfollowed": "Dejaste de seguir",
    "followHint": "Regístrate para seguir este grupo y recibir un aviso con cada nuevo recuerdo.",
    "followedGroups": "Grupos seguidos"
  },
  "payment": {
    "confirming": "Confirmando su pago...",
    "flameLit": "La llama está encendida",
    "redirecting": "Redirigiendo al memorial...",
    "timeout": "El pago se está procesando. Consulte “Mis velas” en un momento.",
    "cancelled": "Pago cancelado",
    "noCharge": "No se ha cobrado ningún importe.",
    "backToCandles": "Volver a mis velas"
  },
  "plans": {
    "decouverte": "Descubrimiento",
    "1mois": "1 mes",
    "6mois": "6 meses",
    "1an": "1 año",
    "eternite": "Para la eternidad"
  },
  "conditions": {
    "back": "Volver al registro",
    "title": "Condiciones de uso y Política de privacidad",
    "disclaimer": "Versión condensada para su integración en la aplicación. Destinada a informar a los usuarios. Se recomienda una validación jurídica independiente antes de su publicación.",
    "s1t": "1. Editor",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. Aceptación",
    "s2c": "Al crear una cuenta o utilizar la aplicación, acepta estas condiciones. Si no las acepta, no debe utilizar el servicio.",
    "s3t": "3. Servicio",
    "s3c": "BougieDuCœur permite crear homenajes digitales, encender velas virtuales, publicar mensajes y fotos, y utilizar los servicios ofrecidos.",
    "s4t": "4. Cuenta",
    "s4c": "Usted garantiza la exactitud de la información facilitada y es responsable de la confidencialidad de sus credenciales.",
    "s5t": "5. Contenidos",
    "s5c": "Conserva sus derechos sobre sus contenidos, pero concede a BougieDuCœur una licencia no exclusiva necesaria para alojarlos, mostrarlos y difundirlos en el marco del servicio.",
    "s6t": "6. Prohibiciones",
    "s6c": "Se prohíben los contenidos ilícitos, difamatorios o fraudulentos, y los que infrinjan los derechos de autor, el derecho a la imagen, la privacidad o la memoria de los difuntos. Se prohíben los homenajes falsos, la suplantación de identidad y los falsos derechohabientes.",
    "s7t": "7. Moderación",
    "s7c": "Cualquier contenido puede ser denunciado. BougieDuCœur puede retirar un contenido, suspender o eliminar una cuenta en caso de incumplimiento de estas condiciones.",
    "s8t": "8. Familias",
    "s8c": "Las familias y derechohabientes pueden solicitar la modificación o eliminación de un memorial tras la verificación de los justificantes.",
    "s9t": "9. Datos personales",
    "s9c": "Sus datos (nombre, correo, teléfono, país) se utilizan para gestionar la cuenta, las velas y las notificaciones. No se venden. Conforme al RGPD, tiene derecho de acceso, rectificación y supresión escribiendo a contact@bougieducoeur.com."
  }
};

const de = {
  "brand": {
    "part1": "Kerze",
    "part2": "DesHerzens"
  },
  "header": {
    "myCandles": "Meine Kerzen",
    "admin": "Admin",
    "notifications": "Benachrichtigungen",
    "noNotifications": "Keine Benachrichtigungen",
    "viewCandle": "Kerze ansehen"
  },
  "nav": {
    "home": "Startseite",
    "myCandles": "Meine Kerzen",
    "messages": "Nachrichten",
    "profile": "Profil"
  },
  "install": {
    "title": "BougieDuCœur installieren",
    "desc": "Fügen Sie das Symbol zu Ihrem Startbildschirm hinzu, für schnellen Zugriff wie eine App.",
    "button": "App installieren",
    "later": "Später",
    "iosStep1": "Tippen Sie auf Teilen",
    "iosStep2": "Dann „Zum Home-Bildschirm\"",
    "androidStep1": "Öffnen Sie das Browser-Menü ⋮",
    "androidStep2": "Dann „Zum Startbildschirm hinzufügen\""
  },
  "messages": {
    "title": "Erhaltene Nachrichten",
    "empty": "Noch keine Nachrichten erhalten.",
    "reactions": "Reaktion(en)"
  },
  "profile": {
    "title": "Mein Profil",
    "name": "Name",
    "email": "E-Mail",
    "phone": "Handy",
    "country": "Land",
    "language": "Sprache",
    "notifications": "Benachrichtigungen erhalten",
    "save": "Speichern",
    "saved": "Profil aktualisiert",
    "error": "Ein Fehler ist aufgetreten",
    "logout": "Abmelden",
    "incompleteNotice": "Ihr Profil ist unvollständig. Bitte vervollständigen Sie Ihre Angaben.",
    "complete": "Vervollständigen",
    "missingIntro": "Zu ergänzen:",
    "password": "Passwort",
    "currentPassword": "Aktuelles Passwort",
    "newPassword": "Neues Passwort",
    "confirmPassword": "Neues Passwort bestätigen",
    "changePassword": "Passwort ändern",
    "pwdSection": "Anmeldepasswort",
    "pwdTooShort": "Das Passwort muss mindestens 6 Zeichen lang sein",
    "pwdMismatch": "Die Passwörter stimmen nicht überein",
    "pwdChanged": "Passwort geändert",
    "pwdHint": "Lassen Sie das Feld „Aktuelles Passwort“ leer, wenn Sie noch keines hatten."
  },
  "home": {
    "title": "Eine Flamme, um nie zu vergessen",
    "subtitle": "Zünden Sie eine Herzenskerze im Gedenken an einen geliebten Menschen an. Teilen Sie eine Botschaft und laden Sie Ihre Angehörigen kostenlos zum Gedenken ein.",
    "cta": "Eine Kerze anzünden",
    "ctaSub": "Eine Hommage an einen geliebten Menschen",
    "ctaFree": "kostenlos innehalten",
    "stats": "Bereits {{candles}} Kerzen angezündet · {{messages}} Gedenknachrichten"
  },
  "auth": {
    "title": "BougieDuCœur beitreten",
    "desc": "Melden Sie sich an, um Ihre Kerzen anzuzünden und zu verwalten.",
    "google": "Mit Google fortfahren",
    "apple": "Mit Apple fortfahren",
    "appleSoon": "Apple-Anmeldung folgt bald",
    "or": "oder",
    "login": "Anmelden",
    "register": "Registrieren",
    "email": "E-Mail",
    "password": "Passwort",
    "name": "Name",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "signIn": "Anmelden",
    "createAccount": "Konto erstellen",
    "welcome": "Willkommen",
    "accountCreated": "Konto erstellt",
    "loginError": "Anmeldung fehlgeschlagen",
    "registerError": "Registrierung fehlgeschlagen",
    "regTitle": "Konto erstellen",
    "regSubtitle": "Treten Sie der Gemeinschaft bei und ehren Sie die, die Ihnen fehlen.",
    "freeBadge": "100 % kostenlose Anmeldung",
    "phone": "Mobiltelefon (optional)",
    "termsAccept": "Ich habe die Allgemeinen Nutzungsbedingungen und das Impressum gelesen und akzeptiere sie.",
    "readTerms": "Allgemeine Nutzungsbedingungen und Impressum lesen",
    "enableNotifications": "Benachrichtigungen aktivieren",
    "continueWith": "oder fortfahren mit",
    "alreadyMember": "Bereits registriert? Anmelden",
    "mustAcceptTerms": "Sie müssen die Nutzungsbedingungen akzeptieren",
    "noAccount": "Noch kein Konto?"
  },
  "create": {
    "title": "Eine Kerze anzünden",
    "subtitle": "Eine persönliche Hommage, ganz einfach.",
    "nameLabel": "Name des Verstorbenen",
    "namePlaceholder": "z. B. Marie Dupont",
    "messageLabel": "Gedenkbotschaft",
    "messagePlaceholder": "Ein paar Worte von Herzen...",
    "durationLabel": "Ein Andenken an einen geliebten Menschen",
    "photoLabel": "Foto (erforderlich)",
    "addPhoto": "Foto hinzufügen",
    "birthDate": "Geburt",
    "offerDeadline": "Angebot bis zum {{date}} bestätigen",
    "candleFreeUntil": "Kerze kostenlos entzündet bis zum {{date}}",
    "offerIncentive": "Wenn Sie dieses Angebot vor dem {{end}} bestätigen, bleibt Ihre Kerze bis zum {{until}} kostenlos entzündet.",
    "datesLater": "Geburts- und Sterbedatum können Sie nach der Zahlung hinzufügen.",
    "draftRestored": "Wir haben die Angaben Ihrer nicht abgeschlossenen Kerze gespeichert.",
    "deathDate": "Tod",
    "previewEternal": "die für immer brennt",
    "previewDuration": "Dauer: {{label}}",
    "payButton": "Anzünden für {{price}}",
    "stripeNote": "Sichere Zahlung über Stripe · Testkarte 4242 4242 4242 4242",
    "candleLit": "Kerze angezündet",
    "error": "Ein Fehler ist aufgetreten",
    "photoTooBig": "Foto zu groß (max. 3 MB)",
    "photoRequired": "Bitte füge ein Foto hinzu",
    "tagline": "Eine Flamme & Botschaften für die Ewigkeit",
    "previewFlame": "Vorschau der Flamme"
  },
  "memorial": {
    "inMemory": "Im Gedenken an",
    "days": "Tage",
    "hours": "Std.",
    "minutes": "Min.",
    "seconds": "Sek.",
    "extinguished": "Die Flamme ist erloschen",
    "eternal": "Kerze für die Ewigkeit angezündet",
    "pendingPayment": "Kerze wartet auf Zahlung",
    "edit": "Bearbeiten",
    "share": "Teilen",
    "copyLink": "Link kopieren",
    "findThemOn": "Finde {{name}} auf",
    "socialsTitle": "Soziale Netzwerke des Verstorbenen (optional)",
    "socialsHint": "Füge die offiziellen Links hinzu — sie erscheinen auf der Gedenkseite.",
    "officialSite": "Offizielle Website",
    "shareInvite": "Zünde eine Kerze an und hinterlasse eine kostenlose Nachricht 🕯️",
    "condolences": "Nachrichten der Anteilnahme",
    "yourName": "Ihr Name",
    "supportMessage": "Hinterlassen Sie eine unterstützende Nachricht...",
    "depositFree": "Kostenlos eine Nachricht hinterlassen",
    "messageDeposited": "Ihre Nachricht wurde veröffentlicht",
    "sendError": "Senden nicht möglich",
    "notFound": "Kerze nicht gefunden",
    "relightCta": "Teilnehmen & Verlängern",
    "eternityCta": "Für die Ewigkeit verlängern",
    "extendMore": "Mehr verlängern",
    "relightTitle": "Die Flamme verlängern",
    "relightDesc": "Wählen Sie eine Dauer, um die Kerze von {{name}} neu zu entzünden.",
    "flameWeak": "Die Flamme wird schwächer.",
    "flameExtinguished": "Die Flamme ist erloschen.",
    "reviveInvite": "Entzünden Sie sie neu und verlängern Sie diesen Moment.",
    "editTitle": "Hommage bearbeiten",
    "editDesc": "Aktualisieren Sie Name, Nachricht und Foto dieser Kerze.",
    "photo": "Foto",
    "add": "Hinzufügen",
    "save": "Änderungen speichern",
    "messageUpdated": "Nachricht aktualisiert",
    "editError": "Änderung nicht möglich",
    "nameRequired": "Name ist erforderlich",
    "linkCopied": "Link kopiert",
    "copiedToClipboard": "Link in die Zwischenablage kopiert",
    "instagramCopied": "Link kopiert — fügen Sie ihn in Ihre Instagram-Story oder Bio ein",
    "firstMessage": "Seien Sie der Erste, der eine Nachricht hinterlässt.",
    "leaveMessage": "Hinterlassen Sie eine Nachricht",
    "leaveMessageSub": "Kostenlos, in Sekunden",
    "supportCountLabel": "Unterstützungsnachrichten",
    "error": "Fehler",
    "forEternity": "Eine Kerze für die Ewigkeit"
  },
  "mycandles": {
    "title": "Meine Kerzen",
    "new": "Neu",
    "active": "Aktiv",
    "extinguished": "Erloschen",
    "eternal": "Ewig",
    "pending": "Zahlung ausstehend",
    "relights": "Neuentzündung(en)",
    "collected": "gesammelt",
    "empty": "Sie haben noch keine Kerze angezündet.",
    "lightCandle": "Eine Kerze anzünden",
    "pay": "Bezahlen",
    "revive": "Neu entzünden",
    "dialogLightTitle": "Die Kerze anzünden",
    "dialogRelightTitle": "Die Flamme verlängern",
    "chooseDuration": "Wählen Sie eine Dauer",
    "chooseDurationFor": "Wählen Sie eine Dauer für {{name}}.",
    "light": "Anzünden",
    "prolong": "Verlängern",
    "updated": "Kerze aktualisiert",
    "changePhoto": "Foto ändern",
    "groupShort": "Gruppe",
    "newFull": "Neue Kerze",
    "messagesCount": "Anzahl der Nachrichten"
  },
  "family": {
    "title": "Familienerinnerungen",
    "subtitle": "Fassen Sie die Nachrichten und Fotos mehrerer Kerzen an einem Ort zusammen.",
    "button": "Familienerinnerungen",
    "newGroup": "Neue Gruppe",
    "editGroup": "Gruppe bearbeiten",
    "createGroup": "Gruppe erstellen",
    "groupName": "Gruppenname",
    "groupNamePlaceholder": "z. B. Meine Eltern, Familie Müller…",
    "selectCandles": "Wählen Sie die Kerzen zum Gruppieren",
    "noCandles": "Sie haben noch keine Kerze zum Gruppieren.",
    "empty": "Noch keine Gruppe. Erstellen Sie eine, um Ihre Erinnerungen zu sammeln.",
    "open": "Öffnen",
    "share": "Teilen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "save": "Speichern",
    "deleteConfirm": "Diese Gruppe löschen? Die Kerzen und ihre Nachrichten werden nicht gelöscht.",
    "linkCopied": "Freigabelink kopiert — senden Sie ihn an Ihre Familie",
    "saved": "Gruppe gespeichert",
    "deleted": "Gruppe gelöscht",
    "photos": "Fotos",
    "messages": "Nachrichten",
    "noPhotos": "Noch keine Fotos.",
    "noMessages": "Noch keine Nachrichten.",
    "sharedTitle": "Geteilte Erinnerungen",
    "backToGroups": "Zurück zu den Gruppen",
    "selectAtLeastOne": "Wählen Sie mindestens eine Kerze",
    "candlesCount_one": "{{count}} Kerze",
    "candlesCount_other": "{{count}} Kerzen",
    "photosCount_one": "{{count}} Foto",
    "photosCount_other": "{{count}} Fotos",
    "messagesCount_one": "{{count}} Nachricht",
    "messagesCount_other": "{{count}} Nachrichten",
    "for": "für",
    "inviteTitle": "Ehren auch Sie ihr Andenken",
    "inviteText": "Melden Sie sich an, um eigene Fotos und Botschaften auf einer der Kerzen zu hinterlassen.",
    "contributeTitle": "Hinterlassen Sie eine Nachricht für die Familie",
    "contributeSub": "Ihre Nachricht und Ihre Fotos werden zu jeder Kerze der Familie hinzugefügt.",
    "yourName": "Ihr Name",
    "yourMessage": "Ihre Nachricht…",
    "connectForPhotos": "Melden Sie sich an, um Fotos hinzuzufügen",
    "photosMax": "max. 10 Fotos",
    "send": "Veröffentlichen",
    "moderationNote": "Sofort auf jeder Kerze der Familie veröffentlicht.",
    "publishedNotice": "Danke, Ihre Nachricht wurde veröffentlicht 🕯️",
    "familyLabel": "Die ganze Familie",
    "deletePhoto": "Foto löschen",
    "editMessage": "Nachricht bearbeiten",
    "connected": "Sie sind angemeldet",
    "coverPhoto": "Titelbild (optional)",
    "addCover": "Ein Foto hinzufügen",
    "follow": "Dieser Gruppe folgen",
    "following": "Folgt",
    "followed": "Folgt ✓ Sie werden über neue Erinnerungen benachrichtigt",
    "unfollowed": "Nicht mehr gefolgt",
    "followHint": "Registrieren Sie sich, um dieser Gruppe zu folgen und bei jeder neuen Erinnerung benachrichtigt zu werden.",
    "followedGroups": "Gefolgte Gruppen"
  },
  "payment": {
    "confirming": "Ihre Zahlung wird bestätigt...",
    "flameLit": "Die Flamme brennt",
    "redirecting": "Weiterleitung zum Gedenken...",
    "timeout": "Zahlung wird verarbeitet. Sehen Sie gleich unter „Meine Kerzen“ nach.",
    "cancelled": "Zahlung abgebrochen",
    "noCharge": "Es wurde kein Betrag abgebucht.",
    "backToCandles": "Zurück zu meinen Kerzen"
  },
  "plans": {
    "decouverte": "Entdeckung",
    "1mois": "1 Monat",
    "6mois": "6 Monate",
    "1an": "1 Jahr",
    "eternite": "Für die Ewigkeit"
  },
  "conditions": {
    "back": "Zurück zur Anmeldung",
    "title": "Nutzungsbedingungen und Datenschutzerklärung",
    "disclaimer": "Gekürzte Fassung zur Integration in die App. Dient der Information der Nutzer. Vor der Veröffentlichung wird eine unabhängige rechtliche Prüfung empfohlen.",
    "s1t": "1. Betreiber",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. Annahme",
    "s2c": "Mit der Erstellung eines Kontos oder der Nutzung der App akzeptieren Sie diese Bedingungen. Wenn Sie sie ablehnen, dürfen Sie den Dienst nicht nutzen.",
    "s3t": "3. Dienst",
    "s3c": "BougieDuCœur ermöglicht das Erstellen digitaler Gedenkseiten, das Anzünden virtueller Kerzen, das Veröffentlichen von Nachrichten und Fotos sowie die Nutzung der angebotenen Dienste.",
    "s4t": "4. Konto",
    "s4c": "Sie garantieren die Richtigkeit der angegebenen Informationen und sind für die Vertraulichkeit Ihrer Zugangsdaten verantwortlich.",
    "s5t": "5. Inhalte",
    "s5c": "Sie behalten Ihre Rechte an Ihren Inhalten, gewähren BougieDuCœur jedoch eine nicht-exklusive Lizenz, die für deren Hosting, Anzeige und Verbreitung im Rahmen des Dienstes erforderlich ist.",
    "s6t": "6. Verbote",
    "s6c": "Rechtswidrige, hetzerische, verleumderische oder betrügerische Inhalte sowie Inhalte, die Urheberrechte, das Recht am eigenen Bild, die Privatsphäre oder das Andenken der Verstorbenen verletzen, sind verboten. Falsche Gedenkseiten, Identitätsdiebstahl und falsche Berechtigte sind verboten.",
    "s7t": "7. Moderation",
    "s7c": "Jeder Inhalt kann gemeldet werden. BougieDuCœur kann Inhalte entfernen, ein Konto sperren oder löschen, wenn gegen diese Bedingungen verstoßen wird.",
    "s8t": "8. Familien",
    "s8c": "Familien und Berechtigte können nach Prüfung der Nachweise die Änderung oder Löschung einer Gedenkseite verlangen.",
    "s9t": "9. Personenbezogene Daten",
    "s9c": "Ihre Daten (Name, E-Mail, Telefon, Land) werden zur Verwaltung des Kontos, der Kerzen und der Benachrichtigungen verwendet. Sie werden nicht verkauft. Gemäß DSGVO haben Sie das Recht auf Auskunft, Berichtigung und Löschung per E-Mail an contact@bougieducoeur.com."
  }
};

const it = {
  "brand": {
    "part1": "Candela",
    "part2": "DelCuore"
  },
  "header": {
    "myCandles": "Le mie candele",
    "admin": "Admin",
    "notifications": "Notifiche",
    "noNotifications": "Nessuna notifica",
    "viewCandle": "Vedi la candela"
  },
  "nav": {
    "home": "Home",
    "myCandles": "Le mie candele",
    "messages": "Messaggi",
    "profile": "Profilo"
  },
  "install": {
    "title": "Installa BougieDuCœur",
    "desc": "Aggiungi l'icona alla schermata home per un accesso rapido, come un'app.",
    "button": "Installa l'app",
    "later": "Più tardi",
    "iosStep1": "Tocca Condividi",
    "iosStep2": "Poi «Aggiungi a Home»",
    "androidStep1": "Apri il menu ⋮ del browser",
    "androidStep2": "Poi «Aggiungi a schermata Home»"
  },
  "messages": {
    "title": "Messaggi ricevuti",
    "empty": "Nessun messaggio ricevuto per ora.",
    "reactions": "reazione(i)"
  },
  "profile": {
    "title": "Il mio profilo",
    "name": "Nome",
    "email": "Email",
    "phone": "Cellulare",
    "country": "Paese",
    "language": "Lingua",
    "notifications": "Ricevere le notifiche",
    "save": "Salva",
    "saved": "Profilo aggiornato",
    "error": "Si è verificato un errore",
    "logout": "Disconnettersi",
    "incompleteNotice": "Il tuo profilo è incompleto. Completa le tue informazioni.",
    "complete": "Completare",
    "missingIntro": "Da completare:",
    "password": "Password",
    "currentPassword": "Password attuale",
    "newPassword": "Nuova password",
    "confirmPassword": "Conferma la nuova password",
    "changePassword": "Cambia la password",
    "pwdSection": "Password di accesso",
    "pwdTooShort": "La password deve contenere almeno 6 caratteri",
    "pwdMismatch": "Le password non corrispondono",
    "pwdChanged": "Password modificata",
    "pwdHint": "Lascia vuoto il campo «password attuale» se non ne avevi ancora una."
  },
  "home": {
    "title": "Una fiamma per non dimenticare mai",
    "subtitle": "Accendi una candela del cuore in memoria di una persona cara. Condividi un messaggio e invita i tuoi cari al raccoglimento Gratuitamente.",
    "cta": "Accendi una candela",
    "ctaSub": "Un omaggio a una persona cara",
    "ctaFree": "raccogliersi gratuitamente",
    "stats": "Già {{candles}} candele accese · {{messages}} messaggi di raccoglimento"
  },
  "auth": {
    "title": "Unisciti a BougieDuCœur",
    "desc": "Accedi per accendere e gestire le tue candele.",
    "google": "Continua con Google",
    "apple": "Continua con Apple",
    "appleSoon": "L'accesso con Apple arriverà presto",
    "or": "o",
    "login": "Accedi",
    "register": "Registrati",
    "email": "Email",
    "password": "Password",
    "name": "Nome",
    "firstName": "Nome",
    "lastName": "Cognome",
    "signIn": "Accedi",
    "createAccount": "Crea il mio account",
    "welcome": "Benvenuto",
    "accountCreated": "Account creato",
    "loginError": "Accesso non riuscito",
    "registerError": "Registrazione non riuscita",
    "regTitle": "Crea un account",
    "regSubtitle": "Unisciti alla comunità e rendi omaggio a chi ti manca.",
    "freeBadge": "Registrazione 100% gratuita",
    "phone": "Cellulare (facoltativo)",
    "termsAccept": "Ho letto e accetto le condizioni generali d'uso e le note legali.",
    "readTerms": "Leggi le condizioni generali d'uso e le note legali",
    "enableNotifications": "Attivare le notifiche",
    "continueWith": "o continua con",
    "alreadyMember": "Già registrato? Accedi",
    "mustAcceptTerms": "Devi accettare le condizioni d'uso",
    "noAccount": "Non hai ancora un account?"
  },
  "create": {
    "title": "Accendi una candela",
    "subtitle": "Un omaggio personalizzato, in tutta semplicità.",
    "nameLabel": "Nome del defunto",
    "namePlaceholder": "Es. Maria Rossi",
    "messageLabel": "Messaggio di omaggio",
    "messagePlaceholder": "Qualche parola dal cuore...",
    "durationLabel": "Un omaggio a una persona cara",
    "photoLabel": "Foto (obbligatoria)",
    "addPhoto": "Aggiungi una foto",
    "birthDate": "Nascita",
    "offerDeadline": "Offerta da confermare entro il {{date}}",
    "candleFreeUntil": "Candela accesa gratuitamente fino al {{date}}",
    "offerIncentive": "Se confermi questa offerta entro il {{end}}, la tua candela resterà accesa gratuitamente fino al {{until}}.",
    "datesLater": "Potrai aggiungere le date di nascita e morte dopo il pagamento.",
    "draftRestored": "Abbiamo conservato i dati della tua candela non completata.",
    "deathDate": "Morte",
    "previewEternal": "che brucerà per sempre",
    "previewDuration": "durata: {{label}}",
    "payButton": "Accendi per {{price}}",
    "stripeNote": "Pagamento sicuro con Stripe · Carta di prova 4242 4242 4242 4242",
    "candleLit": "Candela accesa",
    "error": "Si è verificato un errore",
    "photoTooBig": "Foto troppo grande (max 3 MB)",
    "photoRequired": "Aggiungi una foto, per favore",
    "tagline": "Una Fiamma e Messaggi per l'eternità",
    "previewFlame": "Anteprima della fiamma"
  },
  "memorial": {
    "inMemory": "In memoria di",
    "days": "Giorni",
    "hours": "Ore",
    "minutes": "Min",
    "seconds": "Sec",
    "extinguished": "La fiamma si è spenta",
    "eternal": "Candela accesa per l'eternità",
    "pendingPayment": "Candela in attesa di pagamento",
    "edit": "Modifica",
    "share": "Condividi",
    "copyLink": "Copia link",
    "findThemOn": "Trova {{name}} su",
    "socialsTitle": "Social network del defunto (opzionale)",
    "socialsHint": "Aggiungi i link ufficiali — appariranno sulla scheda.",
    "officialSite": "Sito ufficiale",
    "shareInvite": "Accendi una candela e lascia un messaggio gratuito 🕯️",
    "condolences": "Messaggi di vicinanza",
    "yourName": "Il tuo nome",
    "supportMessage": "Lascia un messaggio di sostegno...",
    "depositFree": "Lascia un messaggio gratuitamente",
    "messageDeposited": "Il tuo messaggio è stato pubblicato",
    "sendError": "Invio non riuscito",
    "notFound": "Candela non trovata",
    "relightCta": "Partecipa e Prolunga",
    "eternityCta": "Prolunga per l'eternità",
    "extendMore": "Prolunga di più",
    "relightTitle": "Prolunga la fiamma",
    "relightDesc": "Scegli una durata per riaccendere la candela di {{name}}.",
    "flameWeak": "La fiamma si affievolisce.",
    "flameExtinguished": "La fiamma si è spenta.",
    "reviveInvite": "Riaccendila e prolunga questo momento.",
    "editTitle": "Modifica l'omaggio",
    "editDesc": "Aggiorna il nome, il messaggio e la foto di questa candela.",
    "photo": "Foto",
    "add": "Aggiungi",
    "save": "Salva le modifiche",
    "messageUpdated": "Messaggio aggiornato",
    "editError": "Modifica non riuscita",
    "nameRequired": "Il nome è obbligatorio",
    "linkCopied": "Link copiato",
    "copiedToClipboard": "Link copiato negli appunti",
    "instagramCopied": "Link copiato — incollalo nella tua storia o bio di Instagram",
    "firstMessage": "Sii il primo a lasciare un messaggio.",
    "leaveMessage": "Lascia un messaggio",
    "leaveMessageSub": "Gratis, in pochi secondi",
    "supportCountLabel": "messaggi di sostegno",
    "error": "Errore",
    "forEternity": "Una candela per l'eternità"
  },
  "mycandles": {
    "title": "Le mie candele",
    "new": "Nuova",
    "active": "Attiva",
    "extinguished": "Spenta",
    "eternal": "Eterna",
    "pending": "In attesa di pagamento",
    "relights": "riaccensione/i",
    "collected": "raccolti",
    "empty": "Non hai ancora acceso alcuna candela.",
    "lightCandle": "Accendi una candela",
    "pay": "Paga",
    "revive": "Riaccendi",
    "dialogLightTitle": "Accendi la candela",
    "dialogRelightTitle": "Prolunga la fiamma",
    "chooseDuration": "Scegli una durata",
    "chooseDurationFor": "Scegli una durata per {{name}}.",
    "light": "Accendi",
    "prolong": "Prolunga",
    "updated": "Candela aggiornata",
    "changePhoto": "Cambia la foto",
    "groupShort": "Gruppo",
    "newFull": "Nuova candela",
    "messagesCount": "Numero di messaggi"
  },
  "family": {
    "title": "Ricordi di famiglia",
    "subtitle": "Riunisci i messaggi e le foto di più candele in un unico posto.",
    "button": "Ricordi di famiglia",
    "newGroup": "Nuovo gruppo",
    "editGroup": "Modifica gruppo",
    "createGroup": "Crea il gruppo",
    "groupName": "Nome del gruppo",
    "groupNamePlaceholder": "Es. I miei genitori, Famiglia Rossi…",
    "selectCandles": "Scegli le candele da raggruppare",
    "noCandles": "Non hai ancora una candela da raggruppare.",
    "empty": "Ancora nessun gruppo. Creane uno per riunire i tuoi ricordi.",
    "open": "Apri",
    "share": "Condividi",
    "edit": "Modifica",
    "delete": "Elimina",
    "save": "Salva",
    "deleteConfirm": "Eliminare questo gruppo? Le candele e i loro messaggi non vengono eliminati.",
    "linkCopied": "Link di condivisione copiato — invialo alla tua famiglia",
    "saved": "Gruppo salvato",
    "deleted": "Gruppo eliminato",
    "photos": "Foto",
    "messages": "Messaggi",
    "noPhotos": "Ancora nessuna foto.",
    "noMessages": "Ancora nessun messaggio.",
    "sharedTitle": "Ricordi condivisi",
    "backToGroups": "Torna ai gruppi",
    "selectAtLeastOne": "Seleziona almeno una candela",
    "candlesCount_one": "{{count}} candela",
    "candlesCount_other": "{{count}} candele",
    "photosCount_one": "{{count}} foto",
    "photosCount_other": "{{count}} foto",
    "messagesCount_one": "{{count}} messaggio",
    "messagesCount_other": "{{count}} messaggi",
    "for": "per",
    "inviteTitle": "Onora anche tu la loro memoria",
    "inviteText": "Accedi per lasciare le tue foto e testimonianze su una delle candele.",
    "contributeTitle": "Lascia un messaggio per la famiglia",
    "contributeSub": "Il tuo messaggio e le tue foto saranno aggiunti a ogni candela della famiglia.",
    "yourName": "Il tuo nome",
    "yourMessage": "Il tuo messaggio…",
    "connectForPhotos": "Accedi per aggiungere foto",
    "photosMax": "massimo 10 foto",
    "send": "Pubblica",
    "moderationNote": "Pubblicato subito su ogni candela della famiglia.",
    "publishedNotice": "Grazie, il tuo messaggio è stato pubblicato 🕯️",
    "familyLabel": "Tutta la famiglia",
    "deletePhoto": "Elimina la foto",
    "editMessage": "Modifica il messaggio",
    "connected": "Hai effettuato l'accesso",
    "coverPhoto": "Foto di copertina (facoltativa)",
    "addCover": "Aggiungi una foto",
    "follow": "Segui questo gruppo",
    "following": "Segui",
    "followed": "Segui ✓ Sarai avvisato dei nuovi ricordi",
    "unfollowed": "Non segui più",
    "followHint": "Registrati per seguire questo gruppo ed essere avvisato a ogni nuovo ricordo.",
    "followedGroups": "Gruppi seguiti"
  },
  "payment": {
    "confirming": "Conferma del pagamento in corso...",
    "flameLit": "La fiamma è accesa",
    "redirecting": "Reindirizzamento al memoriale...",
    "timeout": "Il pagamento è in elaborazione. Controlla “Le mie candele” tra poco.",
    "cancelled": "Pagamento annullato",
    "noCharge": "Nessun importo è stato addebitato.",
    "backToCandles": "Torna alle mie candele"
  },
  "plans": {
    "decouverte": "Scoperta",
    "1mois": "1 mese",
    "6mois": "6 mesi",
    "1an": "1 anno",
    "eternite": "Per l'eternità"
  },
  "conditions": {
    "back": "Torna alla registrazione",
    "title": "Condizioni d'uso e Informativa sulla privacy",
    "disclaimer": "Versione ridotta per l'integrazione nell'applicazione. Destinata all'informazione degli utenti. Si consiglia una validazione legale indipendente prima della pubblicazione.",
    "s1t": "1. Editore",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. Accettazione",
    "s2c": "Creando un account o utilizzando l'applicazione, accetti le presenti condizioni. Se non le accetti, non devi utilizzare il servizio.",
    "s3t": "3. Servizio",
    "s3c": "BougieDuCœur consente di creare omaggi digitali, accendere candele virtuali, pubblicare messaggi e foto e utilizzare i servizi offerti.",
    "s4t": "4. Account",
    "s4c": "Garantisci l'esattezza delle informazioni fornite e sei responsabile della riservatezza delle tue credenziali.",
    "s5t": "5. Contenuti",
    "s5c": "Conservi i tuoi diritti sui tuoi contenuti ma concedi a BougieDuCœur una licenza non esclusiva necessaria per ospitarli, visualizzarli e diffonderli nell'ambito del servizio.",
    "s6t": "6. Divieti",
    "s6c": "Sono vietati i contenuti illeciti, diffamatori o fraudolenti e quelli che violano il diritto d'autore, il diritto all'immagine, la privacy o la memoria dei defunti. Sono vietati falsi omaggi, furto d'identità e falsi aventi diritto.",
    "s7t": "7. Moderazione",
    "s7c": "Qualsiasi contenuto può essere segnalato. BougieDuCœur può rimuovere un contenuto, sospendere o eliminare un account in caso di violazione delle presenti condizioni.",
    "s8t": "8. Famiglie",
    "s8c": "Le famiglie e gli aventi diritto possono richiedere la modifica o l'eliminazione di un memoriale dopo la verifica dei giustificativi.",
    "s9t": "9. Dati personali",
    "s9c": "I tuoi dati (nome, email, telefono, paese) sono utilizzati per la gestione dell'account, delle candele e delle notifiche. Non vengono venduti. In conformità al GDPR, hai diritto di accesso, rettifica e cancellazione scrivendo a contact@bougieducoeur.com."
  }
};

const pl = {
  "brand": {
    "part1": "Świeca",
    "part2": "Serca"
  },
  "header": {
    "myCandles": "Moje świece",
    "admin": "Admin",
    "notifications": "Powiadomienia",
    "noNotifications": "Brak powiadomień",
    "viewCandle": "Zobacz świecę"
  },
  "nav": {
    "home": "Start",
    "myCandles": "Moje świece",
    "messages": "Wiadomości",
    "profile": "Profil"
  },
  "install": {
    "title": "Zainstaluj BougieDuCœur",
    "desc": "Dodaj ikonę do ekranu głównego, aby uzyskać szybki dostęp jak do aplikacji.",
    "button": "Zainstaluj aplikację",
    "later": "Później",
    "iosStep1": "Dotknij Udostępnij",
    "iosStep2": "Następnie „Do ekranu głównego”",
    "androidStep1": "Otwórz menu ⋮ przeglądarki",
    "androidStep2": "Następnie „Dodaj do ekranu głównego”"
  },
  "messages": {
    "title": "Otrzymane wiadomości",
    "empty": "Nie otrzymano jeszcze żadnych wiadomości.",
    "reactions": "reakcja(e)"
  },
  "profile": {
    "title": "Mój profil",
    "name": "Imię i nazwisko",
    "email": "E-mail",
    "phone": "Telefon",
    "country": "Kraj",
    "language": "Język",
    "notifications": "Otrzymuj powiadomienia",
    "save": "Zapisz",
    "saved": "Profil zaktualizowany",
    "error": "Wystąpił błąd",
    "logout": "Wyloguj się",
    "incompleteNotice": "Twój profil jest niekompletny. Uzupełnij swoje dane.",
    "complete": "Uzupełnij",
    "missingIntro": "Do uzupełnienia:",
    "password": "Hasło",
    "currentPassword": "Aktualne hasło",
    "newPassword": "Nowe hasło",
    "confirmPassword": "Potwierdź nowe hasło",
    "changePassword": "Zmień hasło",
    "pwdSection": "Hasło logowania",
    "pwdTooShort": "Hasło musi mieć co najmniej 6 znaków",
    "pwdMismatch": "Hasła nie są zgodne",
    "pwdChanged": "Hasło zmienione",
    "pwdHint": "Pozostaw pole „aktualne hasło“ puste, jeśli jeszcze go nie miałeś."
  },
  "home": {
    "title": "Płomień, by nigdy nie zapomnieć",
    "subtitle": "Zapal świecę serca ku pamięci bliskiej osoby. Podziel się wiadomością i zaproś bliskich do wspomnień — bezpłatnie.",
    "cta": "Zapal świecę",
    "ctaSub": "Hołd dla bliskiej osoby",
    "ctaFree": "wspominać bezpłatnie",
    "stats": "Już {{candles}} zapalonych świec · {{messages}} wiadomości pamięci"
  },
  "auth": {
    "title": "Dołącz do BougieDuCœur",
    "desc": "Zaloguj się, aby zapalać i zarządzać swoimi świecami.",
    "google": "Kontynuuj z Google",
    "apple": "Kontynuuj z Apple",
    "appleSoon": "Logowanie Apple już wkrótce",
    "or": "lub",
    "login": "Logowanie",
    "register": "Rejestracja",
    "email": "E-mail",
    "password": "Hasło",
    "name": "Imię i nazwisko",
    "firstName": "Imię",
    "lastName": "Nazwisko",
    "signIn": "Zaloguj się",
    "createAccount": "Utwórz konto",
    "welcome": "Witamy",
    "accountCreated": "Konto utworzone",
    "loginError": "Nie można się zalogować",
    "registerError": "Nie można się zarejestrować",
    "regTitle": "Utwórz konto",
    "regSubtitle": "Dołącz do społeczności i oddaj hołd tym, których Ci brakuje.",
    "freeBadge": "Rejestracja w 100% bezpłatna",
    "phone": "Telefon komórkowy (opcjonalnie)",
    "termsAccept": "Przeczytałem(-am) i akceptuję ogólne warunki korzystania oraz informacje prawne.",
    "readTerms": "Przeczytaj ogólne warunki korzystania i informacje prawne",
    "enableNotifications": "Włącz powiadomienia",
    "continueWith": "lub kontynuuj z",
    "alreadyMember": "Masz już konto? Zaloguj się",
    "mustAcceptTerms": "Musisz zaakceptować warunki korzystania",
    "noAccount": "Nie masz jeszcze konta?"
  },
  "create": {
    "title": "Zapal świecę",
    "subtitle": "Spersonalizowany hołd, w prosty sposób.",
    "nameLabel": "Imię zmarłego",
    "namePlaceholder": "np. Anna Kowalska",
    "messageLabel": "Wiadomość hołdu",
    "messagePlaceholder": "Kilka słów płynących z serca...",
    "durationLabel": "Hołd dla bliskiej osoby",
    "photoLabel": "Zdjęcie (wymagane)",
    "addPhoto": "Dodaj zdjęcie",
    "birthDate": "Urodzenie",
    "offerDeadline": "Ofertę potwierdź przed {{date}}",
    "candleFreeUntil": "Świeca zapalona bezpłatnie do {{date}}",
    "offerIncentive": "Jeśli potwierdzisz tę ofertę przed {{end}}, Twoja świeca pozostanie zapalona bezpłatnie do {{until}}.",
    "datesLater": "Daty urodzenia i śmierci możesz dodać po opłaceniu.",
    "draftRestored": "Zachowaliśmy dane Twojej niedokończonej świecy.",
    "deathDate": "Śmierć",
    "previewEternal": "która będzie płonąć wiecznie",
    "previewDuration": "czas: {{label}}",
    "payButton": "Zapal za {{price}}",
    "stripeNote": "Bezpieczna płatność przez Stripe · Karta testowa 4242 4242 4242 4242",
    "candleLit": "Świeca zapalona",
    "error": "Wystąpił błąd",
    "photoTooBig": "Zdjęcie za duże (maks. 3 MB)",
    "photoRequired": "Dodaj zdjęcie",
    "tagline": "Płomień i wiadomości na wieczność",
    "previewFlame": "Podgląd płomienia"
  },
  "memorial": {
    "inMemory": "Ku pamięci",
    "days": "Dni",
    "hours": "Godz.",
    "minutes": "Min",
    "seconds": "Sek",
    "extinguished": "Płomień zgasł",
    "eternal": "Świeca zapalona na wieczność",
    "pendingPayment": "Świeca oczekuje na płatność",
    "edit": "Edytuj",
    "share": "Udostępnij",
    "copyLink": "Kopiuj link",
    "condolences": "Wyrazy współczucia",
    "yourName": "Twoje imię",
    "supportMessage": "Zostaw wiadomość wsparcia...",
    "depositFree": "Zostaw wiadomość bezpłatnie",
    "messageDeposited": "Twoja wiadomość została opublikowana",
    "sendError": "Nie można wysłać",
    "notFound": "Nie znaleziono świecy",
    "relightCta": "Weź udział i przedłuż",
    "eternityCta": "Przedłuż na wieczność",
    "extendMore": "Przedłuż więcej",
    "relightTitle": "Przedłuż płomień",
    "relightDesc": "Wybierz czas, aby ponownie zapalić świecę {{name}}.",
    "flameWeak": "Płomień słabnie.",
    "flameExtinguished": "Płomień zgasł.",
    "reviveInvite": "Zapal ją ponownie i przedłuż tę chwilę.",
    "editTitle": "Edytuj hołd",
    "editDesc": "Zaktualizuj imię, wiadomość i zdjęcie tej świecy.",
    "photo": "Zdjęcie",
    "add": "Dodaj",
    "save": "Zapisz zmiany",
    "messageUpdated": "Wiadomość zaktualizowana",
    "editError": "Nie można zmienić",
    "nameRequired": "Imię jest wymagane",
    "linkCopied": "Link skopiowany",
    "copiedToClipboard": "Link skopiowany do schowka",
    "instagramCopied": "Link skopiowany — wklej go w relację lub bio na Instagramie",
    "firstMessage": "Bądź pierwszym, który zostawi wiadomość.",
    "leaveMessage": "Zostaw wiadomość",
    "leaveMessageSub": "Za darmo, w kilka sekund",
    "supportCountLabel": "wiadomości wsparcia",
    "error": "Błąd",
    "forEternity": "Świeca na wieczność",
    "findThemOn": "Znajdź {{name}} na",
    "socialsTitle": "Media społecznościowe zmarłego (opcjonalnie)",
    "socialsHint": "Dodaj oficjalne linki — pojawią się na stronie.",
    "officialSite": "Oficjalna strona",
    "shareInvite": "Zapal świecę i zostaw bezpłatną wiadomość 🕯️"
  },
  "mycandles": {
    "title": "Moje świece",
    "new": "Nowa",
    "active": "Aktywna",
    "extinguished": "Zgasła",
    "eternal": "Wieczna",
    "pending": "Oczekuje na płatność",
    "relights": "ponowne zapalenia",
    "collected": "zebrane",
    "empty": "Nie zapaliłeś jeszcze żadnej świecy.",
    "lightCandle": "Zapal świecę",
    "pay": "Zapłać",
    "revive": "Zapal ponownie",
    "dialogLightTitle": "Zapal świecę",
    "dialogRelightTitle": "Przedłuż płomień",
    "chooseDuration": "Wybierz czas",
    "chooseDurationFor": "Wybierz czas dla {{name}}.",
    "light": "Zapal",
    "prolong": "Przedłuż",
    "updated": "Świeca zaktualizowana",
    "changePhoto": "Zmień zdjęcie",
    "groupShort": "Grupa",
    "newFull": "Nowa świeca",
    "messagesCount": "Liczba wiadomości"
  },
  "family": {
    "title": "Wspomnienia rodzinne",
    "subtitle": "Zbierz wiadomości i zdjęcia z kilku świec w jednym miejscu.",
    "button": "Wspomnienia rodzinne",
    "newGroup": "Nowa grupa",
    "editGroup": "Edytuj grupę",
    "createGroup": "Utwórz grupę",
    "groupName": "Nazwa grupy",
    "groupNamePlaceholder": "Np. Moi rodzice, Rodzina Kowalskich…",
    "selectCandles": "Wybierz świece do zgrupowania",
    "noCandles": "Nie masz jeszcze świecy do zgrupowania.",
    "empty": "Brak grup. Utwórz jedną, aby zebrać swoje wspomnienia.",
    "open": "Otwórz",
    "share": "Udostępnij",
    "edit": "Edytuj",
    "delete": "Usuń",
    "save": "Zapisz",
    "deleteConfirm": "Usunąć tę grupę? Świece i ich wiadomości nie zostaną usunięte.",
    "linkCopied": "Link do udostępniania skopiowany — wyślij go rodzinie",
    "saved": "Grupa zapisana",
    "deleted": "Grupa usunięta",
    "photos": "Zdjęcia",
    "messages": "Wiadomości",
    "noPhotos": "Brak zdjęć.",
    "noMessages": "Brak wiadomości.",
    "sharedTitle": "Udostępnione wspomnienia",
    "backToGroups": "Wróć do grup",
    "selectAtLeastOne": "Wybierz co najmniej jedną świecę",
    "candlesCount_one": "{{count}} świeca",
    "candlesCount_other": "{{count}} świec",
    "photosCount_one": "{{count}} zdjęcie",
    "photosCount_other": "{{count}} zdjęć",
    "messagesCount_one": "{{count}} wiadomość",
    "messagesCount_other": "{{count}} wiadomości",
    "for": "dla",
    "inviteTitle": "Uczcij i Ty ich pamięć",
    "inviteText": "Zaloguj się, aby dodać własne zdjęcia i wspomnienia na jednej ze świec.",
    "contributeTitle": "Zostaw wiadomość dla rodziny",
    "contributeSub": "Twoja wiadomość i zdjęcia zostaną dodane do każdej świecy rodziny.",
    "yourName": "Twoje imię",
    "yourMessage": "Twoja wiadomość…",
    "connectForPhotos": "Zaloguj się, aby dodać zdjęcia",
    "photosMax": "maks. 10 zdjęć",
    "send": "Opublikuj",
    "moderationNote": "Opublikowano od razu na każdej świecy rodziny.",
    "publishedNotice": "Dziękujemy, Twoja wiadomość została opublikowana 🕯️",
    "familyLabel": "Cała rodzina",
    "deletePhoto": "Usuń zdjęcie",
    "editMessage": "Edytuj wiadomość",
    "connected": "Jesteś zalogowany(a)",
    "coverPhoto": "Zdjęcie na okładkę (opcjonalne)",
    "addCover": "Dodaj zdjęcie",
    "follow": "Obserwuj tę grupę",
    "following": "Obserwujesz",
    "followed": "Obserwujesz ✓ Otrzymasz powiadomienie o nowych wspomnieniach",
    "unfollowed": "Przestałeś obserwować",
    "followHint": "Zarejestruj się, aby obserwować tę grupę i otrzymywać powiadomienie o każdym nowym wspomnieniu.",
    "followedGroups": "Obserwowane grupy"
  },
  "payment": {
    "confirming": "Potwierdzanie płatności...",
    "flameLit": "Płomień płonie",
    "redirecting": "Przekierowanie do miejsca pamięci...",
    "timeout": "Płatność jest przetwarzana. Sprawdź „Moje świece” za chwilę.",
    "cancelled": "Płatność anulowana",
    "noCharge": "Nie pobrano żadnej kwoty.",
    "backToCandles": "Powrót do moich świec"
  },
  "plans": {
    "decouverte": "Odkrycie",
    "1mois": "1 miesiąc",
    "6mois": "6 miesięcy",
    "1an": "1 rok",
    "eternite": "Na wieczność"
  },
  "conditions": {
    "back": "Powrót do rejestracji",
    "title": "Warunki użytkowania i Polityka prywatności",
    "disclaimer": "Skrócona wersja do integracji w aplikacji. Przeznaczona do informowania użytkowników. Przed publikacją zalecana jest niezależna weryfikacja prawna.",
    "s1t": "1. Wydawca",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. Akceptacja",
    "s2c": "Zakładając konto lub korzystając z aplikacji, akceptujesz niniejsze warunki. Jeśli ich nie akceptujesz, nie możesz korzystać z usługi.",
    "s3t": "3. Usługa",
    "s3c": "BougieDuCœur umożliwia tworzenie cyfrowych hołdów, zapalanie wirtualnych świec, publikowanie wiadomości i zdjęć oraz korzystanie z oferowanych usług.",
    "s4t": "4. Konto",
    "s4c": "Gwarantujesz prawdziwość podanych informacji i odpowiadasz za poufność swoich danych logowania.",
    "s5t": "5. Treści",
    "s5c": "Zachowujesz prawa do swoich treści, ale udzielasz BougieDuCœur niewyłącznej licencji niezbędnej do ich hostingu, wyświetlania i rozpowszechniania w ramach usługi.",
    "s6t": "6. Zakazy",
    "s6c": "Zabronione są treści nielegalne, nawołujące do nienawiści, zniesławiające lub oszukańcze oraz naruszające prawa autorskie, prawo do wizerunku, prywatność lub pamięć zmarłych. Zabronione są fałszywe hołdy, kradzież tożsamości i fałszywi uprawnieni.",
    "s7t": "7. Moderacja",
    "s7c": "Każdą treść można zgłosić. BougieDuCœur może usunąć treść, zawiesić lub usunąć konto w przypadku naruszenia niniejszych warunków.",
    "s8t": "8. Rodziny",
    "s8c": "Rodziny i uprawnieni mogą zażądać zmiany lub usunięcia pamiątki po zweryfikowaniu dokumentów.",
    "s9t": "9. Dane osobowe",
    "s9c": "Twoje dane (imię, e-mail, telefon, kraj) służą do zarządzania kontem, świecami i powiadomieniami. Nie są sprzedawane. Zgodnie z RODO masz prawo dostępu, sprostowania i usunięcia, pisząc na contact@bougieducoeur.com."
  }
};

const fil = {
  "brand": {
    "part1": "Kandila",
    "part2": "NgPuso"
  },
  "header": {
    "myCandles": "Mga kandila ko",
    "admin": "Admin",
    "notifications": "Mga abiso",
    "noNotifications": "Walang abiso",
    "viewCandle": "Tingnan ang kandila"
  },
  "nav": {
    "home": "Home",
    "myCandles": "Mga kandila",
    "messages": "Mga mensahe",
    "profile": "Profile"
  },
  "install": {
    "title": "I-install ang BougieDuCœur",
    "desc": "Idagdag ang icon sa iyong home screen para sa mabilis na access, tulad ng isang app.",
    "button": "I-install ang app",
    "later": "Mamaya",
    "iosStep1": "I-tap ang Share",
    "iosStep2": "Pagkatapos ay \"Add to Home Screen\"",
    "androidStep1": "Buksan ang menu ⋮ ng browser",
    "androidStep2": "Pagkatapos ay \"Add to Home screen\""
  },
  "messages": {
    "title": "Mga natanggap na mensahe",
    "empty": "Wala pang natanggap na mensahe.",
    "reactions": "reaksyon"
  },
  "profile": {
    "title": "Aking profile",
    "name": "Pangalan",
    "email": "Email",
    "phone": "Mobile",
    "country": "Bansa",
    "language": "Wika",
    "notifications": "Tumanggap ng mga abiso",
    "save": "I-save",
    "saved": "Na-update ang profile",
    "error": "May naganap na error",
    "logout": "Mag-log out",
    "incompleteNotice": "Hindi kumpleto ang iyong profile. Kumpletuhin ang iyong impormasyon.",
    "complete": "Kumpletuhin",
    "missingIntro": "Kukumpletuhin:",
    "password": "Password",
    "currentPassword": "Kasalukuyang password",
    "newPassword": "Bagong password",
    "confirmPassword": "Kumpirmahin ang bagong password",
    "changePassword": "Palitan ang password",
    "pwdSection": "Password sa pag-login",
    "pwdTooShort": "Ang password ay dapat na hindi bababa sa 6 na karakter",
    "pwdMismatch": "Hindi magkatugma ang mga password",
    "pwdChanged": "Napalitan ang password",
    "pwdHint": "Iwanang blangko ang field na «kasalukuyang password» kung wala ka pa nito."
  },
  "home": {
    "title": "Isang liwanag para hindi malimutan",
    "subtitle": "Magsindi ng kandila mula sa puso bilang alaala ng isang mahal sa buhay. Magbahagi ng mensahe at anyayahan ang iyong pamilya na mag-alaala nang Libre.",
    "cta": "Magsindi ng kandila",
    "ctaSub": "Parangal sa isang mahal sa buhay",
    "ctaFree": "mag-alaala nang libre",
    "stats": "May {{candles}} kandilang nakasindi na · {{messages}} mensahe ng pag-alaala"
  },
  "auth": {
    "title": "Sumali sa BougieDuCœur",
    "desc": "Mag-sign in upang magsindi at pamahalaan ang iyong mga kandila.",
    "google": "Magpatuloy gamit ang Google",
    "apple": "Magpatuloy gamit ang Apple",
    "appleSoon": "Malapit na ang Apple sign-in",
    "or": "o",
    "login": "Mag-log in",
    "register": "Mag-sign up",
    "email": "Email",
    "password": "Password",
    "name": "Pangalan",
    "firstName": "Pangalan",
    "lastName": "Apelyido",
    "signIn": "Mag-sign in",
    "createAccount": "Gumawa ng account",
    "welcome": "Maligayang pagdating",
    "accountCreated": "Nagawa ang account",
    "loginError": "Hindi maka-sign in",
    "registerError": "Hindi maka-sign up",
    "regTitle": "Gumawa ng account",
    "regSubtitle": "Sumali sa komunidad at magbigay-pugay sa mga namimiss mo.",
    "freeBadge": "100% libreng pagpaparehistro",
    "phone": "Mobile (opsyonal)",
    "termsAccept": "Nabasa at tinatanggap ko ang pangkalahatang mga tuntunin ng paggamit at ang legal na paunawa.",
    "readTerms": "Basahin ang pangkalahatang mga tuntunin at legal na paunawa",
    "enableNotifications": "I-enable ang mga abiso",
    "continueWith": "o magpatuloy gamit ang",
    "alreadyMember": "May account na? Mag-log in",
    "mustAcceptTerms": "Dapat mong tanggapin ang mga tuntunin ng paggamit",
    "noAccount": "Wala pang account?"
  },
  "create": {
    "title": "Magsindi ng kandila",
    "subtitle": "Isang personal na parangal, ginawang simple.",
    "nameLabel": "Pangalan ng yumao",
    "namePlaceholder": "hal. Maria Santos",
    "messageLabel": "Mensahe ng parangal",
    "messagePlaceholder": "Ilang salita mula sa puso...",
    "durationLabel": "Isang parangal sa mahal sa buhay",
    "photoLabel": "Larawan (kinakailangan)",
    "addPhoto": "Magdagdag ng larawan",
    "birthDate": "Kapanganakan",
    "offerDeadline": "Kumpirmahin ang alok bago ang {{date}}",
    "candleFreeUntil": "Kandila na nakasindi nang libre hanggang {{date}}",
    "offerIncentive": "Kung kokumpirmahin mo ang alok na ito bago ang {{end}}, mananatiling nakasindi nang libre ang iyong kandila hanggang {{until}}.",
    "datesLater": "Maaari mong idagdag ang petsa ng kapanganakan at pagpanaw pagkatapos magbayad.",
    "draftRestored": "Itinago namin ang mga detalye ng hindi natapos na kandila.",
    "deathDate": "Pagpanaw",
    "previewEternal": "na magniningas magpakailanman",
    "previewDuration": "tagal: {{label}}",
    "payButton": "Magsindi para sa {{price}}",
    "stripeNote": "Ligtas na bayad sa pamamagitan ng Stripe · Test card 4242 4242 4242 4242",
    "candleLit": "Nakasindi ang kandila",
    "error": "May naganap na error",
    "photoTooBig": "Masyadong malaki ang larawan (max 3 MB)",
    "photoRequired": "Mangyaring magdagdag ng larawan",
    "tagline": "Isang Liwanag at mga Mensahe magpakailanman",
    "previewFlame": "Preview ng liwanag"
  },
  "memorial": {
    "inMemory": "Bilang alaala ni",
    "days": "Araw",
    "hours": "Oras",
    "minutes": "Min",
    "seconds": "Seg",
    "extinguished": "Namatay na ang liwanag",
    "eternal": "Kandilang nakasindi magpakailanman",
    "pendingPayment": "Kandilang naghihintay ng bayad",
    "edit": "I-edit",
    "share": "Ibahagi",
    "copyLink": "Kopyahin ang link",
    "condolences": "Mga mensahe ng pakikiramay",
    "yourName": "Iyong pangalan",
    "supportMessage": "Mag-iwan ng mensahe ng suporta...",
    "depositFree": "Mag-iwan ng mensahe nang libre",
    "messageDeposited": "Nai-post na ang iyong mensahe",
    "sendError": "Hindi maipadala",
    "notFound": "Hindi nahanap ang kandila",
    "relightCta": "Sumali at Palawigin",
    "eternityCta": "Palawigin magpakailanman",
    "extendMore": "Palawigin pa",
    "relightTitle": "Palawigin ang liwanag",
    "relightDesc": "Pumili ng tagal para muling sindihan ang kandila ni {{name}}.",
    "flameWeak": "Humihina ang liwanag.",
    "flameExtinguished": "Namatay na ang liwanag.",
    "reviveInvite": "Muling sindihan ito at palawigin ang sandaling ito.",
    "editTitle": "I-edit ang parangal",
    "editDesc": "I-update ang pangalan, mensahe at larawan ng kandilang ito.",
    "photo": "Larawan",
    "add": "Idagdag",
    "save": "I-save ang mga pagbabago",
    "messageUpdated": "Na-update ang mensahe",
    "editError": "Hindi ma-update",
    "nameRequired": "Kinakailangan ang pangalan",
    "linkCopied": "Nakopya ang link",
    "copiedToClipboard": "Nakopya ang link sa clipboard",
    "instagramCopied": "Nakopya ang link — i-paste ito sa iyong Instagram story o bio",
    "firstMessage": "Ikaw ang mauna na mag-iwan ng mensahe.",
    "leaveMessage": "Mag-iwan ng mensahe",
    "leaveMessageSub": "Libre, ilang segundo lang",
    "supportCountLabel": "mga mensahe ng suporta",
    "error": "Error",
    "forEternity": "Isang kandila para sa kawalang-hanggan",
    "findThemOn": "Hanapin si {{name}} sa",
    "socialsTitle": "Social media ng namayapa (opsyonal)",
    "socialsHint": "Magdagdag ng mga opisyal na link — lalabas ang mga ito sa pahina.",
    "officialSite": "Opisyal na website",
    "shareInvite": "Magsindi ng kandila at mag-iwan ng libreng mensahe 🕯️"
  },
  "mycandles": {
    "title": "Mga kandila ko",
    "new": "Bago",
    "active": "Aktibo",
    "extinguished": "Namatay",
    "eternal": "Walang hanggan",
    "pending": "Naghihintay ng bayad",
    "relights": "muling pagsindi",
    "collected": "nakolekta",
    "empty": "Wala ka pang sinindihang kandila.",
    "lightCandle": "Magsindi ng kandila",
    "pay": "Magbayad",
    "revive": "Muling sindihan",
    "dialogLightTitle": "Sindihan ang kandila",
    "dialogRelightTitle": "Palawigin ang liwanag",
    "chooseDuration": "Pumili ng tagal",
    "chooseDurationFor": "Pumili ng tagal para kay {{name}}.",
    "light": "Sindihan",
    "prolong": "Palawigin",
    "updated": "Na-update ang kandila",
    "changePhoto": "Palitan ang larawan",
    "groupShort": "Grupo",
    "newFull": "Bagong kandila",
    "messagesCount": "Bilang ng mga mensahe"
  },
  "family": {
    "title": "Mga alaala ng pamilya",
    "subtitle": "Pagsama-samahin ang mga mensahe at larawan ng ilang kandila sa isang lugar.",
    "button": "Mga alaala ng pamilya",
    "newGroup": "Bagong grupo",
    "editGroup": "I-edit ang grupo",
    "createGroup": "Gumawa ng grupo",
    "groupName": "Pangalan ng grupo",
    "groupNamePlaceholder": "Hal. Mga magulang ko, Pamilya Santos…",
    "selectCandles": "Piliin ang mga kandilang isasama",
    "noCandles": "Wala ka pang kandilang maisasama.",
    "empty": "Wala pang grupo. Gumawa ng isa para tipunin ang iyong mga alaala.",
    "open": "Buksan",
    "share": "Ibahagi",
    "edit": "I-edit",
    "delete": "Tanggalin",
    "save": "I-save",
    "deleteConfirm": "Tanggalin ang grupong ito? Hindi tatanggalin ang mga kandila at mensahe.",
    "linkCopied": "Nakopya ang link — ipadala ito sa iyong pamilya",
    "saved": "Na-save ang grupo",
    "deleted": "Natanggal ang grupo",
    "photos": "Mga larawan",
    "messages": "Mga mensahe",
    "noPhotos": "Wala pang larawan.",
    "noMessages": "Wala pang mensahe.",
    "sharedTitle": "Mga ibinahaging alaala",
    "backToGroups": "Bumalik sa mga grupo",
    "selectAtLeastOne": "Pumili ng kahit isang kandila",
    "candlesCount_one": "{{count}} kandila",
    "candlesCount_other": "{{count}} kandila",
    "photosCount_one": "{{count}} larawan",
    "photosCount_other": "{{count}} larawan",
    "messagesCount_one": "{{count}} mensahe",
    "messagesCount_other": "{{count}} mensahe",
    "for": "para kay",
    "inviteTitle": "Parangalan mo rin ang kanilang alaala",
    "inviteText": "Mag-sign in para mag-iwan ng sarili mong mga larawan at patotoo sa isa sa mga kandila.",
    "contributeTitle": "Mag-iwan ng mensahe para sa pamilya",
    "contributeSub": "Idaragdag ang iyong mensahe at larawan sa bawat kandila ng pamilya.",
    "yourName": "Iyong pangalan",
    "yourMessage": "Iyong mensahe…",
    "connectForPhotos": "Mag-sign in para magdagdag ng larawan",
    "photosMax": "10 larawan max",
    "send": "I-post",
    "moderationNote": "Agad na nai-post sa bawat kandila ng pamilya.",
    "publishedNotice": "Salamat, nai-post na ang iyong mensahe 🕯️",
    "familyLabel": "Buong pamilya",
    "deletePhoto": "Tanggalin ang larawan",
    "editMessage": "I-edit ang mensahe",
    "connected": "Naka-sign in ka na",
    "coverPhoto": "Larawan sa pabalat (opsyonal)",
    "addCover": "Magdagdag ng larawan",
    "follow": "Sundan ang grupong ito",
    "following": "Sinusundan",
    "followed": "Sinusundan ✓ Aabisuhan ka sa mga bagong alaala",
    "unfollowed": "Hindi na sinusundan",
    "followHint": "Mag-rehistro para sundan ang grupong ito at maabisuhan sa bawat bagong alaala.",
    "followedGroups": "Mga sinusundang grupo"
  },
  "payment": {
    "confirming": "Kinukumpirma ang iyong bayad...",
    "flameLit": "Nakasindi ang liwanag",
    "redirecting": "Nagre-redirect sa memorial...",
    "timeout": "Pinoproseso ang bayad. Tingnan ang \"Mga kandila ko\" sa ilang sandali.",
    "cancelled": "Kanselado ang bayad",
    "noCharge": "Walang halagang siningil.",
    "backToCandles": "Bumalik sa mga kandila ko"
  },
  "plans": {
    "decouverte": "Discovery",
    "1mois": "1 buwan",
    "6mois": "6 buwan",
    "1an": "1 taon",
    "eternite": "Magpakailanman"
  },
  "conditions": {
    "back": "Bumalik sa pagpaparehistro",
    "title": "Mga Tuntunin ng Paggamit at Patakaran sa Privacy",
    "disclaimer": "Pinaikling bersyon para sa integrasyon sa app. Para sa impormasyon ng mga gumagamit. Inirerekomenda ang independiyenteng legal na pagsusuri bago ilathala.",
    "s1t": "1. Publisher",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. Pagtanggap",
    "s2c": "Sa paggawa ng account o paggamit ng app, tinatanggap mo ang mga tuntuning ito. Kung hindi mo tinatanggap ang mga ito, hindi mo dapat gamitin ang serbisyo.",
    "s3t": "3. Serbisyo",
    "s3c": "Pinapayagan ka ng BougieDuCœur na gumawa ng mga digital na pagpupugay, magsindi ng mga virtual na kandila, mag-post ng mga mensahe at larawan, at gamitin ang mga inaalok na serbisyo.",
    "s4t": "4. Account",
    "s4c": "Ginagarantiya mo ang katumpakan ng ibinigay na impormasyon at responsable ka sa pagiging kumpidensyal ng iyong mga kredensyal.",
    "s5t": "5. Nilalaman",
    "s5c": "Pinapanatili mo ang iyong mga karapatan sa iyong nilalaman ngunit binibigyan mo ang BougieDuCœur ng hindi eksklusibong lisensya na kailangan para i-host, ipakita at ipamahagi ito bilang bahagi ng serbisyo.",
    "s6t": "6. Mga Pagbabawal",
    "s6c": "Ipinagbabawal ang ilegal, mapoot, mapanira o mapanlinlang na nilalaman, at nilalamang lumalabag sa copyright, karapatan sa imahe, privacy o alaala ng mga namayapa. Ipinagbabawal ang mga pekeng pagpupugay, pagnanakaw ng pagkakakilanlan at pekeng mga may karapatan.",
    "s7t": "7. Moderasyon",
    "s7c": "Maaaring i-report ang anumang nilalaman. Maaaring alisin ng BougieDuCœur ang nilalaman, suspindihin o tanggalin ang isang account kung may paglabag sa mga tuntuning ito.",
    "s8t": "8. Mga Pamilya",
    "s8c": "Ang mga pamilya at may karapatan ay maaaring humiling ng pagbabago o pagtanggal ng isang memorial pagkatapos ng pagpapatunay ng mga dokumento.",
    "s9t": "9. Personal na datos",
    "s9c": "Ang iyong datos (pangalan, email, telepono, bansa) ay ginagamit para pamahalaan ang account, mga kandila at mga abiso. Hindi ito ibinebenta. Sa ilalim ng GDPR, may karapatan kang mag-access, magwasto at magtanggal sa pamamagitan ng pagsulat sa contact@bougieducoeur.com."
  }
};

const ru = {
  "brand": {
    "part1": "Свеча",
    "part2": "Сердца"
  },
  "header": {
    "myCandles": "Мои свечи",
    "admin": "Админ",
    "notifications": "Уведомления",
    "noNotifications": "Нет уведомлений",
    "viewCandle": "Открыть свечу"
  },
  "nav": {
    "home": "Главная",
    "myCandles": "Мои свечи",
    "messages": "Сообщения",
    "profile": "Профиль"
  },
  "install": {
    "title": "Установить BougieDuCœur",
    "desc": "Добавьте значок на главный экран для быстрого доступа, как приложение.",
    "button": "Установить приложение",
    "later": "Позже",
    "iosStep1": "Нажмите «Поделиться»",
    "iosStep2": "Затем «На экран «Домой»»",
    "androidStep1": "Откройте меню ⋮ браузера",
    "androidStep2": "Затем «Добавить на главный экран»"
  },
  "messages": {
    "title": "Полученные сообщения",
    "empty": "Пока нет полученных сообщений.",
    "reactions": "реакция(и)"
  },
  "profile": {
    "title": "Мой профиль",
    "name": "Имя",
    "email": "Эл. почта",
    "phone": "Телефон",
    "country": "Страна",
    "language": "Язык",
    "notifications": "Получать уведомления",
    "save": "Сохранить",
    "saved": "Профиль обновлён",
    "error": "Произошла ошибка",
    "logout": "Выйти",
    "incompleteNotice": "Ваш профиль неполон. Заполните свои данные.",
    "complete": "Заполнить",
    "missingIntro": "Заполнить:",
    "password": "Пароль",
    "currentPassword": "Текущий пароль",
    "newPassword": "Новый пароль",
    "confirmPassword": "Подтвердите новый пароль",
    "changePassword": "Изменить пароль",
    "pwdSection": "Пароль для входа",
    "pwdTooShort": "Пароль должен содержать не менее 6 символов",
    "pwdMismatch": "Пароли не совпадают",
    "pwdChanged": "Пароль изменён",
    "pwdHint": "Оставьте поле «текущий пароль» пустым, если у вас его ещё не было."
  },
  "home": {
    "title": "Пламя, чтобы никогда не забыть",
    "subtitle": "Зажгите свечу от сердца в память о близком человеке. Поделитесь посланием и пригласите близких почтить память — бесплатно.",
    "cta": "Зажечь свечу",
    "ctaSub": "Дань памяти близкому",
    "ctaFree": "почтить память бесплатно",
    "stats": "Уже {{candles}} зажжённых свечей · {{messages}} посланий памяти"
  },
  "auth": {
    "title": "Присоединяйтесь к BougieDuCœur",
    "desc": "Войдите, чтобы зажигать свечи и управлять ими.",
    "google": "Продолжить с Google",
    "apple": "Продолжить с Apple",
    "appleSoon": "Вход через Apple скоро появится",
    "or": "или",
    "login": "Вход",
    "register": "Регистрация",
    "email": "Эл. почта",
    "password": "Пароль",
    "name": "Имя",
    "firstName": "Имя",
    "lastName": "Фамилия",
    "signIn": "Войти",
    "createAccount": "Создать аккаунт",
    "welcome": "Добро пожаловать",
    "accountCreated": "Аккаунт создан",
    "loginError": "Не удалось войти",
    "registerError": "Не удалось зарегистрироваться",
    "regTitle": "Создать аккаунт",
    "regSubtitle": "Присоединяйтесь к сообществу и почтите тех, кого вам не хватает.",
    "freeBadge": "Регистрация на 100% бесплатна",
    "phone": "Мобильный телефон (необязательно)",
    "termsAccept": "Я прочитал(а) и принимаю общие условия использования и правовую информацию.",
    "readTerms": "Читать общие условия использования и правовую информацию",
    "enableNotifications": "Включить уведомления",
    "continueWith": "или продолжить с",
    "alreadyMember": "Уже зарегистрированы? Войти",
    "mustAcceptTerms": "Вы должны принять условия использования",
    "noAccount": "Ещё нет аккаунта?"
  },
  "create": {
    "title": "Зажечь свечу",
    "subtitle": "Персональная дань памяти — просто.",
    "nameLabel": "Имя усопшего",
    "namePlaceholder": "напр. Мария Иванова",
    "messageLabel": "Послание памяти",
    "messagePlaceholder": "Несколько слов от сердца...",
    "durationLabel": "Дань памяти близкому человеку",
    "photoLabel": "Фото (обязательно)",
    "addPhoto": "Добавить фото",
    "birthDate": "Рождение",
    "offerDeadline": "Подтвердите предложение до {{date}}",
    "candleFreeUntil": "Свеча горит бесплатно до {{date}}",
    "offerIncentive": "Если вы подтвердите это предложение до {{end}}, ваша свеча будет гореть бесплатно до {{until}}.",
    "datesLater": "Даты рождения и смерти можно добавить после оплаты.",
    "draftRestored": "Мы сохранили данные вашей незавершённой свечи.",
    "deathDate": "Смерть",
    "previewEternal": "которая будет гореть вечно",
    "previewDuration": "длительность: {{label}}",
    "payButton": "Зажечь за {{price}}",
    "stripeNote": "Безопасная оплата через Stripe · Тестовая карта 4242 4242 4242 4242",
    "candleLit": "Свеча зажжена",
    "error": "Произошла ошибка",
    "photoTooBig": "Фото слишком большое (макс. 3 МБ)",
    "photoRequired": "Пожалуйста, добавьте фото",
    "tagline": "Пламя и послания на вечность",
    "previewFlame": "Предпросмотр пламени"
  },
  "memorial": {
    "inMemory": "В память о",
    "days": "Дни",
    "hours": "Часы",
    "minutes": "Мин",
    "seconds": "Сек",
    "extinguished": "Пламя погасло",
    "eternal": "Свеча зажжена навечно",
    "pendingPayment": "Свеча ожидает оплаты",
    "edit": "Изменить",
    "share": "Поделиться",
    "copyLink": "Копировать ссылку",
    "condolences": "Слова сочувствия",
    "yourName": "Ваше имя",
    "supportMessage": "Оставьте слова поддержки...",
    "depositFree": "Оставить сообщение бесплатно",
    "messageDeposited": "Ваше сообщение опубликовано",
    "sendError": "Не удалось отправить",
    "notFound": "Свеча не найдена",
    "relightCta": "Участвовать и продлить",
    "eternityCta": "Продлить навечно",
    "extendMore": "Продлить ещё",
    "relightTitle": "Продлить пламя",
    "relightDesc": "Выберите длительность, чтобы вновь зажечь свечу {{name}}.",
    "flameWeak": "Пламя угасает.",
    "flameExtinguished": "Пламя погасло.",
    "reviveInvite": "Зажгите её вновь и продлите этот момент.",
    "editTitle": "Редактировать дань памяти",
    "editDesc": "Обновите имя, сообщение и фото этой свечи.",
    "photo": "Фото",
    "add": "Добавить",
    "save": "Сохранить изменения",
    "messageUpdated": "Сообщение обновлено",
    "editError": "Не удалось изменить",
    "nameRequired": "Имя обязательно",
    "linkCopied": "Ссылка скопирована",
    "copiedToClipboard": "Ссылка скопирована в буфер обмена",
    "instagramCopied": "Ссылка скопирована — вставьте её в сторис или профиль Instagram",
    "firstMessage": "Оставьте сообщение первым.",
    "leaveMessage": "Оставьте сообщение",
    "leaveMessageSub": "Бесплатно, за секунды",
    "supportCountLabel": "сообщений поддержки",
    "error": "Ошибка",
    "forEternity": "Свеча на вечность",
    "findThemOn": "Найдите {{name}} в",
    "socialsTitle": "Соцсети усопшего (необязательно)",
    "socialsHint": "Добавьте официальные ссылки — они появятся на странице.",
    "officialSite": "Официальный сайт",
    "shareInvite": "Зажгите свечу и оставьте бесплатное сообщение 🕯️"
  },
  "mycandles": {
    "title": "Мои свечи",
    "new": "Новая",
    "active": "Активна",
    "extinguished": "Погасла",
    "eternal": "Вечная",
    "pending": "Ожидает оплаты",
    "relights": "возобновлений",
    "collected": "собрано",
    "empty": "Вы ещё не зажгли ни одной свечи.",
    "lightCandle": "Зажечь свечу",
    "pay": "Оплатить",
    "revive": "Возобновить",
    "dialogLightTitle": "Зажечь свечу",
    "dialogRelightTitle": "Продлить пламя",
    "chooseDuration": "Выберите длительность",
    "chooseDurationFor": "Выберите длительность для {{name}}.",
    "light": "Зажечь",
    "prolong": "Продлить",
    "updated": "Свеча обновлена",
    "changePhoto": "Изменить фото",
    "groupShort": "Группа",
    "newFull": "Новая свеча",
    "messagesCount": "Количество сообщений"
  },
  "family": {
    "title": "Семейные воспоминания",
    "subtitle": "Соберите сообщения и фотографии нескольких свечей в одном месте.",
    "button": "Семейные воспоминания",
    "newGroup": "Новая группа",
    "editGroup": "Изменить группу",
    "createGroup": "Создать группу",
    "groupName": "Название группы",
    "groupNamePlaceholder": "Напр. Мои родители, Семья Ивановых…",
    "selectCandles": "Выберите свечи для группы",
    "noCandles": "У вас пока нет свечей для группы.",
    "empty": "Пока нет групп. Создайте одну, чтобы собрать воспоминания.",
    "open": "Открыть",
    "share": "Поделиться",
    "edit": "Изменить",
    "delete": "Удалить",
    "save": "Сохранить",
    "deleteConfirm": "Удалить эту группу? Свечи и их сообщения не будут удалены.",
    "linkCopied": "Ссылка скопирована — отправьте её семье",
    "saved": "Группа сохранена",
    "deleted": "Группа удалена",
    "photos": "Фото",
    "messages": "Сообщения",
    "noPhotos": "Пока нет фотографий.",
    "noMessages": "Пока нет сообщений.",
    "sharedTitle": "Общие воспоминания",
    "backToGroups": "Назад к группам",
    "selectAtLeastOne": "Выберите хотя бы одну свечу",
    "candlesCount_one": "{{count}} свеча",
    "candlesCount_other": "{{count}} свечей",
    "photosCount_one": "{{count}} фото",
    "photosCount_other": "{{count}} фото",
    "messagesCount_one": "{{count}} сообщение",
    "messagesCount_other": "{{count}} сообщений",
    "for": "для",
    "inviteTitle": "Почтите и вы их память",
    "inviteText": "Войдите, чтобы оставить свои фотографии и слова на одной из свечей.",
    "contributeTitle": "Оставьте сообщение для семьи",
    "contributeSub": "Ваше сообщение и фотографии будут добавлены к каждой свече семьи.",
    "yourName": "Ваше имя",
    "yourMessage": "Ваше сообщение…",
    "connectForPhotos": "Войдите, чтобы добавить фото",
    "photosMax": "макс. 10 фото",
    "send": "Опубликовать",
    "moderationNote": "Публикуется сразу на каждой свече семьи.",
    "publishedNotice": "Спасибо, ваше сообщение опубликовано 🕯️",
    "familyLabel": "Вся семья",
    "deletePhoto": "Удалить фото",
    "editMessage": "Изменить сообщение",
    "connected": "Вы вошли в систему",
    "coverPhoto": "Обложка (необязательно)",
    "addCover": "Добавить фото",
    "follow": "Следить за группой",
    "following": "Вы подписаны",
    "followed": "Вы подписаны ✓ Вас уведомят о новых воспоминаниях",
    "unfollowed": "Вы отписались",
    "followHint": "Зарегистрируйтесь, чтобы следить за этой группой и получать уведомления о каждом новом воспоминании.",
    "followedGroups": "Отслеживаемые группы"
  },
  "payment": {
    "confirming": "Подтверждение оплаты...",
    "flameLit": "Пламя зажжено",
    "redirecting": "Переход к мемориалу...",
    "timeout": "Платёж обрабатывается. Проверьте «Мои свечи» через мгновение.",
    "cancelled": "Платёж отменён",
    "noCharge": "Сумма не была списана.",
    "backToCandles": "Вернуться к моим свечам"
  },
  "plans": {
    "decouverte": "Знакомство",
    "1mois": "1 месяц",
    "6mois": "6 месяцев",
    "1an": "1 год",
    "eternite": "Навечно"
  },
  "conditions": {
    "back": "Назад к регистрации",
    "title": "Условия использования и Политика конфиденциальности",
    "disclaimer": "Сокращённая версия для интеграции в приложение. Предназначена для информирования пользователей. Перед публикацией рекомендуется независимая юридическая проверка.",
    "s1t": "1. Издатель",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. Принятие",
    "s2c": "Создавая учётную запись или используя приложение, вы принимаете настоящие условия. Если вы их не принимаете, вы не должны пользоваться сервисом.",
    "s3t": "3. Сервис",
    "s3c": "BougieDuCœur позволяет создавать цифровые посвящения, зажигать виртуальные свечи, публиковать сообщения и фотографии и пользоваться предлагаемыми услугами.",
    "s4t": "4. Учётная запись",
    "s4c": "Вы гарантируете точность предоставленной информации и несёте ответственность за конфиденциальность своих учётных данных.",
    "s5t": "5. Контент",
    "s5c": "Вы сохраняете права на свой контент, но предоставляете BougieDuCœur неисключительную лицензию, необходимую для его размещения, отображения и распространения в рамках сервиса.",
    "s6t": "6. Запреты",
    "s6c": "Запрещён незаконный, разжигающий ненависть, клеветнический или мошеннический контент, а также нарушающий авторские права, право на изображение, частную жизнь или память усопших. Запрещены фальшивые посвящения, кража личности и ложные правообладатели.",
    "s7t": "7. Модерация",
    "s7c": "О любом контенте можно сообщить. BougieDuCœur может удалить контент, приостановить или удалить учётную запись в случае нарушения настоящих условий.",
    "s8t": "8. Семьи",
    "s8c": "Семьи и правообладатели могут запросить изменение или удаление мемориала после проверки подтверждающих документов.",
    "s9t": "9. Персональные данные",
    "s9c": "Ваши данные (имя, e-mail, телефон, страна) используются для управления учётной записью, свечами и уведомлениями. Они не продаются. В соответствии с GDPR вы имеете право на доступ, исправление и удаление, написав на contact@bougieducoeur.com."
  }
};

const el = {
  "brand": {
    "part1": "Κερί",
    "part2": "ΤηςΚαρδιάς"
  },
  "header": {
    "myCandles": "Τα κεριά μου",
    "admin": "Διαχ.",
    "notifications": "Ειδοποιήσεις",
    "noNotifications": "Καμία ειδοποίηση",
    "viewCandle": "Δείτε το κερί"
  },
  "nav": {
    "home": "Αρχική",
    "myCandles": "Τα κεριά μου",
    "messages": "Μηνύματα",
    "profile": "Προφίλ"
  },
  "install": {
    "title": "Εγκατάσταση BougieDuCœur",
    "desc": "Προσθέστε το εικονίδιο στην αρχική οθόνη για γρήγορη πρόσβαση, σαν εφαρμογή.",
    "button": "Εγκατάσταση εφαρμογής",
    "later": "Αργότερα",
    "iosStep1": "Πατήστε Κοινή χρήση",
    "iosStep2": "Μετά «Στην αρχική οθόνη»",
    "androidStep1": "Ανοίξτε το μενού ⋮ του browser",
    "androidStep2": "Μετά «Προσθήκη στην αρχική οθόνη»"
  },
  "messages": {
    "title": "Ληφθέντα μηνύματα",
    "empty": "Δεν έχετε λάβει μηνύματα ακόμη.",
    "reactions": "αντίδραση(εις)"
  },
  "profile": {
    "title": "Το προφίλ μου",
    "name": "Όνομα",
    "email": "Email",
    "phone": "Κινητό",
    "country": "Χώρα",
    "language": "Γλώσσα",
    "notifications": "Λήψη ειδοποιήσεων",
    "save": "Αποθήκευση",
    "saved": "Το προφίλ ενημερώθηκε",
    "error": "Παρουσιάστηκε σφάλμα",
    "logout": "Αποσύνδεση",
    "incompleteNotice": "Το προφίλ σας είναι ελλιπές. Συμπληρώστε τα στοιχεία σας.",
    "complete": "Συμπλήρωση",
    "missingIntro": "Προς συμπλήρωση:",
    "password": "Κωδικός πρόσβασης",
    "currentPassword": "Τρέχων κωδικός",
    "newPassword": "Νέος κωδικός",
    "confirmPassword": "Επιβεβαίωση νέου κωδικού",
    "changePassword": "Αλλαγή κωδικού",
    "pwdSection": "Κωδικός σύνδεσης",
    "pwdTooShort": "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες",
    "pwdMismatch": "Οι κωδικοί δεν ταιριάζουν",
    "pwdChanged": "Ο κωδικός άλλαξε",
    "pwdHint": "Αφήστε κενό το πεδίο «τρέχων κωδικός» αν δεν είχατε ακόμη."
  },
  "home": {
    "title": "Μια φλόγα για να μην ξεχάσουμε ποτέ",
    "subtitle": "Ανάψτε ένα κερί από καρδιάς στη μνήμη ενός αγαπημένου προσώπου. Μοιραστείτε ένα μήνυμα και καλέστε τους δικούς σας να θυμηθούν — Δωρεάν.",
    "cta": "Ανάψτε ένα κερί",
    "ctaSub": "Φόρος τιμής σε ένα αγαπημένο πρόσωπο",
    "ctaFree": "να θυμηθείτε δωρεάν",
    "stats": "Ήδη {{candles}} αναμμένα κεριά · {{messages}} μηνύματα μνήμης"
  },
  "auth": {
    "title": "Γίνετε μέλος του BougieDuCœur",
    "desc": "Συνδεθείτε για να ανάβετε και να διαχειρίζεστε τα κεριά σας.",
    "google": "Συνέχεια με Google",
    "apple": "Συνέχεια με Apple",
    "appleSoon": "Η σύνδεση Apple έρχεται σύντομα",
    "or": "ή",
    "login": "Σύνδεση",
    "register": "Εγγραφή",
    "email": "Email",
    "password": "Κωδικός",
    "name": "Όνομα",
    "firstName": "Όνομα",
    "lastName": "Επώνυμο",
    "signIn": "Σύνδεση",
    "createAccount": "Δημιουργία λογαριασμού",
    "welcome": "Καλώς ήρθατε",
    "accountCreated": "Ο λογαριασμός δημιουργήθηκε",
    "loginError": "Αδυναμία σύνδεσης",
    "registerError": "Αδυναμία εγγραφής",
    "regTitle": "Δημιουργία λογαριασμού",
    "regSubtitle": "Γίνετε μέλος της κοινότητας και τιμήστε αυτούς που σας λείπουν.",
    "freeBadge": "100% δωρεάν εγγραφή",
    "phone": "Κινητό τηλέφωνο (προαιρετικό)",
    "termsAccept": "Διάβασα και αποδέχομαι τους γενικούς όρους χρήσης και τη νομική σημείωση.",
    "readTerms": "Διαβάστε τους γενικούς όρους χρήσης και τη νομική σημείωση",
    "enableNotifications": "Ενεργοποίηση ειδοποιήσεων",
    "continueWith": "ή συνεχίστε με",
    "alreadyMember": "Έχετε ήδη λογαριασμό; Σύνδεση",
    "mustAcceptTerms": "Πρέπει να αποδεχτείτε τους όρους χρήσης",
    "noAccount": "Δεν έχετε λογαριασμό ακόμη;"
  },
  "create": {
    "title": "Ανάψτε ένα κερί",
    "subtitle": "Ένας εξατομικευμένος φόρος τιμής, με απλότητα.",
    "nameLabel": "Όνομα του εκλιπόντος",
    "namePlaceholder": "π.χ. Μαρία Παπαδοπούλου",
    "messageLabel": "Μήνυμα φόρου τιμής",
    "messagePlaceholder": "Λίγα λόγια από την καρδιά...",
    "durationLabel": "Ένας φόρος τιμής σε ένα αγαπημένο πρόσωπο",
    "photoLabel": "Φωτογραφία (υποχρεωτική)",
    "addPhoto": "Προσθήκη φωτογραφίας",
    "birthDate": "Γέννηση",
    "offerDeadline": "Επιβεβαιώστε την προσφορά πριν από τις {{date}}",
    "candleFreeUntil": "Κερί αναμμένο δωρεάν έως τις {{date}}",
    "offerIncentive": "Αν επιβεβαιώσετε αυτή την προσφορά πριν από τις {{end}}, το κερί σας θα παραμείνει αναμμένο δωρεάν έως τις {{until}}.",
    "datesLater": "Μπορείτε να προσθέσετε τις ημερομηνίες γέννησης και θανάτου μετά την πληρωμή.",
    "draftRestored": "Κρατήσαμε τα στοιχεία του κεριού που δεν ολοκληρώσατε.",
    "deathDate": "Θάνατος",
    "previewEternal": "που θα καίει για πάντα",
    "previewDuration": "διάρκεια: {{label}}",
    "payButton": "Ανάψτε για {{price}}",
    "stripeNote": "Ασφαλής πληρωμή μέσω Stripe · Δοκιμαστική κάρτα 4242 4242 4242 4242",
    "candleLit": "Το κερί άναψε",
    "error": "Παρουσιάστηκε σφάλμα",
    "photoTooBig": "Πολύ μεγάλη φωτογραφία (μέγ. 3 MB)",
    "photoRequired": "Προσθέστε μια φωτογραφία",
    "tagline": "Μια Φλόγα & Μηνύματα για την αιωνιότητα",
    "previewFlame": "Προεπισκόπηση φλόγας"
  },
  "memorial": {
    "inMemory": "Στη μνήμη του/της",
    "days": "Ημέρες",
    "hours": "Ώρες",
    "minutes": "Λεπ",
    "seconds": "Δευτ",
    "extinguished": "Η φλόγα έσβησε",
    "eternal": "Κερί αναμμένο για την αιωνιότητα",
    "pendingPayment": "Κερί σε αναμονή πληρωμής",
    "edit": "Επεξεργασία",
    "share": "Κοινή χρήση",
    "copyLink": "Αντιγραφή συνδέσμου",
    "condolences": "Μηνύματα συμπαράστασης",
    "yourName": "Το όνομά σας",
    "supportMessage": "Αφήστε ένα μήνυμα στήριξης...",
    "depositFree": "Αφήστε ένα μήνυμα δωρεάν",
    "messageDeposited": "Το μήνυμά σας δημοσιεύτηκε",
    "sendError": "Αδυναμία αποστολής",
    "notFound": "Το κερί δεν βρέθηκε",
    "relightCta": "Συμμετοχή & Παράταση",
    "eternityCta": "Παράταση για την αιωνιότητα",
    "extendMore": "Περισσότερη παράταση",
    "relightTitle": "Παρατείνετε τη φλόγα",
    "relightDesc": "Επιλέξτε διάρκεια για να ξανανάψετε το κερί του/της {{name}}.",
    "flameWeak": "Η φλόγα εξασθενεί.",
    "flameExtinguished": "Η φλόγα έσβησε.",
    "reviveInvite": "Ξανανάψτε το και παρατείνετε αυτή τη στιγμή.",
    "editTitle": "Επεξεργασία φόρου τιμής",
    "editDesc": "Ενημερώστε το όνομα, το μήνυμα και τη φωτογραφία αυτού του κεριού.",
    "photo": "Φωτογραφία",
    "add": "Προσθήκη",
    "save": "Αποθήκευση αλλαγών",
    "messageUpdated": "Το μήνυμα ενημερώθηκε",
    "editError": "Αδυναμία τροποποίησης",
    "nameRequired": "Το όνομα απαιτείται",
    "linkCopied": "Ο σύνδεσμος αντιγράφηκε",
    "copiedToClipboard": "Ο σύνδεσμος αντιγράφηκε στο πρόχειρο",
    "instagramCopied": "Ο σύνδεσμος αντιγράφηκε — επικολλήστε τον στο story ή στο bio σας στο Instagram",
    "firstMessage": "Γίνετε ο πρώτος που θα αφήσει μήνυμα.",
    "leaveMessage": "Αφήστε ένα μήνυμα",
    "leaveMessageSub": "Δωρεάν, σε δευτερόλεπτα",
    "supportCountLabel": "μηνύματα στήριξης",
    "error": "Σφάλμα",
    "forEternity": "Ένα κερί για την αιωνιότητα",
    "findThemOn": "Βρείτε τον/την {{name}} στο",
    "socialsTitle": "Κοινωνικά δίκτυα του εκλιπόντος (προαιρετικό)",
    "socialsHint": "Προσθέστε τους επίσημους συνδέσμους — θα εμφανιστούν στη σελίδα.",
    "officialSite": "Επίσημος ιστότοπος",
    "shareInvite": "Ανάψτε ένα κερί και αφήστε ένα δωρεάν μήνυμα 🕯️"
  },
  "mycandles": {
    "title": "Τα κεριά μου",
    "new": "Νέο",
    "active": "Ενεργό",
    "extinguished": "Σβησμένο",
    "eternal": "Αιώνιο",
    "pending": "Σε αναμονή πληρωμής",
    "relights": "αναζωπυρώσεις",
    "collected": "συγκεντρώθηκαν",
    "empty": "Δεν έχετε ανάψει κερί ακόμη.",
    "lightCandle": "Ανάψτε ένα κερί",
    "pay": "Πληρωμή",
    "revive": "Αναζωπύρωση",
    "dialogLightTitle": "Ανάψτε το κερί",
    "dialogRelightTitle": "Παρατείνετε τη φλόγα",
    "chooseDuration": "Επιλέξτε διάρκεια",
    "chooseDurationFor": "Επιλέξτε διάρκεια για {{name}}.",
    "light": "Ανάψτε",
    "prolong": "Παρατείνετε",
    "updated": "Το κερί ενημερώθηκε",
    "changePhoto": "Αλλαγή φωτογραφίας",
    "groupShort": "Ομάδα",
    "newFull": "Νέο κερί",
    "messagesCount": "Αριθμός μηνυμάτων"
  },
  "family": {
    "title": "Οικογενειακές αναμνήσεις",
    "subtitle": "Συγκεντρώστε τα μηνύματα και τις φωτογραφίες πολλών κεριών σε ένα μέρος.",
    "button": "Οικογενειακές αναμνήσεις",
    "newGroup": "Νέα ομάδα",
    "editGroup": "Επεξεργασία ομάδας",
    "createGroup": "Δημιουργία ομάδας",
    "groupName": "Όνομα ομάδας",
    "groupNamePlaceholder": "Π.χ. Οι γονείς μου, Οικογένεια Παπαδοπούλου…",
    "selectCandles": "Επιλέξτε τα κεριά για ομαδοποίηση",
    "noCandles": "Δεν έχετε ακόμη κερί για ομαδοποίηση.",
    "empty": "Καμία ομάδα ακόμη. Δημιουργήστε μία για να συγκεντρώσετε τις αναμνήσεις σας.",
    "open": "Άνοιγμα",
    "share": "Κοινοποίηση",
    "edit": "Επεξεργασία",
    "delete": "Διαγραφή",
    "save": "Αποθήκευση",
    "deleteConfirm": "Διαγραφή αυτής της ομάδας; Τα κεριά και τα μηνύματά τους δεν διαγράφονται.",
    "linkCopied": "Ο σύνδεσμος αντιγράφηκε — στείλτε τον στην οικογένειά σας",
    "saved": "Η ομάδα αποθηκεύτηκε",
    "deleted": "Η ομάδα διαγράφηκε",
    "photos": "Φωτογραφίες",
    "messages": "Μηνύματα",
    "noPhotos": "Καμία φωτογραφία ακόμη.",
    "noMessages": "Κανένα μήνυμα ακόμη.",
    "sharedTitle": "Κοινές αναμνήσεις",
    "backToGroups": "Επιστροφή στις ομάδες",
    "selectAtLeastOne": "Επιλέξτε τουλάχιστον ένα κερί",
    "candlesCount_one": "{{count}} κερί",
    "candlesCount_other": "{{count}} κεριά",
    "photosCount_one": "{{count}} φωτογραφία",
    "photosCount_other": "{{count}} φωτογραφίες",
    "messagesCount_one": "{{count}} μήνυμα",
    "messagesCount_other": "{{count}} μηνύματα",
    "for": "για",
    "inviteTitle": "Τιμήστε κι εσείς τη μνήμη τους",
    "inviteText": "Συνδεθείτε για να αφήσετε τις δικές σας φωτογραφίες και μαρτυρίες σε ένα από τα κεριά.",
    "contributeTitle": "Αφήστε ένα μήνυμα για την οικογένεια",
    "contributeSub": "Το μήνυμα και οι φωτογραφίες σας θα προστεθούν σε κάθε κερί της οικογένειας.",
    "yourName": "Το όνομά σας",
    "yourMessage": "Το μήνυμά σας…",
    "connectForPhotos": "Συνδεθείτε για να προσθέσετε φωτογραφίες",
    "photosMax": "10 φωτογραφίες μέγιστο",
    "send": "Δημοσίευση",
    "moderationNote": "Δημοσιεύεται αμέσως σε κάθε κερί της οικογένειας.",
    "publishedNotice": "Ευχαριστούμε, το μήνυμά σας δημοσιεύτηκε 🕯️",
    "familyLabel": "Όλη η οικογένεια",
    "deletePhoto": "Διαγραφή φωτογραφίας",
    "editMessage": "Επεξεργασία μηνύματος",
    "connected": "Έχετε συνδεθεί",
    "coverPhoto": "Φωτογραφία εξωφύλλου (προαιρετικό)",
    "addCover": "Προσθήκη φωτογραφίας",
    "follow": "Ακολουθήστε αυτή την ομάδα",
    "following": "Ακολουθείτε",
    "followed": "Ακολουθείτε ✓ Θα ειδοποιείστε για νέες αναμνήσεις",
    "unfollowed": "Δεν ακολουθείτε πλέον",
    "followHint": "Εγγραφείτε για να ακολουθήσετε αυτή την ομάδα και να ειδοποιείστε σε κάθε νέα ανάμνηση.",
    "followedGroups": "Ομάδες που ακολουθείτε"
  },
  "payment": {
    "confirming": "Επιβεβαίωση της πληρωμής σας...",
    "flameLit": "Η φλόγα είναι αναμμένη",
    "redirecting": "Ανακατεύθυνση στο μνημείο...",
    "timeout": "Η πληρωμή επεξεργάζεται. Ελέγξτε «Τα κεριά μου» σε λίγο.",
    "cancelled": "Η πληρωμή ακυρώθηκε",
    "noCharge": "Δεν χρεώθηκε κανένα ποσό.",
    "backToCandles": "Επιστροφή στα κεριά μου"
  },
  "plans": {
    "decouverte": "Γνωριμία",
    "1mois": "1 μήνας",
    "6mois": "6 μήνες",
    "1an": "1 έτος",
    "eternite": "Για την αιωνιότητα"
  },
  "conditions": {
    "back": "Επιστροφή στην εγγραφή",
    "title": "Όροι Χρήσης και Πολιτική Απορρήτου",
    "disclaimer": "Συνοπτική έκδοση για ενσωμάτωση στην εφαρμογή. Προορίζεται για την ενημέρωση των χρηστών. Συνιστάται ανεξάρτητος νομικός έλεγχος πριν από τη δημοσίευση.",
    "s1t": "1. Εκδότης",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. Αποδοχή",
    "s2c": "Δημιουργώντας λογαριασμό ή χρησιμοποιώντας την εφαρμογή, αποδέχεστε τους παρόντες όρους. Αν δεν τους αποδέχεστε, δεν πρέπει να χρησιμοποιείτε την υπηρεσία.",
    "s3t": "3. Υπηρεσία",
    "s3c": "Το BougieDuCœur σας επιτρέπει να δημιουργείτε ψηφιακά αφιερώματα, να ανάβετε εικονικά κεριά, να δημοσιεύετε μηνύματα και φωτογραφίες και να χρησιμοποιείτε τις προσφερόμενες υπηρεσίες.",
    "s4t": "4. Λογαριασμός",
    "s4c": "Εγγυάστε την ακρίβεια των στοιχείων που παρέχετε και είστε υπεύθυνοι για την εμπιστευτικότητα των διαπιστευτηρίων σας.",
    "s5t": "5. Περιεχόμενο",
    "s5c": "Διατηρείτε τα δικαιώματα στο περιεχόμενό σας αλλά παραχωρείτε στο BougieDuCœur μη αποκλειστική άδεια απαραίτητη για τη φιλοξενία, προβολή και διάδοσή του στο πλαίσιο της υπηρεσίας.",
    "s6t": "6. Απαγορεύσεις",
    "s6c": "Απαγορεύεται το παράνομο, μισαλλόδοξο, δυσφημιστικό ή δόλιο περιεχόμενο, καθώς και αυτό που παραβιάζει πνευματικά δικαιώματα, δικαίωμα στην εικόνα, ιδιωτικότητα ή τη μνήμη των θανόντων. Απαγορεύονται τα ψεύτικα αφιερώματα, η κλοπή ταυτότητας και οι ψευδείς δικαιούχοι.",
    "s7t": "7. Εποπτεία",
    "s7c": "Οποιοδήποτε περιεχόμενο μπορεί να αναφερθεί. Το BougieDuCœur μπορεί να αφαιρέσει περιεχόμενο, να αναστείλει ή να διαγράψει λογαριασμό σε περίπτωση παραβίασης των παρόντων όρων.",
    "s8t": "8. Οικογένειες",
    "s8c": "Οι οικογένειες και οι δικαιούχοι μπορούν να ζητήσουν την τροποποίηση ή διαγραφή ενός μνημείου μετά την επαλήθευση των δικαιολογητικών.",
    "s9t": "9. Προσωπικά δεδομένα",
    "s9c": "Τα δεδομένα σας (όνομα, e-mail, τηλέφωνο, χώρα) χρησιμοποιούνται για τη διαχείριση του λογαριασμού, των κεριών και των ειδοποιήσεων. Δεν πωλούνται. Σύμφωνα με τον GDPR, έχετε δικαίωμα πρόσβασης, διόρθωσης και διαγραφής γράφοντας στο contact@bougieducoeur.com."
  }
};

const hi = {
  "brand": {
    "part1": "हृदय",
    "part2": "दीप"
  },
  "header": {
    "myCandles": "मेरी मोमबत्तियाँ",
    "admin": "एडमिन",
    "notifications": "सूचनाएँ",
    "noNotifications": "कोई सूचना नहीं",
    "viewCandle": "मोमबत्ती देखें"
  },
  "nav": {
    "home": "होम",
    "myCandles": "मेरी मोमबत्तियाँ",
    "messages": "संदेश",
    "profile": "प्रोफ़ाइल"
  },
  "install": {
    "title": "BougieDuCœur इंस्टॉल करें",
    "desc": "किसी ऐप की तरह त्वरित पहुँच के लिए आइकन को अपनी होम स्क्रीन पर जोड़ें।",
    "button": "ऐप इंस्टॉल करें",
    "later": "बाद में",
    "iosStep1": "शेयर पर टैप करें",
    "iosStep2": "फिर \"Add to Home Screen\"",
    "androidStep1": "ब्राउज़र का ⋮ मेनू खोलें",
    "androidStep2": "फिर \"Add to Home screen\""
  },
  "messages": {
    "title": "प्राप्त संदेश",
    "empty": "अभी तक कोई संदेश प्राप्त नहीं हुआ।",
    "reactions": "प्रतिक्रिया"
  },
  "profile": {
    "title": "मेरी प्रोफ़ाइल",
    "name": "नाम",
    "email": "ईमेल",
    "phone": "मोबाइल",
    "country": "देश",
    "language": "भाषा",
    "notifications": "सूचनाएँ प्राप्त करें",
    "save": "सहेजें",
    "saved": "प्रोफ़ाइल अपडेट हुई",
    "error": "एक त्रुटि हुई",
    "logout": "लॉग आउट",
    "incompleteNotice": "आपकी प्रोफ़ाइल अधूरी है। कृपया अपनी जानकारी पूरी करें।",
    "complete": "पूरा करें",
    "missingIntro": "पूरा करना है:",
    "password": "पासवर्ड",
    "currentPassword": "वर्तमान पासवर्ड",
    "newPassword": "नया पासवर्ड",
    "confirmPassword": "नया पासवर्ड पुष्टि करें",
    "changePassword": "पासवर्ड बदलें",
    "pwdSection": "लॉगिन पासवर्ड",
    "pwdTooShort": "पासवर्ड में कम से कम 6 अक्षर होने चाहिए",
    "pwdMismatch": "पासवर्ड मेल नहीं खाते",
    "pwdChanged": "पासवर्ड बदल गया",
    "pwdHint": "यदि आपके पास अभी तक पासवर्ड नहीं था तो «वर्तमान पासवर्ड» फ़ील्ड खाली छोड़ दें।"
  },
  "home": {
    "title": "एक लौ जिसे कभी न भूलें",
    "subtitle": "किसी प्रियजन की स्मृति में दिल से एक मोमबत्ती जलाएँ। एक संदेश साझा करें और अपने प्रियजनों को नि:शुल्क श्रद्धांजलि देने के लिए आमंत्रित करें।",
    "cta": "मोमबत्ती जलाएँ",
    "ctaSub": "किसी प्रियजन को श्रद्धांजलि",
    "ctaFree": "नि:शुल्क श्रद्धांजलि दें",
    "stats": "अब तक {{candles}} मोमबत्तियाँ जलीं · {{messages}} स्मृति संदेश"
  },
  "auth": {
    "title": "BougieDuCœur से जुड़ें",
    "desc": "मोमबत्तियाँ जलाने और प्रबंधित करने के लिए साइन इन करें।",
    "google": "Google के साथ जारी रखें",
    "apple": "Apple के साथ जारी रखें",
    "appleSoon": "Apple साइन-इन जल्द आ रहा है",
    "or": "या",
    "login": "लॉग इन",
    "register": "साइन अप",
    "email": "ईमेल",
    "password": "पासवर्ड",
    "name": "नाम",
    "firstName": "पहला नाम",
    "lastName": "अंतिम नाम",
    "signIn": "साइन इन",
    "createAccount": "मेरा खाता बनाएँ",
    "welcome": "स्वागत है",
    "accountCreated": "खाता बन गया",
    "loginError": "साइन इन नहीं हो सका",
    "registerError": "साइन अप नहीं हो सका",
    "regTitle": "खाता बनाएँ",
    "regSubtitle": "समुदाय से जुड़ें और जिन्हें आप याद करते हैं उन्हें श्रद्धांजलि दें।",
    "freeBadge": "100% नि:शुल्क पंजीकरण",
    "phone": "मोबाइल फ़ोन (वैकल्पिक)",
    "termsAccept": "मैंने सामान्य उपयोग की शर्तें और कानूनी सूचना पढ़ ली है और स्वीकार करता/करती हूँ।",
    "readTerms": "सामान्य उपयोग की शर्तें और कानूनी सूचना पढ़ें",
    "enableNotifications": "सूचनाएँ सक्षम करें",
    "continueWith": "या इसके साथ जारी रखें",
    "alreadyMember": "पहले से पंजीकृत? लॉग इन करें",
    "mustAcceptTerms": "आपको उपयोग की शर्तें स्वीकार करनी होंगी",
    "noAccount": "अभी तक खाता नहीं है?"
  },
  "create": {
    "title": "मोमबत्ती जलाएँ",
    "subtitle": "एक व्यक्तिगत श्रद्धांजलि, सरलता से।",
    "nameLabel": "दिवंगत का नाम",
    "namePlaceholder": "उदा. सीता शर्मा",
    "messageLabel": "श्रद्धांजलि संदेश",
    "messagePlaceholder": "दिल से कुछ शब्द...",
    "durationLabel": "एक प्रियजन को श्रद्धांजलि",
    "photoLabel": "फ़ोटो (आवश्यक)",
    "addPhoto": "जोड़ें",
    "previewEternal": "जो सदा जलती रहेगी",
    "previewDuration": "अवधि: {{label}}",
    "payButton": "{{price}} में जलाएँ",
    "stripeNote": "Stripe के माध्यम से सुरक्षित भुगतान · टेस्ट कार्ड 4242 4242 4242 4242",
    "candleLit": "मोमबत्ती जल गई",
    "error": "एक त्रुटि हुई",
    "photoTooBig": "फ़ोटो बहुत बड़ी है (अधिकतम 3 MB)",
    "photoRequired": "कृपया एक फ़ोटो जोड़ें",
    "tagline": "अनंत काल के लिए एक लौ और संदेश",
    "previewFlame": "लौ का पूर्वावलोकन",
    "birthDate": "जन्म",
    "offerDeadline": "इस ऑफ़र की पुष्टि {{date}} से पहले करें",
    "candleFreeUntil": "{{date}} तक मोमबत्ती निःशुल्क जलती रहेगी",
    "offerIncentive": "यदि आप इस ऑफ़र की पुष्टि {{end}} से पहले करते हैं, तो आपकी मोमबत्ती {{until}} तक निःशुल्क जलती रहेगी।",
    "datesLater": "आप भुगतान के बाद जन्म और मृत्यु की तिथियाँ जोड़ सकते हैं।",
    "draftRestored": "हमने आपकी अधूरी मोमबत्ती की जानकारी सहेज ली है।",
    "deathDate": "मृत्यु"
  },
  "memorial": {
    "inMemory": "की स्मृति में",
    "days": "दिन",
    "hours": "घंटे",
    "minutes": "मिनट",
    "seconds": "सेकंड",
    "extinguished": "लौ बुझ गई है",
    "eternal": "अनंत काल के लिए जलती मोमबत्ती",
    "pendingPayment": "मोमबत्ती भुगतान की प्रतीक्षा में",
    "edit": "संपादित करें",
    "share": "साझा करें",
    "copyLink": "लिंक कॉपी करें",
    "condolences": "सहानुभूति संदेश",
    "yourName": "आपका नाम",
    "supportMessage": "समर्थन का संदेश छोड़ें...",
    "depositFree": "नि:शुल्क संदेश छोड़ें",
    "messageDeposited": "आपका संदेश पोस्ट हो गया है",
    "sendError": "भेजा नहीं जा सका",
    "notFound": "मोमबत्ती नहीं मिली",
    "relightCta": "भाग लें और बढ़ाएँ",
    "eternityCta": "अनंत काल के लिए बढ़ाएँ",
    "extendMore": "और बढ़ाएँ",
    "relightTitle": "लौ को बढ़ाएँ",
    "relightDesc": "{{name}} की मोमबत्ती फिर से जलाने के लिए एक अवधि चुनें।",
    "flameWeak": "लौ मंद हो रही है।",
    "flameExtinguished": "लौ बुझ गई है।",
    "reviveInvite": "इसे फिर से जलाएँ और इस पल को बढ़ाएँ।",
    "editTitle": "श्रद्धांजलि संपादित करें",
    "editDesc": "इस मोमबत्ती का नाम, संदेश और फ़ोटो अपडेट करें।",
    "photo": "फ़ोटो",
    "add": "जोड़ें",
    "save": "परिवर्तन सहेजें",
    "messageUpdated": "संदेश अपडेट हुआ",
    "editError": "संशोधन नहीं हो सका",
    "nameRequired": "नाम आवश्यक है",
    "linkCopied": "लिंक कॉपी हुआ",
    "copiedToClipboard": "लिंक क्लिपबोर्ड पर कॉपी हुआ",
    "instagramCopied": "लिंक कॉपी हुआ — इसे अपनी Instagram स्टोरी या बायो में पेस्ट करें",
    "firstMessage": "संदेश छोड़ने वाले पहले व्यक्ति बनें।",
    "leaveMessage": "एक संदेश छोड़ें",
    "leaveMessageSub": "नि:शुल्क, कुछ ही सेकंड में",
    "supportCountLabel": "समर्थन संदेश",
    "error": "त्रुटि",
    "forEternity": "अनंत काल के लिए एक मोमबत्ती",
    "findThemOn": "{{name}} को यहाँ खोजें",
    "socialsTitle": "दिवंगत के सोशल मीडिया (वैकल्पिक)",
    "socialsHint": "आधिकारिक लिंक जोड़ें — वे पृष्ठ पर दिखाई देंगे।",
    "officialSite": "आधिकारिक साइट",
    "shareInvite": "एक मोमबत्ती जलाएँ और मुफ़्त संदेश छोड़ें 🕯️"
  },
  "mycandles": {
    "title": "मेरी मोमबत्तियाँ",
    "new": "नई",
    "active": "सक्रिय",
    "extinguished": "बुझी हुई",
    "eternal": "शाश्वत",
    "pending": "भुगतान की प्रतीक्षा में",
    "relights": "पुनः प्रज्वलन",
    "collected": "एकत्रित",
    "empty": "आपने अभी तक कोई मोमबत्ती नहीं जलाई है।",
    "lightCandle": "मोमबत्ती जलाएँ",
    "pay": "भुगतान करें",
    "revive": "फिर से जलाएँ",
    "dialogLightTitle": "मोमबत्ती जलाएँ",
    "dialogRelightTitle": "लौ को बढ़ाएँ",
    "chooseDuration": "अवधि चुनें",
    "chooseDurationFor": "{{name}} के लिए अवधि चुनें।",
    "light": "जलाएँ",
    "prolong": "बढ़ाएँ",
    "updated": "मोमबत्ती अपडेट हुई",
    "changePhoto": "फ़ोटो बदलें",
    "groupShort": "समूह",
    "newFull": "नई मोमबत्ती",
    "messagesCount": "संदेशों की संख्या"
  },
  "family": {
    "title": "पारिवारिक यादें",
    "subtitle": "कई मोमबत्तियों के संदेश और तस्वीरें एक ही जगह इकट्ठा करें।",
    "button": "पारिवारिक यादें",
    "newGroup": "नया समूह",
    "editGroup": "समूह संपादित करें",
    "createGroup": "समूह बनाएँ",
    "groupName": "समूह का नाम",
    "groupNamePlaceholder": "जैसे मेरे माता-पिता, शर्मा परिवार…",
    "selectCandles": "समूह बनाने के लिए मोमबत्तियाँ चुनें",
    "noCandles": "अभी आपके पास समूह बनाने के लिए कोई मोमबत्ती नहीं है।",
    "empty": "अभी कोई समूह नहीं। अपनी यादें इकट्ठा करने के लिए एक बनाएँ।",
    "open": "खोलें",
    "share": "साझा करें",
    "edit": "संपादित करें",
    "delete": "हटाएँ",
    "save": "सहेजें",
    "deleteConfirm": "यह समूह हटाएँ? मोमबत्तियाँ और उनके संदेश नहीं हटाए जाते।",
    "linkCopied": "साझा लिंक कॉपी हो गया — इसे अपने परिवार को भेजें",
    "saved": "समूह सहेजा गया",
    "deleted": "समूह हटाया गया",
    "photos": "तस्वीरें",
    "messages": "संदेश",
    "noPhotos": "अभी कोई तस्वीर नहीं।",
    "noMessages": "अभी कोई संदेश नहीं।",
    "sharedTitle": "साझा की गई यादें",
    "backToGroups": "समूहों पर वापस जाएँ",
    "selectAtLeastOne": "कम से कम एक मोमबत्ती चुनें",
    "candlesCount_one": "{{count}} मोमबत्ती",
    "candlesCount_other": "{{count}} मोमबत्तियाँ",
    "photosCount_one": "{{count}} तस्वीर",
    "photosCount_other": "{{count}} तस्वीरें",
    "messagesCount_one": "{{count}} संदेश",
    "messagesCount_other": "{{count}} संदेश",
    "for": "के लिए",
    "inviteTitle": "आप भी उनकी स्मृति का सम्मान करें",
    "inviteText": "किसी एक मोमबत्ती पर अपनी तस्वीरें और श्रद्धांजलि छोड़ने के लिए साइन इन करें।",
    "contributeTitle": "परिवार के लिए एक संदेश छोड़ें",
    "contributeSub": "आपका संदेश और तस्वीरें परिवार की हर मोमबत्ती में जोड़ी जाएँगी।",
    "yourName": "आपका नाम",
    "yourMessage": "आपका संदेश…",
    "connectForPhotos": "तस्वीरें जोड़ने के लिए साइन इन करें",
    "photosMax": "अधिकतम 10 तस्वीरें",
    "send": "प्रकाशित करें",
    "moderationNote": "परिवार की हर मोमबत्ती पर तुरंत प्रकाशित।",
    "publishedNotice": "धन्यवाद, आपका संदेश प्रकाशित हो गया 🕯️",
    "familyLabel": "पूरा परिवार",
    "deletePhoto": "तस्वीर हटाएँ",
    "editMessage": "संदेश संपादित करें",
    "connected": "आप साइन इन हैं",
    "coverPhoto": "कवर फ़ोटो (वैकल्पिक)",
    "addCover": "एक तस्वीर जोड़ें",
    "follow": "इस समूह को फ़ॉलो करें",
    "following": "फ़ॉलो कर रहे हैं",
    "followed": "फ़ॉलो कर रहे हैं ✓ नई यादों की सूचना मिलेगी",
    "unfollowed": "अनफ़ॉलो किया",
    "followHint": "इस समूह को फ़ॉलो करने और हर नई याद की सूचना पाने के लिए रजिस्टर करें।",
    "followedGroups": "फ़ॉलो किए गए समूह"
  },
  "payment": {
    "confirming": "आपके भुगतान की पुष्टि हो रही है...",
    "flameLit": "लौ जल रही है",
    "redirecting": "स्मारक पर पुनर्निर्देशित किया जा रहा है...",
    "timeout": "भुगतान संसाधित हो रहा है। कुछ ही क्षणों में \"मेरी मोमबत्तियाँ\" देखें।",
    "cancelled": "भुगतान रद्द",
    "noCharge": "कोई राशि नहीं ली गई।",
    "backToCandles": "मेरी मोमबत्तियों पर वापस जाएँ"
  },
  "plans": {
    "decouverte": "परिचय",
    "1mois": "1 माह",
    "6mois": "6 माह",
    "1an": "1 वर्ष",
    "eternite": "अनंत काल के लिए"
  },
  "conditions": {
    "back": "पंजीकरण पर वापस जाएँ",
    "title": "उपयोग की शर्तें और गोपनीयता नीति",
    "disclaimer": "ऐप में एकीकरण के लिए संक्षिप्त संस्करण। उपयोगकर्ताओं की जानकारी के लिए। प्रकाशन से पहले स्वतंत्र कानूनी समीक्षा की सिफारिश की जाती है।",
    "s1t": "1. प्रकाशक",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. स्वीकृति",
    "s2c": "खाता बनाकर या ऐप का उपयोग करके, आप इन शर्तों को स्वीकार करते हैं। यदि आप इन्हें स्वीकार नहीं करते, तो आपको सेवा का उपयोग नहीं करना चाहिए।",
    "s3t": "3. सेवा",
    "s3c": "BougieDuCœur आपको डिजिटल श्रद्धांजलि बनाने, आभासी मोमबत्तियाँ जलाने, संदेश और तस्वीरें पोस्ट करने और दी जाने वाली सेवाओं का उपयोग करने की सुविधा देता है।",
    "s4t": "4. खाता",
    "s4c": "आप दी गई जानकारी की सटीकता की गारंटी देते हैं और अपने क्रेडेंशियल की गोपनीयता के लिए जिम्मेदार हैं।",
    "s5t": "5. सामग्री",
    "s5c": "आप अपनी सामग्री पर अपने अधिकार बनाए रखते हैं लेकिन BougieDuCœur को सेवा के भाग के रूप में इसे होस्ट, प्रदर्शित और वितरित करने के लिए आवश्यक गैर-अनन्य लाइसेंस देते हैं।",
    "s6t": "6. निषेध",
    "s6c": "अवैध, घृणास्पद, मानहानिकारक या धोखाधड़ी वाली सामग्री, और कॉपीराइट, छवि अधिकार, निजता या मृतकों की स्मृति का उल्लंघन करने वाली सामग्री निषिद्ध है। झूठी श्रद्धांजलि, पहचान की चोरी और झूठे अधिकारधारक निषिद्ध हैं।",
    "s7t": "7. मॉडरेशन",
    "s7c": "किसी भी सामग्री की रिपोर्ट की जा सकती है। इन शर्तों के उल्लंघन की स्थिति में BougieDuCœur सामग्री हटा सकता है, खाता निलंबित या हटा सकता है।",
    "s8t": "8. परिवार",
    "s8c": "परिवार और अधिकारधारक दस्तावेजों के सत्यापन के बाद किसी स्मारक में संशोधन या उसे हटाने का अनुरोध कर सकते हैं।",
    "s9t": "9. व्यक्तिगत डेटा",
    "s9c": "आपका डेटा (नाम, ई-मेल, फोन, देश) खाते, मोमबत्तियों और सूचनाओं के प्रबंधन के लिए उपयोग किया जाता है। इसे बेचा नहीं जाता। GDPR के तहत, आपको contact@bougieducoeur.com पर लिखकर पहुँच, सुधार और विलोपन का अधिकार है।"
  }
};

const ja = {
  "brand": {
    "part1": "心の",
    "part2": "キャンドル"
  },
  "header": {
    "myCandles": "マイキャンドル",
    "admin": "管理",
    "notifications": "通知",
    "noNotifications": "通知はありません",
    "viewCandle": "キャンドルを見る"
  },
  "nav": {
    "home": "ホーム",
    "myCandles": "マイキャンドル",
    "messages": "メッセージ",
    "profile": "プロフィール"
  },
  "install": {
    "title": "BougieDuCœur をインストール",
    "desc": "アプリのように素早くアクセスできるよう、ホーム画面にアイコンを追加します。",
    "button": "アプリをインストール",
    "later": "後で",
    "iosStep1": "共有をタップ",
    "iosStep2": "「ホーム画面に追加」を選択",
    "androidStep1": "ブラウザのメニュー ⋮ を開く",
    "androidStep2": "「ホーム画面に追加」を選択"
  },
  "messages": {
    "title": "受信メッセージ",
    "empty": "まだメッセージはありません。",
    "reactions": "リアクション"
  },
  "profile": {
    "title": "プロフィール",
    "name": "名前",
    "email": "メール",
    "phone": "携帯",
    "country": "国",
    "language": "言語",
    "notifications": "通知を受け取る",
    "save": "保存",
    "saved": "プロフィールを更新しました",
    "error": "エラーが発生しました",
    "logout": "ログアウト",
    "incompleteNotice": "プロフィールが未完成です。情報を入力してください。",
    "complete": "完了する",
    "missingIntro": "未入力:",
    "password": "パスワード",
    "currentPassword": "現在のパスワード",
    "newPassword": "新しいパスワード",
    "confirmPassword": "新しいパスワードを確認",
    "changePassword": "パスワードを変更",
    "pwdSection": "ログインパスワード",
    "pwdTooShort": "パスワードは6文字以上で入力してください",
    "pwdMismatch": "パスワードが一致しません",
    "pwdChanged": "パスワードを変更しました",
    "pwdHint": "まだパスワードを設定していない場合は「現在のパスワード」欄を空欄のままにしてください。"
  },
  "home": {
    "title": "決して忘れないための灯火",
    "subtitle": "大切な人を偲び、心からのキャンドルを灯しましょう。メッセージを共有し、大切な人たちを無料で追悼に招きましょう。",
    "cta": "キャンドルを灯す",
    "ctaSub": "大切な人への追悼",
    "ctaFree": "無料で追悼する",
    "stats": "すでに {{candles}} 本のキャンドルが灯りました · {{messages}} 件の追悼メッセージ"
  },
  "auth": {
    "title": "BougieDuCœur に参加",
    "desc": "キャンドルを灯して管理するにはサインインしてください。",
    "google": "Google で続ける",
    "apple": "Apple で続ける",
    "appleSoon": "Apple サインインは近日公開",
    "or": "または",
    "login": "ログイン",
    "register": "登録",
    "email": "メール",
    "password": "パスワード",
    "name": "名前",
    "firstName": "名",
    "lastName": "姓",
    "signIn": "サインイン",
    "createAccount": "アカウントを作成",
    "welcome": "ようこそ",
    "accountCreated": "アカウントを作成しました",
    "loginError": "サインインできません",
    "registerError": "登録できません",
    "regTitle": "アカウントを作成",
    "regSubtitle": "コミュニティに参加し、恋しい方々を追悼しましょう。",
    "freeBadge": "登録は100％無料",
    "phone": "携帯電話（任意）",
    "termsAccept": "利用規約および法的通知を読み、同意します。",
    "readTerms": "利用規約と法的通知を読む",
    "enableNotifications": "通知を有効にする",
    "continueWith": "または次で続ける",
    "alreadyMember": "登録済みですか？ ログイン",
    "mustAcceptTerms": "利用規約に同意する必要があります",
    "noAccount": "アカウントをお持ちでないですか？"
  },
  "create": {
    "title": "キャンドルを灯す",
    "subtitle": "シンプルに、心のこもった追悼を。",
    "nameLabel": "故人のお名前",
    "namePlaceholder": "例：山田花子",
    "messageLabel": "追悼メッセージ",
    "messagePlaceholder": "心からの言葉を...",
    "durationLabel": "大切な人への追悼",
    "photoLabel": "写真（必須）",
    "addPhoto": "写真を追加",
    "birthDate": "生年",
    "offerDeadline": "{{date}}までにお申し込みください",
    "candleFreeUntil": "{{date}}まで無料でキャンドルを点灯",
    "offerIncentive": "{{end}}までにこのオファーを確定すると、キャンドルは{{until}}まで無料で点灯し続けます。",
    "datesLater": "生年月日と没年月日は、お支払い後に追加できます。",
    "draftRestored": "未完了のキャンドルの情報を保存しました。",
    "deathDate": "没年",
    "previewEternal": "永遠に灯り続けます",
    "previewDuration": "期間：{{label}}",
    "payButton": "{{price}} で灯す",
    "stripeNote": "Stripe による安全な決済 · テストカード 4242 4242 4242 4242",
    "candleLit": "キャンドルを灯しました",
    "error": "エラーが発生しました",
    "photoTooBig": "写真が大きすぎます（最大3MB）",
    "photoRequired": "写真を追加してください",
    "tagline": "永遠の灯火とメッセージ",
    "previewFlame": "炎のプレビュー"
  },
  "memorial": {
    "inMemory": "追悼",
    "days": "日",
    "hours": "時間",
    "minutes": "分",
    "seconds": "秒",
    "extinguished": "炎は消えました",
    "eternal": "永遠に灯るキャンドル",
    "pendingPayment": "支払い待ちのキャンドル",
    "edit": "編集",
    "share": "共有",
    "copyLink": "リンクをコピー",
    "condolences": "哀悼のメッセージ",
    "yourName": "お名前",
    "supportMessage": "支えの言葉を残す...",
    "depositFree": "無料でメッセージを残す",
    "messageDeposited": "メッセージが投稿されました",
    "sendError": "送信できません",
    "notFound": "キャンドルが見つかりません",
    "relightCta": "参加して延長",
    "eternityCta": "永遠に延長",
    "extendMore": "さらに延長",
    "relightTitle": "炎を延長する",
    "relightDesc": "{{name}} のキャンドルを再び灯す期間を選んでください。",
    "flameWeak": "炎が弱まっています。",
    "flameExtinguished": "炎は消えました。",
    "reviveInvite": "再び灯して、この時を延長しましょう。",
    "editTitle": "追悼を編集",
    "editDesc": "このキャンドルの名前・メッセージ・写真を更新します。",
    "photo": "写真",
    "add": "追加",
    "save": "変更を保存",
    "messageUpdated": "メッセージを更新しました",
    "editError": "変更できません",
    "nameRequired": "名前は必須です",
    "linkCopied": "リンクをコピーしました",
    "copiedToClipboard": "リンクをクリップボードにコピーしました",
    "instagramCopied": "リンクをコピーしました — Instagram のストーリーやプロフィールに貼り付けてください",
    "firstMessage": "最初のメッセージを残しましょう。",
    "leaveMessage": "メッセージを残す",
    "leaveMessageSub": "無料・数秒で完了",
    "supportCountLabel": "応援メッセージ",
    "error": "エラー",
    "forEternity": "永遠に灯るキャンドル",
    "findThemOn": "{{name}} を見つける",
    "socialsTitle": "故人のソーシャルメディア（任意）",
    "socialsHint": "公式リンクを追加してください。ページに表示されます。",
    "officialSite": "公式サイト",
    "shareInvite": "キャンドルを灯して、無料でメッセージを残しましょう 🕯️"
  },
  "mycandles": {
    "title": "マイキャンドル",
    "new": "新規",
    "active": "点灯中",
    "extinguished": "消灯",
    "eternal": "永遠",
    "pending": "支払い待ち",
    "relights": "再点灯",
    "collected": "集まりました",
    "empty": "まだキャンドルを灯していません。",
    "lightCandle": "キャンドルを灯す",
    "pay": "支払う",
    "revive": "再点灯",
    "dialogLightTitle": "キャンドルを灯す",
    "dialogRelightTitle": "炎を延長する",
    "chooseDuration": "期間を選ぶ",
    "chooseDurationFor": "{{name}} の期間を選んでください。",
    "light": "灯す",
    "prolong": "延長",
    "updated": "キャンドルを更新しました",
    "changePhoto": "写真を変更",
    "groupShort": "グループ",
    "newFull": "新しいキャンドル",
    "messagesCount": "メッセージ数"
  },
  "family": {
    "title": "家族の思い出",
    "subtitle": "複数のキャンドルのメッセージや写真を一つの場所にまとめましょう。",
    "button": "家族の思い出",
    "newGroup": "新しいグループ",
    "editGroup": "グループを編集",
    "createGroup": "グループを作成",
    "groupName": "グループ名",
    "groupNamePlaceholder": "例：両親、田中家…",
    "selectCandles": "まとめるキャンドルを選択",
    "noCandles": "まとめられるキャンドルがまだありません。",
    "empty": "グループがまだありません。作成して思い出をまとめましょう。",
    "open": "開く",
    "share": "共有",
    "edit": "編集",
    "delete": "削除",
    "save": "保存",
    "deleteConfirm": "このグループを削除しますか？キャンドルとメッセージは削除されません。",
    "linkCopied": "共有リンクをコピーしました — 家族に送りましょう",
    "saved": "グループを保存しました",
    "deleted": "グループを削除しました",
    "photos": "写真",
    "messages": "メッセージ",
    "noPhotos": "まだ写真がありません。",
    "noMessages": "まだメッセージがありません。",
    "sharedTitle": "共有された思い出",
    "backToGroups": "グループに戻る",
    "selectAtLeastOne": "キャンドルを少なくとも1つ選択してください",
    "candlesCount_one": "{{count}} 本のキャンドル",
    "candlesCount_other": "{{count}} 本のキャンドル",
    "photosCount_one": "{{count}} 枚の写真",
    "photosCount_other": "{{count}} 枚の写真",
    "messagesCount_one": "{{count}} 件のメッセージ",
    "messagesCount_other": "{{count}} 件のメッセージ",
    "for": "宛先：",
    "inviteTitle": "あなたも故人を偲びましょう",
    "inviteText": "ログインして、いずれかのキャンドルにあなたの写真やメッセージを残しましょう。",
    "contributeTitle": "家族へのメッセージを残す",
    "contributeSub": "あなたのメッセージと写真は家族のすべてのキャンドルに追加されます。",
    "yourName": "お名前",
    "yourMessage": "メッセージ…",
    "connectForPhotos": "写真を追加するにはログインしてください",
    "photosMax": "写真は最大10枚",
    "send": "投稿",
    "moderationNote": "家族のすべてのキャンドルにすぐに公開されます。",
    "publishedNotice": "ありがとうございます。メッセージが公開されました 🕯️",
    "familyLabel": "家族全員",
    "deletePhoto": "写真を削除",
    "editMessage": "メッセージを編集",
    "connected": "ログインしています",
    "coverPhoto": "カバー写真（任意）",
    "addCover": "写真を追加",
    "follow": "このグループをフォロー",
    "following": "フォロー中",
    "followed": "フォロー中 ✓ 新しい思い出をお知らせします",
    "unfollowed": "フォローを解除しました",
    "followHint": "登録してこのグループをフォローし、新しい思い出があるたびにお知らせを受け取りましょう。",
    "followedGroups": "フォロー中のグループ"
  },
  "payment": {
    "confirming": "お支払いを確認しています...",
    "flameLit": "炎が灯りました",
    "redirecting": "追悼ページへ移動しています...",
    "timeout": "お支払いを処理中です。まもなく「マイキャンドル」をご確認ください。",
    "cancelled": "支払いがキャンセルされました",
    "noCharge": "料金は請求されていません。",
    "backToCandles": "マイキャンドルに戻る"
  },
  "plans": {
    "decouverte": "お試し",
    "1mois": "1か月",
    "6mois": "6か月",
    "1an": "1年",
    "eternite": "永遠に"
  },
  "conditions": {
    "back": "登録に戻る",
    "title": "利用規約とプライバシーポリシー",
    "disclaimer": "アプリ組み込み用の要約版です。ユーザーへの情報提供を目的としています。公開前に独立した法的レビューを推奨します。",
    "s1t": "1. 運営者",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. 同意",
    "s2c": "アカウントを作成またはアプリを利用することで、本規約に同意したものとみなされます。同意されない場合は、本サービスをご利用いただけません。",
    "s3t": "3. サービス",
    "s3c": "BougieDuCœur では、デジタル追悼ページの作成、バーチャルキャンドルの点灯、メッセージや写真の投稿、提供される各種サービスの利用が可能です。",
    "s4t": "4. アカウント",
    "s4c": "提供された情報の正確性を保証し、認証情報の機密保持について責任を負うものとします。",
    "s5t": "5. コンテンツ",
    "s5c": "コンテンツの権利はお客様に帰属しますが、サービスの一環としてのホスティング・表示・配信に必要な非独占的ライセンスを BougieDuCœur に付与するものとします。",
    "s6t": "6. 禁止事項",
    "s6c": "違法・差別的・中傷的・詐欺的なコンテンツ、著作権・肖像権・プライバシー・故人の名誉を侵害するコンテンツは禁止されています。偽の追悼、なりすまし、虚偽の権利者は禁止です。",
    "s7t": "7. モデレーション",
    "s7c": "すべてのコンテンツは通報できます。本規約に違反した場合、BougieDuCœur はコンテンツの削除、アカウントの停止または削除を行うことがあります。",
    "s8t": "8. ご遺族",
    "s8c": "ご遺族および権利者は、証明書類の確認後に追悼ページの修正または削除を請求できます。",
    "s9t": "9. 個人データ",
    "s9c": "お客様のデータ（氏名、メール、電話、国）は、アカウント・キャンドル・通知の管理に使用され、販売されることはありません。GDPR に基づき、contact@bougieducoeur.com への連絡によりアクセス・訂正・削除の権利を行使できます。"
  }
};

const zh = {
  "brand": {
    "part1": "心之",
    "part2": "烛光"
  },
  "header": {
    "myCandles": "我的蜡烛",
    "admin": "管理",
    "notifications": "通知",
    "noNotifications": "暂无通知",
    "viewCandle": "查看蜡烛"
  },
  "nav": {
    "home": "首页",
    "myCandles": "我的蜡烛",
    "messages": "消息",
    "profile": "个人资料"
  },
  "install": {
    "title": "安装 BougieDuCœur",
    "desc": "将图标添加到主屏幕，像应用一样快速访问。",
    "button": "安装应用",
    "later": "稍后",
    "iosStep1": "点按分享",
    "iosStep2": "然后选择“添加到主屏幕”",
    "androidStep1": "打开浏览器菜单 ⋮",
    "androidStep2": "然后选择“添加到主屏幕”"
  },
  "messages": {
    "title": "收到的消息",
    "empty": "暂时还没有收到消息。",
    "reactions": "个反应"
  },
  "profile": {
    "title": "我的资料",
    "name": "姓名",
    "email": "邮箱",
    "phone": "手机",
    "country": "国家",
    "language": "语言",
    "notifications": "接收通知",
    "save": "保存",
    "saved": "资料已更新",
    "error": "发生错误",
    "logout": "退出登录",
    "incompleteNotice": "您的资料尚不完整。请完善您的信息。",
    "complete": "完善",
    "missingIntro": "待完善：",
    "password": "密码",
    "currentPassword": "当前密码",
    "newPassword": "新密码",
    "confirmPassword": "确认新密码",
    "changePassword": "修改密码",
    "pwdSection": "登录密码",
    "pwdTooShort": "密码至少需要6个字符",
    "pwdMismatch": "两次输入的密码不一致",
    "pwdChanged": "密码已修改",
    "pwdHint": "如果您还没有设置密码，请将「当前密码」栏留空。"
  },
  "home": {
    "title": "一束永不遗忘的烛光",
    "subtitle": "为所爱之人点燃一支发自内心的蜡烛。分享寄语，免费邀请亲友一同缅怀。",
    "cta": "点燃蜡烛",
    "ctaSub": "向挚爱致敬",
    "ctaFree": "免费缅怀",
    "stats": "已点燃 {{candles}} 支蜡烛 · {{messages}} 条缅怀寄语"
  },
  "auth": {
    "title": "加入 BougieDuCœur",
    "desc": "登录以点燃并管理您的蜡烛。",
    "google": "使用 Google 继续",
    "apple": "使用 Apple 继续",
    "appleSoon": "Apple 登录即将推出",
    "or": "或",
    "login": "登录",
    "register": "注册",
    "email": "邮箱",
    "password": "密码",
    "name": "姓名",
    "firstName": "名",
    "lastName": "姓",
    "signIn": "登录",
    "createAccount": "创建我的账户",
    "welcome": "欢迎",
    "accountCreated": "账户已创建",
    "loginError": "无法登录",
    "registerError": "无法注册",
    "regTitle": "创建账户",
    "regSubtitle": "加入社区，向您思念的人致敬。",
    "freeBadge": "100% 免费注册",
    "phone": "手机号码（可选）",
    "termsAccept": "我已阅读并接受一般使用条款和法律声明。",
    "readTerms": "阅读一般使用条款和法律声明",
    "enableNotifications": "启用通知",
    "continueWith": "或使用以下方式继续",
    "alreadyMember": "已注册？登录",
    "mustAcceptTerms": "您必须接受使用条款",
    "noAccount": "还没有账户？"
  },
  "create": {
    "title": "点燃蜡烛",
    "subtitle": "个性化的致敬，简单而真挚。",
    "nameLabel": "逝者姓名",
    "namePlaceholder": "例如：李梅",
    "messageLabel": "致敬寄语",
    "messagePlaceholder": "几句发自内心的话...",
    "durationLabel": "献给挚爱的追思",
    "photoLabel": "照片（必填）",
    "addPhoto": "添加照片",
    "birthDate": "出生",
    "offerDeadline": "请在 {{date}} 前确认此优惠",
    "candleFreeUntil": "蜡烛免费点亮至 {{date}}",
    "offerIncentive": "如果您在 {{end}} 前确认此优惠，您的蜡烛将免费点亮至 {{until}}。",
    "datesLater": "付款后即可添加出生和逝世日期。",
    "draftRestored": "我们已保存您未完成蜡烛的信息。",
    "deathDate": "逝世",
    "previewEternal": "将永远燃烧",
    "previewDuration": "时长：{{label}}",
    "payButton": "以 {{price}} 点燃",
    "stripeNote": "通过 Stripe 安全支付 · 测试卡 4242 4242 4242 4242",
    "candleLit": "蜡烛已点燃",
    "error": "发生错误",
    "photoTooBig": "照片过大（最大 3 MB）",
    "photoRequired": "请添加一张照片",
    "tagline": "永恒的烛光与寄语",
    "previewFlame": "火焰预览"
  },
  "memorial": {
    "inMemory": "缅怀",
    "days": "天",
    "hours": "时",
    "minutes": "分",
    "seconds": "秒",
    "extinguished": "烛光已熄灭",
    "eternal": "永恒点燃的蜡烛",
    "pendingPayment": "等待支付的蜡烛",
    "edit": "编辑",
    "share": "分享",
    "copyLink": "复制链接",
    "condolences": "慰问留言",
    "yourName": "您的姓名",
    "supportMessage": "留下支持的话语...",
    "depositFree": "免费留言",
    "messageDeposited": "您的寄语已发布",
    "sendError": "无法发送",
    "notFound": "未找到蜡烛",
    "relightCta": "参与并延续",
    "eternityCta": "延续至永恒",
    "extendMore": "延续更多",
    "relightTitle": "延续烛光",
    "relightDesc": "选择时长，重新点燃 {{name}} 的蜡烛。",
    "flameWeak": "烛光正在减弱。",
    "flameExtinguished": "烛光已熄灭。",
    "reviveInvite": "重新点燃它，延续这一刻。",
    "editTitle": "编辑致敬",
    "editDesc": "更新这支蜡烛的姓名、寄语和照片。",
    "photo": "照片",
    "add": "添加",
    "save": "保存更改",
    "messageUpdated": "寄语已更新",
    "editError": "无法修改",
    "nameRequired": "姓名为必填项",
    "linkCopied": "链接已复制",
    "copiedToClipboard": "链接已复制到剪贴板",
    "instagramCopied": "链接已复制 — 粘贴到您的 Instagram 快拍或简介中",
    "firstMessage": "成为第一个留言的人。",
    "leaveMessage": "留言",
    "leaveMessageSub": "免费，几秒完成",
    "supportCountLabel": "支持寄语",
    "error": "错误",
    "forEternity": "永恒之烛",
    "findThemOn": "在这里找到 {{name}}",
    "socialsTitle": "逝者的社交媒体（可选）",
    "socialsHint": "添加官方链接——它们将显示在页面上。",
    "officialSite": "官方网站",
    "shareInvite": "点燃一支蜡烛，免费留下一条留言 🕯️"
  },
  "mycandles": {
    "title": "我的蜡烛",
    "new": "新建",
    "active": "点燃中",
    "extinguished": "已熄灭",
    "eternal": "永恒",
    "pending": "等待支付",
    "relights": "次续燃",
    "collected": "已筹集",
    "empty": "您还没有点燃任何蜡烛。",
    "lightCandle": "点燃蜡烛",
    "pay": "支付",
    "revive": "续燃",
    "dialogLightTitle": "点燃蜡烛",
    "dialogRelightTitle": "延续烛光",
    "chooseDuration": "选择时长",
    "chooseDurationFor": "为 {{name}} 选择时长。",
    "light": "点燃",
    "prolong": "延续",
    "updated": "蜡烛已更新",
    "changePhoto": "更换照片",
    "groupShort": "群组",
    "newFull": "新蜡烛",
    "messagesCount": "留言数量"
  },
  "family": {
    "title": "家庭回忆",
    "subtitle": "将多支蜡烛的留言和照片汇集到一处。",
    "button": "家庭回忆",
    "newGroup": "新建群组",
    "editGroup": "编辑群组",
    "createGroup": "创建群组",
    "groupName": "群组名称",
    "groupNamePlaceholder": "例如：我的父母、张家…",
    "selectCandles": "选择要归入群组的蜡烛",
    "noCandles": "您还没有可归入群组的蜡烛。",
    "empty": "还没有群组。创建一个来汇集您的回忆。",
    "open": "打开",
    "share": "分享",
    "edit": "编辑",
    "delete": "删除",
    "save": "保存",
    "deleteConfirm": "删除此群组？蜡烛及其留言不会被删除。",
    "linkCopied": "分享链接已复制 — 发送给您的家人吧",
    "saved": "群组已保存",
    "deleted": "群组已删除",
    "photos": "照片",
    "messages": "留言",
    "noPhotos": "还没有照片。",
    "noMessages": "还没有留言。",
    "sharedTitle": "共享的回忆",
    "backToGroups": "返回群组",
    "selectAtLeastOne": "请至少选择一支蜡烛",
    "candlesCount_one": "{{count}} 支蜡烛",
    "candlesCount_other": "{{count}} 支蜡烛",
    "photosCount_one": "{{count}} 张照片",
    "photosCount_other": "{{count}} 张照片",
    "messagesCount_one": "{{count}} 条留言",
    "messagesCount_other": "{{count}} 条留言",
    "for": "致",
    "inviteTitle": "您也来缅怀他们",
    "inviteText": "登录后可在其中一支蜡烛上留下您的照片和悼念。",
    "contributeTitle": "为这个家庭留言",
    "contributeSub": "您的留言和照片将被添加到家庭的每一支蜡烛上。",
    "yourName": "您的姓名",
    "yourMessage": "您的留言…",
    "connectForPhotos": "登录后可添加照片",
    "photosMax": "最多10张照片",
    "send": "发布",
    "moderationNote": "立即发布到家庭的每一支蜡烛上。",
    "publishedNotice": "谢谢，您的留言已发布 🕯️",
    "familyLabel": "全家",
    "deletePhoto": "删除照片",
    "editMessage": "编辑留言",
    "connected": "您已登录",
    "coverPhoto": "封面照片（可选）",
    "addCover": "添加照片",
    "follow": "关注此群组",
    "following": "已关注",
    "followed": "已关注 ✓ 有新回忆时会通知您",
    "unfollowed": "已取消关注",
    "followHint": "注册以关注此群组，每有新回忆都会通知您。",
    "followedGroups": "关注的群组"
  },
  "payment": {
    "confirming": "正在确认您的支付...",
    "flameLit": "烛光已点燃",
    "redirecting": "正在跳转至纪念页面...",
    "timeout": "支付正在处理中。请稍后查看“我的蜡烛”。",
    "cancelled": "支付已取消",
    "noCharge": "未扣除任何金额。",
    "backToCandles": "返回我的蜡烛"
  },
  "plans": {
    "decouverte": "体验",
    "1mois": "1 个月",
    "6mois": "6 个月",
    "1an": "1 年",
    "eternite": "永恒"
  },
  "conditions": {
    "back": "返回注册",
    "title": "使用条款与隐私政策",
    "disclaimer": "用于应用内集成的精简版本，仅供用户参考。发布前建议进行独立的法律审查。",
    "s1t": "1. 运营方",
    "s1c": "BougieDuCœur — HOLDING DES MARQUES (H.D.M.), ZAC DU PACQUIS, 8 Avenue Pierre Bérégovoy, 70400 Héricourt, France. SIREN 453 058 794 – SIRET 453 058 794 00026 – TVA FR75453058794 – contact@bougieducoeur.com.",
    "s2t": "2. 接受条款",
    "s2c": "创建账户或使用本应用即表示您接受这些条款。如果您不接受，则不得使用本服务。",
    "s3t": "3. 服务",
    "s3c": "BougieDuCœur 允许您创建数字纪念、点燃虚拟蜡烛、发布留言和照片，并使用所提供的服务。",
    "s4t": "4. 账户",
    "s4c": "您保证所提供信息的准确性，并对您凭据的保密性负责。",
    "s5t": "5. 内容",
    "s5c": "您保留对内容的权利，但授予 BougieDuCœur 在服务范围内托管、展示和传播内容所需的非独占许可。",
    "s6t": "6. 禁止事项",
    "s6c": "禁止发布非法、仇恨、诽谤或欺诈内容，以及侵犯版权、肖像权、隐私或逝者名誉的内容。禁止虚假纪念、身份冒用和虚假权利人。",
    "s7t": "7. 审核",
    "s7c": "任何内容均可被举报。如违反本条款，BougieDuCœur 可删除内容、暂停或删除账户。",
    "s8t": "8. 家属",
    "s8c": "家属和权利人可在核实证明文件后，请求修改或删除纪念页面。",
    "s9t": "9. 个人数据",
    "s9c": "您的数据（姓名、邮箱、电话、国家）用于管理账户、蜡烛和通知，不会被出售。根据 GDPR，您有权通过发送邮件至 contact@bougieducoeur.com 进行访问、更正和删除。"
  }
};

export const LANGS = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "es_mx", label: "Español (MX)", flag: "🇲🇽" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "pl", label: "Polski", flag: "🇵🇱" },
  { code: "fil", label: "Filipino", flag: "🇵🇭" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "el", label: "Ελληνικά", flag: "🇬🇷" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
];

fr.create.nationalityLabel = "Nationalité du défunt (facultatif — affiche le drapeau)";
fr.create.nationalityNone = "— Aucune —";
en.create.nationalityLabel = "Nationality of the deceased (optional — shows the flag)";
en.create.nationalityNone = "— None —";
es.create.nationalityLabel = "Nacionalidad del difunto (opcional — muestra la bandera)";
es.create.nationalityNone = "— Ninguna —";
de.create.nationalityLabel = "Nationalität des Verstorbenen (optional — zeigt die Flagge)";
de.create.nationalityNone = "— Keine —";
it.create.nationalityLabel = "Nazionalità del defunto (facoltativo — mostra la bandiera)";
it.create.nationalityNone = "— Nessuna —";
pl.create.nationalityLabel = "Narodowość zmarłego (opcjonalnie — pokazuje flagę)";
pl.create.nationalityNone = "— Brak —";
fil.create.nationalityLabel = "Nasyonalidad ng namayapa (opsyonal — ipinapakita ang bandila)";
fil.create.nationalityNone = "— Wala —";
ru.create.nationalityLabel = "Национальность усопшего (необязательно — показывает флаг)";
ru.create.nationalityNone = "— Нет —";
el.create.nationalityLabel = "Εθνικότητα του εκλιπόντος (προαιρετικό — εμφανίζει τη σημαία)";
el.create.nationalityNone = "— Καμία —";
hi.create.nationalityLabel = "दिवंगत की राष्ट्रीयता (वैकल्पिक — झंडा दिखाता है)";
hi.create.nationalityNone = "— कोई नहीं —";
ja.create.nationalityLabel = "故人の国籍（任意 — 国旗を表示）";
ja.create.nationalityNone = "— なし —";
zh.create.nationalityLabel = "逝者的国籍（可选——显示国旗）";
zh.create.nationalityNone = "— 无 —";

fr.create.dateOrderError = "La date de décès ne peut pas précéder la date de naissance.";
en.create.dateOrderError = "The date of passing cannot be before the date of birth.";
es.create.dateOrderError = "La fecha de fallecimiento no puede ser anterior a la de nacimiento.";
de.create.dateOrderError = "Das Sterbedatum darf nicht vor dem Geburtsdatum liegen.";
it.create.dateOrderError = "La data del decesso non può precedere la data di nascita.";
pl.create.dateOrderError = "Data śmierci nie może być wcześniejsza niż data urodzenia.";
fil.create.dateOrderError = "Ang petsa ng pagpanaw ay hindi maaaring mas maaga sa petsa ng kapanganakan.";
ru.create.dateOrderError = "Дата смерти не может быть раньше даты рождения.";
el.create.dateOrderError = "Η ημερομηνία θανάτου δεν μπορεί να προηγείται της ημερομηνίας γέννησης.";
hi.create.dateOrderError = "मृत्यु की तिथि जन्म तिथि से पहले नहीं हो सकती।";
ja.create.dateOrderError = "没年は生年より前にはできません。";
zh.create.dateOrderError = "逝世日期不能早于出生日期。";


fr.ambassador = {
  "badge": "Ambassadeur de la Marque",
  "welcomeTitle": "Bienvenue {{name}}",
  "intro": "Vous faites désormais partie du cercle très privé des Ambassadeurs de BougieDuCœur, le premier mémorial numérique Mondial dédié à la mémoire de ceux qui nous sont chers.",
  "giftTitle_one": "{{count}} bougie offerte pour l'éternité",
  "giftTitle_other": "{{count}} bougies offertes pour l'éternité",
  "giftText": "Allumez une bougie pour l'éternité en mémoire d'un proche disparu, le jour de votre choix. Partagez ensuite sa flamme uniquement avec votre famille et vos amis : ceux qui reçoivent le lien pourront déposer messages et photos en son souvenir.",
  "lightButton": "Allumer une bougie",
  "freeForever": "Gratuit, sans abonnement, pour toujours.",
  "slotsTitle": "Vos bougies pour l'éternité",
  "slotLabel_one": "{{count}} bougie pour l'éternité à allumer",
  "slotLabel_other": "{{count}} bougies pour l'éternité à allumer",
  "flameAndMessages": "Une Flamme & Messages pour l'éternité",
  "creditBanner_one": "Vous disposez de {{count}} bougie pour l'éternité — allumez-la le jour de votre choix.",
  "creditBanner_other": "Vous disposez de {{count}} bougies pour l'éternité — allumez-les le jour de votre choix.",
  "createNotice": "Bougie offerte — elle sera allumée pour l'éternité, gratuitement et sans abonnement.",
  "createButton": "Allumer pour l'éternité (offert)",
  "litToast": "Bougie allumée pour l'éternité 🕯️",
};
en.ambassador = {
  "badge": "Brand Ambassador",
  "welcomeTitle": "Welcome {{name}}",
  "intro": "You are now part of the very private circle of BougieDuCœur Ambassadors, the world's first digital memorial dedicated to the memory of those dear to us.",
  "giftTitle_one": "{{count}} free candle for eternity",
  "giftTitle_other": "{{count}} free candles for eternity",
  "giftText": "Light a candle for eternity in memory of a departed loved one, on the day of your choice. Then share its flame only with your family and friends: those who receive the link can leave messages and photos in their memory.",
  "lightButton": "Light a candle",
  "freeForever": "Free, no subscription, forever.",
  "slotsTitle": "Your candles for eternity",
  "slotLabel_one": "{{count}} candle for eternity to light",
  "slotLabel_other": "{{count}} candles for eternity to light",
  "flameAndMessages": "A Flame & Messages for eternity",
  "creditBanner_one": "You have {{count}} candle for eternity — light it on the day of your choice.",
  "creditBanner_other": "You have {{count}} candles for eternity — light them on the day of your choice.",
  "createNotice": "Free candle — it will be lit for eternity, free and with no subscription.",
  "createButton": "Light for eternity (free)",
  "litToast": "Candle lit for eternity 🕯️",
};
es.ambassador = {
  "badge": "Embajador de la Marca",
  "welcomeTitle": "Bienvenido {{name}}",
  "intro": "Ahora formas parte del círculo muy privado de los Embajadores de BougieDuCœur, el primer memorial digital mundial dedicado a la memoria de nuestros seres queridos.",
  "giftTitle_one": "{{count}} vela gratis para la eternidad",
  "giftTitle_other": "{{count}} velas gratis para la eternidad",
  "giftText": "Enciende una vela para la eternidad en memoria de un ser querido fallecido, el día que elijas. Después comparte su llama solo con tu familia y amigos: quienes reciban el enlace podrán dejar mensajes y fotos en su memoria.",
  "lightButton": "Encender una vela",
  "freeForever": "Gratis, sin suscripción, para siempre.",
  "slotsTitle": "Tus velas para la eternidad",
  "slotLabel_one": "{{count}} vela para la eternidad por encender",
  "slotLabel_other": "{{count}} velas para la eternidad por encender",
  "flameAndMessages": "Una Llama y Mensajes para la eternidad",
  "creditBanner_one": "Dispones de {{count}} vela para la eternidad: enciéndela el día que elijas.",
  "creditBanner_other": "Dispones de {{count}} velas para la eternidad: enciéndelas el día que elijas.",
  "createNotice": "Vela de regalo: se encenderá para la eternidad, gratis y sin suscripción.",
  "createButton": "Encender para la eternidad (gratis)",
  "litToast": "Vela encendida para la eternidad 🕯️",
};
de.ambassador = {
  "badge": "Markenbotschafter",
  "welcomeTitle": "Willkommen {{name}}",
  "intro": "Sie gehören nun zum sehr privaten Kreis der BougieDuCœur-Botschafter, dem weltweit ersten digitalen Gedenkort für die Erinnerung an unsere Liebsten.",
  "giftTitle_one": "{{count}} kostenlose Kerze für die Ewigkeit",
  "giftTitle_other": "{{count}} kostenlose Kerzen für die Ewigkeit",
  "giftText": "Entzünden Sie eine Kerze für die Ewigkeit im Gedenken an einen verstorbenen Angehörigen, an dem Tag Ihrer Wahl. Teilen Sie ihre Flamme dann nur mit Ihrer Familie und Ihren Freunden: Wer den Link erhält, kann Nachrichten und Fotos zum Gedenken hinterlassen.",
  "lightButton": "Eine Kerze anzünden",
  "freeForever": "Kostenlos, ohne Abo, für immer.",
  "slotsTitle": "Ihre Kerzen für die Ewigkeit",
  "slotLabel_one": "{{count}} Kerze für die Ewigkeit zum Anzünden",
  "slotLabel_other": "{{count}} Kerzen für die Ewigkeit zum Anzünden",
  "flameAndMessages": "Eine Flamme & Nachrichten für die Ewigkeit",
  "creditBanner_one": "Sie haben {{count}} Kerze für die Ewigkeit – zünden Sie sie an dem Tag Ihrer Wahl an.",
  "creditBanner_other": "Sie haben {{count}} Kerzen für die Ewigkeit – zünden Sie sie an dem Tag Ihrer Wahl an.",
  "createNotice": "Geschenkkerze – sie wird für die Ewigkeit angezündet, kostenlos und ohne Abo.",
  "createButton": "Für die Ewigkeit anzünden (geschenkt)",
  "litToast": "Kerze für die Ewigkeit angezündet 🕯️",
};
it.ambassador = {
  "badge": "Ambasciatore del Marchio",
  "welcomeTitle": "Benvenuto {{name}}",
  "intro": "Ora fai parte della cerchia molto privata degli Ambasciatori di BougieDuCœur, il primo memoriale digitale mondiale dedicato alla memoria di chi ci è caro.",
  "giftTitle_one": "{{count}} candela gratuita per l'eternità",
  "giftTitle_other": "{{count}} candele gratuite per l'eternità",
  "giftText": "Accendi una candela per l'eternità in memoria di una persona cara scomparsa, nel giorno che preferisci. Poi condividi la sua fiamma solo con la tua famiglia e i tuoi amici: chi riceve il link potrà lasciare messaggi e foto in suo ricordo.",
  "lightButton": "Accendi una candela",
  "freeForever": "Gratis, senza abbonamento, per sempre.",
  "slotsTitle": "Le tue candele per l'eternità",
  "slotLabel_one": "{{count}} candela per l'eternità da accendere",
  "slotLabel_other": "{{count}} candele per l'eternità da accendere",
  "flameAndMessages": "Una Fiamma e Messaggi per l'eternità",
  "creditBanner_one": "Hai {{count}} candela per l'eternità: accendila nel giorno che preferisci.",
  "creditBanner_other": "Hai {{count}} candele per l'eternità: accendile nel giorno che preferisci.",
  "createNotice": "Candela in omaggio: sarà accesa per l'eternità, gratis e senza abbonamento.",
  "createButton": "Accendi per l'eternità (omaggio)",
  "litToast": "Candela accesa per l'eternità 🕯️",
};
pl.ambassador = {
  "badge": "Ambasador Marki",
  "welcomeTitle": "Witaj {{name}}",
  "intro": "Dołączasz teraz do bardzo wąskiego grona Ambasadorów BougieDuCœur, pierwszego na świecie cyfrowego miejsca pamięci poświęconego pamięci naszych bliskich.",
  "giftTitle_one": "{{count}} darmowa świeca na wieczność",
  "giftTitle_other": "{{count}} darmowych świec na wieczność",
  "giftText": "Zapal świecę na wieczność ku pamięci zmarłej bliskiej osoby, w wybranym dniu. Następnie udostępnij jej płomień tylko rodzinie i przyjaciołom: osoby, które otrzymają link, będą mogły zostawić wiadomości i zdjęcia ku pamięci.",
  "lightButton": "Zapal świecę",
  "freeForever": "Za darmo, bez abonamentu, na zawsze.",
  "slotsTitle": "Twoje świece na wieczność",
  "slotLabel_one": "{{count}} świeca na wieczność do zapalenia",
  "slotLabel_other": "{{count}} świec na wieczność do zapalenia",
  "flameAndMessages": "Płomień i wiadomości na wieczność",
  "creditBanner_one": "Masz {{count}} świecę na wieczność — zapal ją w wybranym dniu.",
  "creditBanner_other": "Masz {{count}} świec na wieczność — zapal je w wybranym dniu.",
  "createNotice": "Świeca w prezencie — zostanie zapalona na wieczność, za darmo i bez abonamentu.",
  "createButton": "Zapal na wieczność (gratis)",
  "litToast": "Świeca zapalona na wieczność 🕯️",
};
fil.ambassador = {
  "badge": "Ambasador ng Tatak",
  "welcomeTitle": "Maligayang pagdating {{name}}",
  "intro": "Bahagi ka na ngayon ng napakapribadong bilog ng mga Ambasador ng BougieDuCœur, ang unang digital na memorial sa mundo na nakatuon sa alaala ng mga mahal natin sa buhay.",
  "giftTitle_one": "{{count}} libreng kandila para sa kawalang-hanggan",
  "giftTitle_other": "{{count}} libreng kandila para sa kawalang-hanggan",
  "giftText": "Magsindi ng kandila para sa kawalang-hanggan bilang alaala ng isang yumaong mahal sa buhay, sa araw na gusto mo. Pagkatapos ay ibahagi ang liwanag nito sa iyong pamilya at mga kaibigan lamang: ang mga makatatanggap ng link ay makakapag-iwan ng mga mensahe at litrato bilang alaala.",
  "lightButton": "Magsindi ng kandila",
  "freeForever": "Libre, walang subscription, magpakailanman.",
  "slotsTitle": "Ang iyong mga kandila para sa kawalang-hanggan",
  "slotLabel_one": "{{count}} kandila para sa kawalang-hanggan na sisindihan",
  "slotLabel_other": "{{count}} kandila para sa kawalang-hanggan na sisindihan",
  "flameAndMessages": "Isang Liwanag at mga Mensahe para sa kawalang-hanggan",
  "creditBanner_one": "Mayroon kang {{count}} kandila para sa kawalang-hanggan — sindihan ito sa araw na gusto mo.",
  "creditBanner_other": "Mayroon kang {{count}} kandila para sa kawalang-hanggan — sindihan ang mga ito sa araw na gusto mo.",
  "createNotice": "Regalong kandila — sisindihan ito para sa kawalang-hanggan, libre at walang subscription.",
  "createButton": "Sindihan para sa kawalang-hanggan (libre)",
  "litToast": "Nasindihan ang kandila para sa kawalang-hanggan 🕯️",
};
ru.ambassador = {
  "badge": "Амбассадор бренда",
  "welcomeTitle": "Добро пожаловать, {{name}}",
  "intro": "Теперь вы в очень узком кругу Амбассадоров BougieDuCœur — первого в мире цифрового мемориала, посвящённого памяти наших близких.",
  "giftTitle_one": "{{count}} бесплатная свеча на вечность",
  "giftTitle_other": "{{count}} бесплатных свечей на вечность",
  "giftText": "Зажгите свечу на вечность в память об ушедшем близком в выбранный вами день. Затем делитесь её пламенем только с семьёй и друзьями: те, кто получит ссылку, смогут оставить сообщения и фотографии в память.",
  "lightButton": "Зажечь свечу",
  "freeForever": "Бесплатно, без подписки, навсегда.",
  "slotsTitle": "Ваши свечи на вечность",
  "slotLabel_one": "{{count}} свеча на вечность для зажжения",
  "slotLabel_other": "{{count}} свечей на вечность для зажжения",
  "flameAndMessages": "Пламя и сообщения на вечность",
  "creditBanner_one": "У вас {{count}} свеча на вечность — зажгите её в выбранный день.",
  "creditBanner_other": "У вас {{count}} свечей на вечность — зажгите их в выбранный день.",
  "createNotice": "Свеча в подарок — она будет зажжена на вечность, бесплатно и без подписки.",
  "createButton": "Зажечь на вечность (бесплатно)",
  "litToast": "Свеча зажжена на вечность 🕯️",
};
el.ambassador = {
  "badge": "Πρεσβευτής της Μάρκας",
  "welcomeTitle": "Καλώς ήρθες {{name}}",
  "intro": "Ανήκεις πλέον στον πολύ κλειστό κύκλο των Πρεσβευτών του BougieDuCœur, του πρώτου παγκόσμιου ψηφιακού μνημείου αφιερωμένου στη μνήμη των αγαπημένων μας.",
  "giftTitle_one": "{{count}} δωρεάν κερί για την αιωνιότητα",
  "giftTitle_other": "{{count}} δωρεάν κεριά για την αιωνιότητα",
  "giftText": "Άναψε ένα κερί για την αιωνιότητα στη μνήμη ενός αγαπημένου που έφυγε, την ημέρα που εσύ επιλέγεις. Έπειτα μοιράσου τη φλόγα του μόνο με την οικογένεια και τους φίλους σου: όσοι λάβουν τον σύνδεσμο θα μπορούν να αφήσουν μηνύματα και φωτογραφίες στη μνήμη του.",
  "lightButton": "Άναψε ένα κερί",
  "freeForever": "Δωρεάν, χωρίς συνδρομή, για πάντα.",
  "slotsTitle": "Τα κεριά σου για την αιωνιότητα",
  "slotLabel_one": "{{count}} κερί για την αιωνιότητα προς άναμμα",
  "slotLabel_other": "{{count}} κεριά για την αιωνιότητα προς άναμμα",
  "flameAndMessages": "Μια Φλόγα & Μηνύματα για την αιωνιότητα",
  "creditBanner_one": "Έχεις {{count}} κερί για την αιωνιότητα — άναψέ το την ημέρα που επιλέγεις.",
  "creditBanner_other": "Έχεις {{count}} κεριά για την αιωνιότητα — άναψέ τα την ημέρα που επιλέγεις.",
  "createNotice": "Δωρεάν κερί — θα ανάψει για την αιωνιότητα, δωρεάν και χωρίς συνδρομή.",
  "createButton": "Άναψε για την αιωνιότητα (δωρεάν)",
  "litToast": "Το κερί άναψε για την αιωνιότητα 🕯️",
};
hi.ambassador = {
  "badge": "ब्रांड एंबेसडर",
  "welcomeTitle": "स्वागत है {{name}}",
  "intro": "अब आप BougieDuCœur के एंबेसडरों के बहुत निजी समूह का हिस्सा हैं — दुनिया का पहला डिजिटल स्मारक जो हमारे प्रियजनों की स्मृति को समर्पित है।",
  "giftTitle_one": "अनंत काल के लिए {{count}} निःशुल्क मोमबत्ती",
  "giftTitle_other": "अनंत काल के लिए {{count}} निःशुल्क मोमबत्तियाँ",
  "giftText": "अपने किसी दिवंगत प्रियजन की स्मृति में, अपनी पसंद के दिन, अनंत काल के लिए एक मोमबत्ती जलाएँ। फिर उसकी लौ केवल अपने परिवार और मित्रों के साथ साझा करें: जिन्हें लिंक मिलेगा वे उनकी स्मृति में संदेश और तस्वीरें छोड़ सकेंगे।",
  "lightButton": "मोमबत्ती जलाएँ",
  "freeForever": "निःशुल्क, बिना सदस्यता, हमेशा के लिए।",
  "slotsTitle": "अनंत काल के लिए आपकी मोमबत्तियाँ",
  "slotLabel_one": "जलाने के लिए अनंत काल की {{count}} मोमबत्ती",
  "slotLabel_other": "जलाने के लिए अनंत काल की {{count}} मोमबत्तियाँ",
  "flameAndMessages": "अनंत काल के लिए एक लौ और संदेश",
  "creditBanner_one": "आपके पास अनंत काल के लिए {{count}} मोमबत्ती है — इसे अपनी पसंद के दिन जलाएँ।",
  "creditBanner_other": "आपके पास अनंत काल के लिए {{count}} मोमबत्तियाँ हैं — इन्हें अपनी पसंद के दिन जलाएँ।",
  "createNotice": "उपहार मोमबत्ती — यह अनंत काल के लिए जलाई जाएगी, निःशुल्क और बिना सदस्यता।",
  "createButton": "अनंत काल के लिए जलाएँ (निःशुल्क)",
  "litToast": "मोमबत्ती अनंत काल के लिए जलाई गई 🕯️",
};
ja.ambassador = {
  "badge": "ブランドアンバサダー",
  "welcomeTitle": "ようこそ、{{name}}さん",
  "intro": "あなたは今、BougieDuCœur のアンバサダーというごく限られた輪の一員です。大切な人の思い出に捧げる世界初のデジタル追悼の場です。",
  "giftTitle_one": "永遠のための無料キャンドル {{count}} 本",
  "giftTitle_other": "永遠のための無料キャンドル {{count}} 本",
  "giftText": "亡くなった大切な人の思い出に、お好きな日に永遠のキャンドルを灯しましょう。その灯りはご家族やご友人だけに共有できます。リンクを受け取った方は、追悼のメッセージや写真を残すことができます。",
  "lightButton": "キャンドルを灯す",
  "freeForever": "無料、サブスクなし、永遠に。",
  "slotsTitle": "永遠のためのあなたのキャンドル",
  "slotLabel_one": "灯す永遠のキャンドル {{count}} 本",
  "slotLabel_other": "灯す永遠のキャンドル {{count}} 本",
  "flameAndMessages": "永遠のための灯りとメッセージ",
  "creditBanner_one": "永遠のためのキャンドルが {{count}} 本あります。お好きな日に灯してください。",
  "creditBanner_other": "永遠のためのキャンドルが {{count}} 本あります。お好きな日に灯してください。",
  "createNotice": "ギフトキャンドル — 無料・サブスクなしで永遠に灯されます。",
  "createButton": "永遠に灯す（無料）",
  "litToast": "キャンドルを永遠に灯しました 🕯️",
};
zh.ambassador = {
  "badge": "品牌大使",
  "welcomeTitle": "欢迎 {{name}}",
  "intro": "您现在是 BougieDuCœur 大使这一非常私密圈子的一员——全球首个纪念挚爱之人的数字纪念馆。",
  "giftTitle_one": "{{count}} 支永恒免费蜡烛",
  "giftTitle_other": "{{count}} 支永恒免费蜡烛",
  "giftText": "在您选择的日子，为逝去的挚爱点燃一支永恒的蜡烛。然后仅与您的家人和朋友分享它的烛光：收到链接的人可以留下缅怀的留言和照片。",
  "lightButton": "点燃蜡烛",
  "freeForever": "免费，无需订阅，永远。",
  "slotsTitle": "您永恒的蜡烛",
  "slotLabel_one": "{{count}} 支待点燃的永恒蜡烛",
  "slotLabel_other": "{{count}} 支待点燃的永恒蜡烛",
  "flameAndMessages": "永恒的烛光与留言",
  "creditBanner_one": "您有 {{count}} 支永恒蜡烛——在您选择的日子点燃它。",
  "creditBanner_other": "您有 {{count}} 支永恒蜡烛——在您选择的日子点燃它们。",
  "createNotice": "赠送蜡烛——将为永恒点燃，免费且无需订阅。",
  "createButton": "为永恒点燃（赠送）",
  "litToast": "蜡烛已为永恒点燃 🕯️",
};


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: { ...fr, po: { ...PO.fr, ...PO2.fr, ...PO3.fr, ...PO4.fr, ...PO5.fr, ...PO6.fr, ...PO7.fr, ...PO8.fr, ...PO9.fr, ...PO10.fr }, cgu: CGU.fr, cropper: CROP.fr } }, en: { translation: { ...en, po: { ...PO.en, ...PO2.en, ...PO3.en, ...PO4.en, ...PO5.en, ...PO6.en, ...PO7.en, ...PO8.en, ...PO9.en, ...PO10.en }, cgu: CGU.en, cropper: CROP.en } }, es: { translation: { ...es, po: { ...PO.es, ...PO2.es, ...PO3.es, ...PO4.es, ...PO5.es, ...PO6.es, ...PO7.es, ...PO8.es, ...PO9.es, ...PO10.es }, cgu: CGU.es, cropper: CROP.es } },
      es_mx: { translation: { ...es, po: { ...PO.es, ...PO2.es, ...PO3.es, ...PO4.es, ...PO5.es, ...PO6.es, ...PO7.es, ...PO8.es, ...PO9.es, ...PO10.es }, cgu: CGU.es, cropper: CROP.es } }, de: { translation: { ...de, po: { ...PO.de, ...PO2.de, ...PO3.de, ...PO4.de, ...PO5.de, ...PO6.de, ...PO7.de, ...PO8.de, ...PO9.de, ...PO10.de }, cgu: CGU.de, cropper: CROP.de } }, it: { translation: { ...it, po: { ...PO.it, ...PO2.it, ...PO3.it, ...PO4.it, ...PO5.it, ...PO6.it, ...PO7.it, ...PO8.it, ...PO9.it, ...PO10.it }, cgu: CGU.it, cropper: CROP.it } },
      pl: { translation: { ...pl, po: { ...PO.pl, ...PO2.pl, ...PO3.pl, ...PO4.pl, ...PO5.pl, ...PO6.pl, ...PO7.pl, ...PO8.pl, ...PO9.pl, ...PO10.pl }, cgu: CGU.pl, cropper: CROP.pl } }, fil: { translation: { ...fil, po: { ...PO.fil, ...PO2.fil, ...PO3.fil, ...PO4.fil, ...PO5.fil, ...PO6.fil, ...PO7.fil, ...PO8.fil, ...PO9.fil, ...PO10.fil }, cgu: CGU.fil, cropper: CROP.fil } }, ru: { translation: { ...ru, po: { ...PO.ru, ...PO2.ru, ...PO3.ru, ...PO4.ru, ...PO5.ru, ...PO6.ru, ...PO7.ru, ...PO8.ru, ...PO9.ru, ...PO10.ru }, cgu: CGU.ru, cropper: CROP.ru } },
      el: { translation: { ...el, po: { ...PO.el, ...PO2.el, ...PO3.el, ...PO4.el, ...PO5.el, ...PO6.el, ...PO7.el, ...PO8.el, ...PO9.el, ...PO10.el }, cgu: CGU.el, cropper: CROP.el } }, hi: { translation: { ...hi, po: { ...PO.hi, ...PO2.hi, ...PO3.hi, ...PO4.hi, ...PO5.hi, ...PO6.hi, ...PO7.hi, ...PO8.hi, ...PO9.hi, ...PO10.hi }, cgu: CGU.hi, cropper: CROP.hi } }, ja: { translation: { ...ja, po: { ...PO.ja, ...PO2.ja, ...PO3.ja, ...PO4.ja, ...PO5.ja, ...PO6.ja, ...PO7.ja, ...PO8.ja, ...PO9.ja, ...PO10.ja }, cgu: CGU.ja, cropper: CROP.ja } }, zh: { translation: { ...zh, po: { ...PO.zh, ...PO2.zh, ...PO3.zh, ...PO4.zh, ...PO5.zh, ...PO6.zh, ...PO7.zh, ...PO8.zh, ...PO9.zh, ...PO10.zh }, cgu: CGU.zh, cropper: CROP.zh } },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en", "es", "es_mx", "de", "it", "pl", "fil", "ru", "el", "hi", "ja", "zh"],
    detection: { order: ["querystring", "localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "bdc_lang", lookupQuerystring: "lang" },
    interpolation: { escapeValue: false },
  });

// Namespace saisonnier /toussaint (hub Toussaint & jour des morts) fusionné dans "translation".
["fr", "en", "es", "es_mx", "de", "it", "pl", "fil", "ru", "el", "hi", "ja", "zh"].forEach((l) => {
  const base = TSS[l] || TSS.fr;
  const off = TSSO[l] || TSSO.fr;
  const land = TSSL[l] || TSSL.fr;
  const cta = TSSC[l] || TSSC.fr;
  i18n.addResourceBundle(l, "translation", { tss: { ...base, ...off, ...land, ...cta } }, true, true);
});

// Synchronise l'attribut <html lang="..."> avec la langue active (SEO + accessibilité).
const HTML_LANG = { fr: "fr", en: "en", es: "es", es_mx: "es-MX", de: "de", it: "it", pl: "pl", fil: "fil", ru: "ru", el: "el", hi: "hi", ja: "ja", zh: "zh" };
const applyHtmlLang = (lng) => {
  document.documentElement.setAttribute("lang", HTML_LANG[lng] || (lng || "fr").split("-")[0]);
};
applyHtmlLang(i18n.language);
i18n.on("languageChanged", applyHtmlLang);

// Libellé "Partager cet article" localisé (namespace blog).
const BLOG_SHARE = {
  fr: "Partager cet article", en: "Share this article", es: "Compartir este artículo",
  es_mx: "Compartir este artículo", de: "Diesen Artikel teilen", it: "Condividi questo articolo",
  pl: "Udostępnij ten artykuł", fil: "Ibahagi ang artikulong ito", ru: "Поделиться этой статьёй",
  el: "Κοινοποίηση αυτού του άρθρου", hi: "इस लेख को साझा करें", ja: "この記事をシェア", zh: "分享这篇文章",
};
Object.entries(BLOG_SHARE).forEach(([l, v]) => {
  i18n.addResourceBundle(l, "translation", { blog: { shareArticle: v } }, true, true);
});

export default i18n;
